(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire08d4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire08d4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dSfL8", function(module, exports) {

$parcel$export(module.exports, "requestUserLocation", () => $a19c8af75d1fca99$export$8e377c10469248c2);
/**
 * Location
 *
 * Browser geolocation, centralized so multiple modules can share the
 * permission prompt and session cache. Pure browser-API wrapper — no
 * dependency on Mapbox or any other library.
 *
 * ── Public API ───────────────────────────────────────────────
 *   window.bruce.location.requestUserLocation()
 *     Always issues a fresh geolocation request. Resolves [lng, lat]
 *     on success, null on denial / timeout / unavailable. Updates the
 *     last-known cache on success.
 *
 *   window.bruce.location.getInitialUserLocation()
 *     Shared session-scoped promise. First call kicks off the request;
 *     subsequent calls reuse the same in-flight or settled promise.
 *     Use this to coordinate boot-time location reads across modules
 *     without double-prompting.
 *
 *   window.bruce.location.getLastKnown()
 *     Synchronous accessor. Returns the most recent successful coord,
 *     or null. Never triggers a prompt, never throws. A later failed
 *     request does NOT wipe a previously-cached success.
 *
 * Each function is also exported as an ES module named export.
 */ const $a19c8af75d1fca99$var$USER_LOCATION_TIMEOUT = 8000;
/** @type {[number, number] | null} */ let $a19c8af75d1fca99$var$lastKnown = null;
/** @type {Promise<[number, number] | null> | null} */ let $a19c8af75d1fca99$var$initialLocationPromise = null;
function $a19c8af75d1fca99$export$8e377c10469248c2() {
    return new Promise((resolve)=>{
        if (!navigator.geolocation) return resolve(null);
        let settled = false;
        const finish = (result)=>{
            if (settled) return;
            settled = true;
            if (result) $a19c8af75d1fca99$var$lastKnown = result;
            resolve(result);
        };
        const timer = setTimeout(()=>finish(null), $a19c8af75d1fca99$var$USER_LOCATION_TIMEOUT);
        navigator.geolocation.getCurrentPosition((pos)=>{
            clearTimeout(timer);
            finish([
                pos.coords.longitude,
                pos.coords.latitude
            ]);
        }, ()=>{
            clearTimeout(timer);
            finish(null);
        }, {
            timeout: $a19c8af75d1fca99$var$USER_LOCATION_TIMEOUT,
            maximumAge: 60000,
            enableHighAccuracy: false
        });
    });
}
function $a19c8af75d1fca99$export$9daf9be34faecae4() {
    if (!$a19c8af75d1fca99$var$initialLocationPromise) $a19c8af75d1fca99$var$initialLocationPromise = $a19c8af75d1fca99$export$8e377c10469248c2();
    return $a19c8af75d1fca99$var$initialLocationPromise;
}
function $a19c8af75d1fca99$export$aa2b107288f4c8f5() {
    return $a19c8af75d1fca99$var$lastKnown;
}
/** @type {any} */ window.bruce ||= {};
/** @type {any} */ window.bruce.location = {
    requestUserLocation: $a19c8af75d1fca99$export$8e377c10469248c2,
    getInitialUserLocation: $a19c8af75d1fca99$export$9daf9be34faecae4,
    getLastKnown: $a19c8af75d1fca99$export$aa2b107288f4c8f5
};

});

parcelRegister("fxPUT", function(module, exports) {

$parcel$export(module.exports, "directionsHref", () => $b512359f36887712$export$c9ffbdbd8b130ecc);
/**
 * Directions Links
 *
 * Upgrades any authored "Directions" link so it opens the visitor's most
 * likely map app (Apple Maps on iOS/macOS, Google Maps elsewhere, or a
 * provider the visitor explicitly chose). Works on any page, inside CMS
 * items, sliders and components — it's attribute-driven, not component-bound.
 *
 * Markup:
 *   <a href="https://www.google.com/maps/dir/?api=1&destination=55.6,13.0"
 *      data-directions
 *      data-directions-lat="55.6" data-directions-lng="13.0"
 *      data-directions-name="Bruce Malmö">Directions</a>
 *
 *   Author a real Google URL as the static href (bind CMS lat/lng into it) so
 *   the link is correct with JS off; this module only rewrites it.
 *
 * Optional per-link attributes:
 *   - data-directions-provider="apple|google|waze"  force a provider
 *   - data-directions-mode="place"                  open a pin on the location
 *                                                   instead of a route from
 *                                                   the visitor's position
 *
 * Optional chooser (any clickable element):
 *   <button data-directions-choose="apple">Apple Maps</button>
 *   Stores the choice in localStorage and re-upgrades every link on the page.
 *
 * Resolution order: per-link provider → stored choice → platform default.
 *
 * Links are upgraded on DOM ready and again whenever new [data-directions]
 * nodes are inserted (Finsweet re-renders, slider clones), via a
 * MutationObserver. The href *attribute* is set (not the .href property) so
 * middle-click, right-click and assistive tech see the final URL.
 */ 
var $bQkhO = parcelRequire("bQkhO");
const $b512359f36887712$var$LINK = "[data-directions]";
const $b512359f36887712$var$CHOOSER = "[data-directions-choose]";
const $b512359f36887712$var$STORAGE_KEY = "bruce:mapProvider";
function $b512359f36887712$var$readStoredProvider() {
    try {
        return localStorage.getItem($b512359f36887712$var$STORAGE_KEY);
    } catch  {
        return null;
    }
}
function $b512359f36887712$var$writeStoredProvider(provider) {
    try {
        if (provider) localStorage.setItem($b512359f36887712$var$STORAGE_KEY, provider);
        else localStorage.removeItem($b512359f36887712$var$STORAGE_KEY);
    } catch  {
    /* private mode / storage disabled — choice just won't persist */ }
}
function $b512359f36887712$export$c9ffbdbd8b130ecc(dest, { provider: provider, mode: mode } = {}) {
    const resolved = (0, $bQkhO.resolveProvider)({
        override: provider,
        stored: $b512359f36887712$var$readStoredProvider(),
        isApple: (0, $bQkhO.isApplePlatform)(navigator)
    });
    return (0, $bQkhO.buildDirectionsUrl)(resolved, dest, {
        mode: (0, $bQkhO.normalizeMode)(mode)
    });
}
function $b512359f36887712$export$8fd1976526b35e14(root = document) {
    root.querySelectorAll($b512359f36887712$var$LINK).forEach($b512359f36887712$var$upgradeLink);
}
function $b512359f36887712$var$upgradeLink(link) {
    const coords = (0, $bQkhO.parseCoords)(link.getAttribute("data-directions-lat"), link.getAttribute("data-directions-lng"));
    if (!coords) return;
    const name = link.getAttribute("data-directions-name") || undefined;
    const provider = link.getAttribute("data-directions-provider");
    const mode = link.getAttribute("data-directions-mode");
    link.setAttribute("href", $b512359f36887712$export$c9ffbdbd8b130ecc({
        ...coords,
        name: name
    }, {
        provider: provider,
        mode: mode
    }));
}
function $b512359f36887712$var$setupChooser() {
    document.addEventListener("click", (e)=>{
        const target = /** @type {Element | null} */ e.target;
        const el = target?.closest?.($b512359f36887712$var$CHOOSER);
        if (!el) return;
        const provider = (0, $bQkhO.normalizeProvider)(el.getAttribute("data-directions-choose"));
        $b512359f36887712$var$writeStoredProvider(provider);
        $b512359f36887712$export$8fd1976526b35e14();
        document.dispatchEvent(new CustomEvent("directions:provider", {
            detail: {
                provider: provider
            }
        }));
    });
}
function $b512359f36887712$var$observeInsertions() {
    if (typeof MutationObserver !== "function") return;
    const observer = new MutationObserver((mutations)=>{
        for (const m of mutations)for (const node of m.addedNodes){
            if (!(node instanceof Element)) continue;
            if (node.matches($b512359f36887712$var$LINK)) $b512359f36887712$var$upgradeLink(node);
            $b512359f36887712$export$8fd1976526b35e14(node);
        }
    });
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}
// studio.js is a separate Parcel entry that also imports this module, so on
// the studio page two bundles evaluate it. Init once per page.
const $b512359f36887712$var$INIT_FLAG = "__bruceDirectionsInit";
function $b512359f36887712$var$init() {
    if (window[$b512359f36887712$var$INIT_FLAG]) return;
    window[$b512359f36887712$var$INIT_FLAG] = true;
    $b512359f36887712$export$8fd1976526b35e14();
    $b512359f36887712$var$setupChooser();
    $b512359f36887712$var$observeInsertions();
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $b512359f36887712$var$init, {
    once: true
});
else $b512359f36887712$var$init();

});
parcelRegister("bQkhO", function(module, exports) {

$parcel$export(module.exports, "normalizeProvider", () => $89f4497c1f0fbbd7$export$b1276c07738d6325);
$parcel$export(module.exports, "resolveProvider", () => $89f4497c1f0fbbd7$export$15e3fc6f1916b634);
$parcel$export(module.exports, "isApplePlatform", () => $89f4497c1f0fbbd7$export$5775b3f9d1a43b3d);
$parcel$export(module.exports, "buildDirectionsUrl", () => $89f4497c1f0fbbd7$export$850bfafcd0246112);
$parcel$export(module.exports, "normalizeMode", () => $89f4497c1f0fbbd7$export$6926ae187ee400be);
$parcel$export(module.exports, "parseCoords", () => $89f4497c1f0fbbd7$export$93ac7bc215bb896c);
/**
 * Directions URL — pure helpers for directions.js (and studio.js)
 *
 * Framework-free (no DOM, no imports) so the provider-resolution + URL-building
 * logic is unit-testable in Node. The DOM shell lives in directions.js. (Same
 * split as membership-pricing-format.js ↔ membership-pricing.js.)
 *
 * Browsers expose no "preferred map app" — the best available signal is the
 * platform (Apple devices ship Apple Maps; everything else defaults to Google
 * Maps), optionally overridden by an explicit per-link provider or a choice the
 * user made earlier that we stored.
 */ const $89f4497c1f0fbbd7$export$b35c40687956bf9e = [
    "apple",
    "google",
    "waze"
];
function $89f4497c1f0fbbd7$export$b1276c07738d6325(value) {
    const v = (value || "").trim().toLowerCase();
    return $89f4497c1f0fbbd7$export$b35c40687956bf9e.includes(v) ? /** @type {any} */ v : null;
}
function $89f4497c1f0fbbd7$export$15e3fc6f1916b634({ override: override, stored: stored, isApple: isApple }) {
    return $89f4497c1f0fbbd7$export$b1276c07738d6325(override) || $89f4497c1f0fbbd7$export$b1276c07738d6325(stored) || (isApple ? "apple" : "google");
}
function $89f4497c1f0fbbd7$export$5775b3f9d1a43b3d(nav) {
    const platform = nav?.userAgentData?.platform;
    if (platform) {
        const p = platform.toLowerCase();
        return p === "macos" || p === "ios";
    }
    return /iPhone|iPad|iPod|Macintosh|Mac OS X/.test(nav?.userAgent || "");
}
function $89f4497c1f0fbbd7$export$850bfafcd0246112(provider, { lat: lat, lng: lng, name: name }, { mode: mode = "directions" } = {}) {
    const ll = `${lat},${lng}`;
    const place = mode === "place";
    switch(provider){
        case "apple":
            {
                const params = place ? new URLSearchParams({
                    ll: ll
                }) : new URLSearchParams({
                    daddr: ll,
                    dirflg: "d"
                });
                if (name) params.set("q", name);
                return `https://maps.apple.com/?${params}`;
            }
        case "waze":
            {
                const params = new URLSearchParams({
                    ll: ll
                });
                if (!place) params.set("navigate", "yes");
                return `https://waze.com/ul?${params}`;
            }
        default:
            {
                if (place) {
                    const params = new URLSearchParams({
                        api: "1",
                        query: ll
                    });
                    return `https://www.google.com/maps/search/?${params}`;
                }
                const params = new URLSearchParams({
                    api: "1",
                    destination: ll
                });
                return `https://www.google.com/maps/dir/?${params}`;
            }
    }
}
function $89f4497c1f0fbbd7$export$6926ae187ee400be(value) {
    return (value || "").trim().toLowerCase() === "place" ? "place" : "directions";
}
function $89f4497c1f0fbbd7$export$93ac7bc215bb896c(lat, lng) {
    const la = parseFloat(lat ?? "");
    const ln = parseFloat(lng ?? "");
    if (!Number.isFinite(la) || !Number.isFinite(ln)) return null;
    return {
        lat: la,
        lng: ln
    };
}

});


parcelRegister("77YEB", function(module, exports) {

$parcel$export(module.exports, "extractOne", () => $53083c770f43127f$export$6641b8764fb21421);
$parcel$export(module.exports, "extractFeatures", () => $53083c770f43127f$export$f99603a087f5ed5);
$parcel$export(module.exports, "cloneTemplate", () => $53083c770f43127f$export$ab8f051e2ff626fb);
$parcel$export(module.exports, "createMapRenderer", () => $53083c770f43127f$export$2f38820ed14bdd85);
// Shared Mapbox render engine — the marker/popup/cluster/camera layer common to
// every map on the site. Extracted verbatim from explorer.js so a second
// component can render the same CMS-authored pins without dragging along the
// explorer's Finsweet list, bottom-sheet and filter chrome.
//
// The split: THIS module owns the map instance, the feature extraction, the
// point + cluster markers, the popups and the camera. The CALLER owns its own
// chrome and injects the four things that differ per surface — where the camera
// centers (`getCenter`), how much of the canvas is covered by an overlay
// (`getBottomPad`), what to do when the user pans (`onUserMove`) and what to run
// once the first render has landed (`onReady`).
//
// Because the explorer keeps features the shared layer knows nothing about
// (geolocation markers, "search this area"), the renderer deliberately exposes
// its raw `map` and `mapboxgl` handles. That is a leak, but the alternative is
// pulling explorer-only behaviour into shared code.
//
// Markup contract (per CMS item, unchanged from the explorer):
//   [data-explorer-field="studio-lat"]   textContent → latitude
//   [data-explorer-field="studio-lng"]   textContent → longitude
//   [data-explorer-field="studio-id"]    textContent → stable marker key
//   [data-explorer-element="studio-marker"]  cloned as the map marker
//   [data-explorer-element="studio-popup"]   cloned as the popup body

var $jC8QR = parcelRequire("jC8QR");
const $53083c770f43127f$var$S = {
    lat: '[data-explorer-field="studio-lat"]',
    lng: '[data-explorer-field="studio-lng"]',
    id: '[data-explorer-field="studio-id"]',
    marker: '[data-explorer-element="studio-marker"]',
    popup: '[data-explorer-element="studio-popup"]',
    count: '[data-explorer-field="count"]'
};
const $53083c770f43127f$export$f8f652967c07da69 = [
    10.7522,
    59.9139
];
const $53083c770f43127f$var$DEFAULT_ZOOM = 11;
const $53083c770f43127f$var$CITY_ZOOM = 11;
const $53083c770f43127f$var$SINGLE_FEATURE_ZOOM = 13;
const $53083c770f43127f$var$FIT_BOUNDS_CONFIG = {
    duration: 500,
    maxZoom: 14,
    padding: 48
};
const $53083c770f43127f$var$MARKER_FADE_DURATION = 250;
const $53083c770f43127f$var$POPUP_CLASS = "explorer-popup";
// Supercluster is the only extra CDN dep beyond mapbox-gl and is fetched only
// by callers that actually cluster — kept out of the Webflow <head> so neither
// blocks first paint.
const $53083c770f43127f$var$SUPERCLUSTER_JS_URL = "https://unpkg.com/supercluster@8.0.0/dist/supercluster.min.js";
// minPoints 6 → fewer than 6 nearby points stay as individual studio markers
// rather than collapsing into a cluster bubble.
const $53083c770f43127f$var$CLUSTER_CONFIG = {
    radius: 50,
    maxZoom: 14,
    minPoints: 6
};
// Extra zoom beyond supercluster's expansionZoom so a cluster click lands a
// touch past the break-apart point (avoids re-clustering into one bubble).
const $53083c770f43127f$var$CLUSTER_EXPANSION_PADDING = 0.5;
// ── Feature extraction ───────────────────────────────────────
// CMS values are immutable post-render, so parsing each item once is safe; the
// WeakMap auto-GCs when items leave the DOM.
const $53083c770f43127f$var$featureCache = new WeakMap();
function $53083c770f43127f$export$6641b8764fb21421(el) {
    if ($53083c770f43127f$var$featureCache.has(el)) return $53083c770f43127f$var$featureCache.get(el);
    const latEl = el.querySelector($53083c770f43127f$var$S.lat);
    const lngEl = el.querySelector($53083c770f43127f$var$S.lng);
    const markerEl = el.querySelector($53083c770f43127f$var$S.marker);
    if (!latEl || !lngEl || !markerEl) {
        $53083c770f43127f$var$featureCache.set(el, null);
        return null;
    }
    const lat = parseFloat(latEl.textContent);
    const lng = parseFloat(lngEl.textContent);
    // 0,0 is the CMS "no coordinates" sentinel (Gulf of Guinea) — skip it so a
    // studio without a location doesn't drop a marker off the African coast.
    if (Number.isNaN(lat) || Number.isNaN(lng) || lat === 0 && lng === 0) {
        $53083c770f43127f$var$featureCache.set(el, null);
        return null;
    }
    const idEl = el.querySelector($53083c770f43127f$var$S.id);
    const feature = {
        coordinates: [
            lng,
            lat
        ],
        id: idEl ? idEl.textContent.trim() : "",
        markerEl: markerEl,
        popupEl: el.querySelector($53083c770f43127f$var$S.popup)
    };
    $53083c770f43127f$var$featureCache.set(el, feature);
    return feature;
}
let $53083c770f43127f$var$hasWarnedAboutSkipped = false;
function $53083c770f43127f$export$f99603a087f5ed5(elements) {
    const features = [];
    let skipped = 0;
    elements.forEach((el)=>{
        const one = $53083c770f43127f$export$6641b8764fb21421(el);
        if (one) features.push(one);
        else skipped++;
    });
    if (skipped && !$53083c770f43127f$var$hasWarnedAboutSkipped) {
        $53083c770f43127f$var$hasWarnedAboutSkipped = true;
        console.warn(`[map] Mapped ${features.length} / ${elements.length} items. Skipped ${skipped} with missing/invalid ${$53083c770f43127f$var$S.lat} / ${$53083c770f43127f$var$S.lng} / ${$53083c770f43127f$var$S.marker} (or 0,0 coords). Logged once per session.`);
    }
    return features;
}
function $53083c770f43127f$export$ab8f051e2ff626fb(sourceEl) {
    if (!sourceEl) return null;
    const clone = sourceEl.cloneNode(true);
    if (clone instanceof HTMLElement) {
        clone.style.display = "";
        if (clone.id) clone.removeAttribute("id");
        clone.querySelectorAll("[id]").forEach((n)=>n.removeAttribute("id"));
        for (const hook of [
            "data-explorer-element",
            "data-map-element"
        ]){
            clone.removeAttribute(hook);
            clone.querySelectorAll(`[${hook}]`).forEach((n)=>n.removeAttribute(hook));
        }
    }
    return clone;
}
function $53083c770f43127f$export$8bf9c1934890dd1(feature) {
    return feature.id || feature.coordinates.join(",");
}
function $53083c770f43127f$export$2c4a36e055486d20(count) {
    if (count < 10) return "sm";
    if (count < 50) return "md";
    if (count < 200) return "lg";
    return "xl";
}
function $53083c770f43127f$var$applyClusterMeta(el, count, countSelector) {
    if (!(el instanceof HTMLElement)) return;
    el.dataset.size = $53083c770f43127f$export$2c4a36e055486d20(count);
    const slot = countSelector ? el.querySelector(countSelector) : null;
    if (slot) slot.textContent = String(count);
}
// Supercluster loads at most once per session, memoised independently of
// mapbox-gl so a non-clustering caller can skip it entirely.
let $53083c770f43127f$var$superclusterPromise = null;
function $53083c770f43127f$var$loadSupercluster() {
    if ($53083c770f43127f$var$superclusterPromise) return $53083c770f43127f$var$superclusterPromise;
    $53083c770f43127f$var$superclusterPromise = window.Supercluster ? Promise.resolve() : (0, $jC8QR.loadScriptOnce)($53083c770f43127f$var$SUPERCLUSTER_JS_URL);
    return $53083c770f43127f$var$superclusterPromise;
}
function $53083c770f43127f$export$2f38820ed14bdd85({ targetEl: targetEl, getFeatures: getFeatures, clusterTemplateEl: clusterTemplateEl = null, getCenter: getCenter = ()=>null, getBottomPad: getBottomPad = ()=>0, onUserMove: onUserMove = ()=>{}, onReady: onReady = ()=>{} } = {}) {
    // Clustering is opt-in, decided by the markup: a caller that authored no
    // cluster bubble gets individual point markers and never pays the
    // supercluster fetch.
    const clustering = Boolean(clusterTemplateEl);
    let mapboxgl = null;
    let Supercluster = null;
    let map = null;
    let mapLoaded = false;
    let mapInitStarted = false;
    let lastSignature = null;
    let clusterIndex = null;
    // Memoised viewport key (bbox + zoom) — skips re-clustering when neither moved.
    let lastRenderKey = null;
    let activePopup = null;
    // Reused across renders so Mapbox can `setLngLat` markers (smooth) and CSS
    // transitions animate on the same element instead of recreating nodes.
    const pointMarkers = new Map(); // pointKey -> { marker, feature }
    const clusterMarkers = new Map(); // cluster_id -> { marker, clusterId, coords }
    // Camera padding that keeps a fly-to's focal point in the strip ABOVE any
    // overlay the caller reports.
    function bottomPad() {
        return {
            top: 0,
            right: 0,
            left: 0,
            bottom: getBottomPad()
        };
    }
    function closePopup() {
        if (activePopup) {
            activePopup.remove();
            activePopup = null;
        }
    }
    function openPopup(feature) {
        closePopup();
        const content = $53083c770f43127f$export$ab8f051e2ff626fb(feature.popupEl);
        if (!content) return;
        activePopup = new mapboxgl.Popup({
            className: $53083c770f43127f$var$POPUP_CLASS,
            closeButton: false,
            closeOnClick: true,
            maxWidth: "none"
        }).setLngLat(feature.coordinates).setDOMContent(content).addTo(map);
        activePopup.on("close", ()=>{
            activePopup = null;
        });
    }
    // Mounts a DOM element as a Mapbox marker, fades it in, and wires a click.
    function attachMarker(el, coords, onClick) {
        const marker = new mapboxgl.Marker({
            element: el,
            anchor: "center"
        }).setLngLat(coords).addTo(map);
        // Opacity-only fade; animating transform would fight Mapbox's per-frame
        // marker positioning during pan/zoom.
        el.animate([
            {
                opacity: 0
            },
            {
                opacity: 1
            }
        ], {
            duration: $53083c770f43127f$var$MARKER_FADE_DURATION,
            easing: "ease-out"
        });
        el.addEventListener("click", (e)=>{
            e.stopPropagation();
            onClick();
        });
        return marker;
    }
    function addPointMarker(feature) {
        const el = $53083c770f43127f$export$ab8f051e2ff626fb(feature.markerEl);
        if (!el) return;
        const entry = {
            feature: feature
        };
        entry.marker = attachMarker(el, feature.coordinates, ()=>{
            openPopup(entry.feature);
            map.flyTo({
                center: entry.feature.coordinates,
                speed: 0.6,
                padding: bottomPad()
            });
        });
        pointMarkers.set($53083c770f43127f$export$8bf9c1934890dd1(feature), entry);
    }
    // A cluster bubble. Clicking zooms to the point where supercluster breaks the
    // cluster apart (+ padding), so the studios underneath become visible.
    function addClusterMarker(cluster) {
        const el = $53083c770f43127f$export$ab8f051e2ff626fb(clusterTemplateEl);
        if (!el) return;
        $53083c770f43127f$var$applyClusterMeta(el, cluster.properties.point_count, $53083c770f43127f$var$S.count);
        const entry = {
            clusterId: cluster.properties.cluster_id,
            coords: cluster.geometry.coordinates
        };
        entry.marker = attachMarker(el, entry.coords, ()=>{
            const expansionZoom = clusterIndex.getClusterExpansionZoom(entry.clusterId);
            map.flyTo({
                center: entry.coords,
                zoom: expansionZoom + $53083c770f43127f$var$CLUSTER_EXPANSION_PADDING,
                duration: $53083c770f43127f$var$FIT_BOUNDS_CONFIG.duration,
                padding: bottomPad()
            });
        });
        clusterMarkers.set(entry.clusterId, entry);
    }
    function clearMarkers() {
        clusterMarkers.forEach((e)=>e.marker.remove());
        clusterMarkers.clear();
        pointMarkers.forEach((e)=>e.marker.remove());
        pointMarkers.clear();
    }
    function fitToFeatures(features) {
        if (!map) return;
        const cov = getBottomPad();
        const pad = {
            top: $53083c770f43127f$var$FIT_BOUNDS_CONFIG.padding,
            right: $53083c770f43127f$var$FIT_BOUNDS_CONFIG.padding,
            left: $53083c770f43127f$var$FIT_BOUNDS_CONFIG.padding,
            bottom: $53083c770f43127f$var$FIT_BOUNDS_CONFIG.padding + cov
        };
        const pts = features.map((f)=>f.coordinates);
        if (pts.length === 0) {
            const c = getCenter();
            if (c) map.flyTo({
                center: c,
                zoom: $53083c770f43127f$var$CITY_ZOOM,
                duration: $53083c770f43127f$var$FIT_BOUNDS_CONFIG.duration,
                padding: bottomPad()
            });
            return;
        }
        if (pts.length === 1) {
            map.flyTo({
                center: pts[0],
                zoom: $53083c770f43127f$var$SINGLE_FEATURE_ZOOM,
                duration: $53083c770f43127f$var$FIT_BOUNDS_CONFIG.duration,
                padding: bottomPad()
            });
            return;
        }
        const bounds = pts.reduce((b, c)=>b.extend(c), new mapboxgl.LngLatBounds());
        map.fitBounds(bounds, {
            padding: pad,
            maxZoom: $53083c770f43127f$var$FIT_BOUNDS_CONFIG.maxZoom,
            duration: $53083c770f43127f$var$FIT_BOUNDS_CONFIG.duration
        });
    }
    // (Re)builds the supercluster index from the current feature set. Clearing
    // the markers here is required: cluster_ids are regenerated per index, so
    // reusing stale clusters would wire markers to ids that no longer exist.
    function rebuildIndex(features) {
        if (features.length === 0) // Supercluster.load() throws on an empty array, which would reject the
        // caller; represent "nothing to cluster" as a null index instead.
        clusterIndex = null;
        else clusterIndex = new Supercluster($53083c770f43127f$var$CLUSTER_CONFIG).load(features.map((f)=>({
                type: "Feature",
                geometry: {
                    type: "Point",
                    coordinates: f.coordinates
                },
                properties: {
                    feature: f
                }
            })));
        lastRenderKey = null;
        clearMarkers();
    }
    // Renders the clusters + points for the current viewport, upserting markers
    // (move, don't recreate) and pruning any that left the view. Cheap to call on
    // every moveend — the bbox+zoom key short-circuits when nothing changed.
    function renderClusters() {
        if (!mapLoaded || !clusterIndex) return;
        const bbox = map.getBounds().toArray().flat();
        const zoom = Math.floor(map.getZoom());
        // Round bbox to ~11m so float jitter from programmatic camera ops doesn't
        // bust the cache.
        const renderKey = `${bbox.map((n)=>n.toFixed(4)).join(",")}|${zoom}`;
        if (renderKey === lastRenderKey) return;
        lastRenderKey = renderKey;
        const seenClusters = new Set();
        const seenPoints = new Set();
        clusterIndex.getClusters(bbox, zoom).forEach((item)=>{
            if (item.properties.cluster) {
                const id = item.properties.cluster_id;
                seenClusters.add(id);
                const existing = clusterMarkers.get(id);
                if (existing) {
                    existing.marker.setLngLat(item.geometry.coordinates);
                    existing.coords = item.geometry.coordinates;
                    $53083c770f43127f$var$applyClusterMeta(existing.marker.getElement(), item.properties.point_count, $53083c770f43127f$var$S.count);
                } else addClusterMarker(item);
            } else {
                const feature = item.properties.feature;
                const id = $53083c770f43127f$export$8bf9c1934890dd1(feature);
                seenPoints.add(id);
                const existing = pointMarkers.get(id);
                if (existing) {
                    existing.marker.setLngLat(feature.coordinates);
                    existing.feature = feature;
                } else addPointMarker(feature);
            }
        });
        clusterMarkers.forEach((entry, id)=>{
            if (seenClusters.has(id)) return;
            entry.marker.remove();
            clusterMarkers.delete(id);
        });
        pointMarkers.forEach((entry, id)=>{
            if (seenPoints.has(id)) return;
            entry.marker.remove();
            pointMarkers.delete(id);
        });
    }
    // The points-only counterpart to renderClusters: every feature is a marker,
    // regardless of viewport, upserted so re-renders move markers instead of
    // recreating them.
    function renderPoints(features) {
        const seen = new Set();
        features.forEach((feature)=>{
            const id = $53083c770f43127f$export$8bf9c1934890dd1(feature);
            seen.add(id);
            const existing = pointMarkers.get(id);
            if (existing) {
                existing.marker.setLngLat(feature.coordinates);
                existing.feature = feature;
            } else addPointMarker(feature);
        });
        pointMarkers.forEach((entry, id)=>{
            if (seen.has(id)) return;
            entry.marker.remove();
            pointMarkers.delete(id);
        });
    }
    // Rebuilds the index + reframes the camera only when the feature set actually
    // changed (so a pagination click, which re-fires afterRender with the same
    // set, never yanks the view). Viewport-only changes go through renderClusters.
    function render(features, { fit: fit = false } = {}) {
        if (!mapLoaded || !map) return;
        const signature = features.map($53083c770f43127f$export$8bf9c1934890dd1).join("|");
        const changed = signature !== lastSignature;
        if (!changed) return;
        lastSignature = signature;
        closePopup();
        if (clustering) {
            rebuildIndex(features);
            renderClusters();
        } else renderPoints(features);
        if (fit) fitToFeatures(features);
    }
    // Lazily build the map on first call: load the CDN libs, create the map on the
    // caller's center, then render whatever features are loaded. Runs at most
    // once. The container must be visible by now so Mapbox sizes its canvas.
    function ensureMap() {
        if (mapInitStarted || !targetEl) return;
        mapInitStarted = true;
        Promise.all([
            (0, $jC8QR.loadMapboxGl)(),
            clustering ? $53083c770f43127f$var$loadSupercluster() : null
        ]).then(([gl])=>{
            mapboxgl = gl;
            if (clustering) Supercluster = window.Supercluster;
            map = new mapboxgl.Map({
                container: targetEl,
                style: (0, $jC8QR.MAPBOX_STYLE),
                projection: "globe",
                center: getCenter() || $53083c770f43127f$export$f8f652967c07da69,
                zoom: $53083c770f43127f$var$DEFAULT_ZOOM,
                attributionControl: false
            });
            map.addControl(new mapboxgl.AttributionControl({
                compact: true
            }));
            // The container can be toggled (display:none ↔ visible) and reflow
            // between layouts; keep the canvas sized to it.
            new ResizeObserver(()=>map && map.resize()).observe(targetEl);
            map.on("load", ()=>{
                mapLoaded = true;
                render(getFeatures(), {
                    fit: true
                });
                // AFTER the render: onReady may run its own camera move (the explorer
                // flushes a pending geolocation fly-to here) and must win over the
                // fit above, exactly as it did when this lived inline.
                onReady();
            });
            // Re-cluster as the user pans / zooms. `originalEvent` is only present
            // on user-driven moves (pan/pinch/wheel) — programmatic flyTo/fitBounds
            // don't carry it — so callers only see real interaction.
            // Only a clustered map re-renders on move — a points-only map already
            // has every marker down, so panning changes nothing.
            map.on("moveend", (e)=>{
                if (clustering) renderClusters();
                if (e.originalEvent) onUserMove();
            });
        }).catch((err)=>console.error("[map] map failed to load", err));
    }
    return {
        ensureMap: ensureMap,
        render: render,
        closePopup: closePopup,
        isLoaded: ()=>mapLoaded,
        get map () {
            return map;
        },
        get mapboxgl () {
            return mapboxgl;
        }
    };
}

});
parcelRegister("jC8QR", function(module, exports) {

$parcel$export(module.exports, "MAPBOX_STYLE", () => $e4786eabed2e68b3$export$968062a7427b447c);
$parcel$export(module.exports, "loadScriptOnce", () => $e4786eabed2e68b3$export$d44d937b91eda530);
$parcel$export(module.exports, "loadMapboxGl", () => $e4786eabed2e68b3$export$1d1707c1ad510e57);
$parcel$export(module.exports, "whenIdle", () => $e4786eabed2e68b3$export$4d9952dcbf5b2792);
// Shared Mapbox GL loader — used by both explorer.js (per-city list/map page)
// and studio.js (single studio template page). Mapbox GL is loaded LAZILY from the
// CDN on first call; it must NOT be added as a blocking <script> in the Webflow
// <head>, or the ~460 KB + eval lands back on the critical path.
//
// Supercluster is intentionally NOT loaded here — only the list page clusters,
// so it loads supercluster separately alongside loadMapboxGl().
const $e4786eabed2e68b3$export$3120cc2ed1152f2f = "pk.eyJ1IjoibmlrbGFzaGFuc3NvbiIsImEiOiJjbWxleHI0MngxaHU3M2dzOWZrMXJpMjJlIn0.yvXc8nLFEuUocjlwqNZiJQ";
const $e4786eabed2e68b3$export$968062a7427b447c = "mapbox://styles/niklashansson/cmlextxil004n01r3d9gq7uzj";
const $e4786eabed2e68b3$export$fbd1063a36bc1ec3 = "https://api.mapbox.com/mapbox-gl-js/v3.21.0/mapbox-gl.js";
const $e4786eabed2e68b3$export$b7d072d0741a29b3 = "https://api.mapbox.com/mapbox-gl-js/v3.21.0/mapbox-gl.css";
function $e4786eabed2e68b3$export$d44d937b91eda530(src) {
    return new Promise((resolve, reject)=>{
        const existing = document.querySelector(`script[src="${src}"]`);
        if (existing) {
            if (existing.dataset.loaded === "true") return resolve();
            existing.addEventListener("load", ()=>resolve(), {
                once: true
            });
            existing.addEventListener("error", reject, {
                once: true
            });
            return;
        }
        const script = document.createElement("script");
        script.src = src;
        script.async = true;
        script.addEventListener("load", ()=>{
            script.dataset.loaded = "true";
            resolve();
        }, {
            once: true
        });
        script.addEventListener("error", reject, {
            once: true
        });
        document.head.appendChild(script);
    });
}
function $e4786eabed2e68b3$export$9711875b861d5092(href) {
    if (document.querySelector(`link[href="${href}"]`)) return;
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    document.head.appendChild(link);
}
// Loads mapbox-gl (+ its CSS) on first call and caches the promise so every
// caller awaits the same single load. Sets the access token once ready and
// resolves with the global `mapboxgl`.
let $e4786eabed2e68b3$var$mapboxGlPromise = null;
function $e4786eabed2e68b3$export$1d1707c1ad510e57() {
    if ($e4786eabed2e68b3$var$mapboxGlPromise) return $e4786eabed2e68b3$var$mapboxGlPromise;
    $e4786eabed2e68b3$var$mapboxGlPromise = (async ()=>{
        $e4786eabed2e68b3$export$9711875b861d5092($e4786eabed2e68b3$export$b7d072d0741a29b3);
        if (!window.mapboxgl) await $e4786eabed2e68b3$export$d44d937b91eda530($e4786eabed2e68b3$export$fbd1063a36bc1ec3);
        const mapboxgl = window.mapboxgl;
        if (!mapboxgl) throw new Error("[mapbox] mapbox-gl failed to load from the CDN.");
        mapboxgl.accessToken = $e4786eabed2e68b3$export$3120cc2ed1152f2f;
        return mapboxgl;
    })();
    return $e4786eabed2e68b3$var$mapboxGlPromise;
}
function $e4786eabed2e68b3$export$4d9952dcbf5b2792(cb) {
    if (typeof requestIdleCallback === "function") requestIdleCallback(cb, {
        timeout: 2000
    });
    else setTimeout(cb, 200);
}

});


/**
 * Nav Component
 *
 * Two independent nav behaviors:
 *   1. Skip-to-main link — focuses <main> for accessibility
 *   2. Scroll state — adds is-scroll-top / is-scroll-up / is-scroll-down
 *      classes based on direction, with a distance threshold
 *      to prevent flicker from jitter. Opt-in per component via
 *      data-hide-on-scroll.
 *
 * Usage in Webflow:
 *   <div class="nav_component">
 *     <a class="nav_skip_wrap" href="#main">Skip to content</a>
 *   </div>
 *   <main>...</main>
 *
 * Enable scroll state on a nav:
 *   <div class="nav_component" data-hide-on-scroll>
 *
 * Optional per-component threshold override:
 *   <div class="nav_component" data-hide-on-scroll data-scroll-threshold="20">
 *
 *
 */ /**
 * Shared utilities for Webflow custom-script components.
 *
 * Centralized here so behavioral fixes (e.g. how to detect a
 * Finsweet-managed list, what counts as a truthy Webflow attribute)
 * stay consistent across all components.
 */ // Marks a list that Finsweet's `fs-list` owns. The CMS-flatten helpers must
// NOT mutate such lists: Finsweet enumerates the collection from this live
// DOM, so deleting its nodes corrupts pagination/filtering (e.g. an
// `fs-list-nest` accordion, or any list sharing a page with a results list).
const $e1f0b8fa1ae2171c$export$c35657657d74f55f = "[fs-list-element], [fs-list-nest], [fs-list-instance]";
function $e1f0b8fa1ae2171c$export$df345a2880184520(el, attr, defaultValue = false) {
    const v = el.getAttribute(attr);
    if (v === null) return defaultValue;
    return v === "True" || v === "true";
}
function $e1f0b8fa1ae2171c$export$a802fe75dee3ccae(el, attr, defaultValue) {
    const v = parseFloat(el.getAttribute(attr) || "");
    return Number.isFinite(v) ? v : defaultValue;
}
function $e1f0b8fa1ae2171c$export$abb8b833bfa7c79(slot) {
    if (!slot) return;
    let child = slot.firstElementChild;
    while(child && child.classList.contains("u-display-contents")){
        const isCMSList = child.classList.contains("w-dyn-list");
        const hasFinsweet = child.hasAttribute("fs-list-element") || child.querySelector($e1f0b8fa1ae2171c$export$c35657657d74f55f);
        if (isCMSList || hasFinsweet) break;
        while(child.firstChild)slot.insertBefore(child.firstChild, child);
        slot.removeChild(child);
        child = slot.firstElementChild;
    }
}
function $e1f0b8fa1ae2171c$export$20a158e904f6d53d(slot) {
    if (!slot) return;
    const dynList = Array.from(slot.children).find((child)=>child.classList.contains("w-dyn-list"));
    if (!dynList) return;
    const dynListIsFinsweet = dynList.hasAttribute("fs-list-element") || dynList.querySelector($e1f0b8fa1ae2171c$export$c35657657d74f55f);
    if (dynListIsFinsweet) return;
    const nestedItems = dynList.querySelector(".w-dyn-items")?.children;
    if (!nestedItems) return;
    const staticWrapper = [
        ...slot.children
    ];
    [
        ...nestedItems
    ].forEach((el)=>{
        const c = [
            ...el.children
        ].find((child)=>!child.classList.contains("w-condition-invisible"));
        if (c) slot.appendChild(c);
    });
    staticWrapper.forEach((el)=>el.remove());
}


// ── Module-level constants ───────────────────────────────────
const $c08bc1a7592051c6$var$SCROLL_TRIGGER_THRESHOLD = 100;
const $c08bc1a7592051c6$var$DEFAULT_DIRECTION_THRESHOLD = 16; // px to scroll before flipping direction
// ── Skip link ────────────────────────────────────────────────
function $c08bc1a7592051c6$var$initSkipLink() {
    const target = document.querySelector("main");
    if (!target) return;
    document.querySelectorAll(".nav_skip_wrap").forEach((link)=>{
        const el = /** @type {HTMLElement} */ link;
        if (el.dataset.scriptInitialized) return;
        el.dataset.scriptInitialized = "true";
        link.addEventListener("click", ()=>{
            // tabindex=-1 makes <main> programmatically focusable without
            // adding it to the natural tab order
            target.setAttribute("tabindex", "-1");
            /** @type {HTMLElement} */ target.focus();
            // Clean up after focus moves away so the DOM isn't permanently mutated
            target.addEventListener("blur", ()=>target.removeAttribute("tabindex"), {
                once: true
            });
        });
    });
}
// ── Scroll state ─────────────────────────────────────────────
function $c08bc1a7592051c6$var$initScrollState() {
    const components = document.querySelectorAll(".nav_component[data-hide-on-scroll]");
    if (!components.length) return;
    // Initial state based on current scroll position
    const initialAtTop = window.scrollY <= $c08bc1a7592051c6$var$SCROLL_TRIGGER_THRESHOLD;
    components.forEach((c)=>{
        c.classList.add(initialAtTop ? "is-scroll-top" : "is-scroll-down");
    });
    // ── Per-component state ────────────────────────────────
    /** @typedef {{ el: HTMLElement, threshold: number, committed: -1 | 0 | 1, pivotY: number }} NavState */ /** @type {NavState[]} */ const states = [];
    components.forEach((component)=>{
        const el = /** @type {HTMLElement} */ component;
        if (el.dataset.scriptInitialized) return;
        el.dataset.scriptInitialized = "true";
        states.push({
            el: el,
            threshold: (0, $e1f0b8fa1ae2171c$export$a802fe75dee3ccae)(el, "data-scroll-threshold", $c08bc1a7592051c6$var$DEFAULT_DIRECTION_THRESHOLD),
            committed: initialAtTop ? 0 : 1,
            pivotY: window.scrollY
        });
    });
    if (!states.length) return;
    // ── Shared scroll handler (one listener for all nav components) ──
    let ticking = false;
    const update = ()=>{
        ticking = false;
        const currentY = window.scrollY;
        for (const state of states){
            // Top-of-page: above the trigger threshold → enforce is-scroll-top
            if (currentY <= $c08bc1a7592051c6$var$SCROLL_TRIGGER_THRESHOLD) {
                if (state.committed !== 0) {
                    state.el.classList.remove("is-scroll-up", "is-scroll-down");
                    state.el.classList.add("is-scroll-top");
                    state.committed = 0;
                    state.pivotY = currentY;
                }
                continue;
            }
            // Past trigger point — measure delta against pivot
            const delta = currentY - state.pivotY;
            if (Math.abs(delta) < state.threshold) continue;
            const newDirection = delta > 0 ? 1 : -1;
            if (newDirection !== state.committed) {
                state.committed = newDirection;
                state.el.classList.toggle("is-scroll-up", newDirection === -1);
                state.el.classList.toggle("is-scroll-down", newDirection === 1);
                state.el.classList.remove("is-scroll-top");
            }
            state.pivotY = currentY;
        }
    };
    // rAF-throttled scroll listener — one rAF call per frame max,
    // regardless of how many scroll events fire
    const onScroll = ()=>{
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
    };
    window.addEventListener("scroll", onScroll, {
        passive: true
    });
}
function $c08bc1a7592051c6$export$240cd81d1fa164a8() {
    $c08bc1a7592051c6$var$initSkipLink();
    $c08bc1a7592051c6$var$initScrollState();
}
// ── Auto-boot ────────────────────────────────────────────────
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $c08bc1a7592051c6$export$240cd81d1fa164a8, {
    once: true
});
else $c08bc1a7592051c6$export$240cd81d1fa164a8();


/**
 * Per-slug session-scoped dismissal for CMS announcement items.
 * Marks dismissed items with `data-announcement-dismissed`; project CSS
 * owns visibility and any parent collapse (e.g. via `:has()`).
 */ const $4290c5a650800a1a$var$DISMISSED_STORAGE_KEY = "dismissed-announcements";
const $4290c5a650800a1a$var$ANNOUNCEMENT_SLUG_ATTR = "data-announcement-slug";
const $4290c5a650800a1a$var$DISMISSED_ATTR = "data-announcement-dismissed";
const $4290c5a650800a1a$var$ITEM_SELECTOR = '[data-announcement-element="item"]';
const $4290c5a650800a1a$var$DISMISS_SELECTOR = '[data-announcement-element="dismiss"]';
/** @returns {Set<string>} */ function $4290c5a650800a1a$var$readDismissedSlugs() {
    try {
        const raw = sessionStorage.getItem($4290c5a650800a1a$var$DISMISSED_STORAGE_KEY);
        if (!raw) return new Set();
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? new Set(parsed.filter((s)=>typeof s === "string")) : new Set();
    } catch (_) {
        return new Set();
    }
}
/** @param {Set<string>} set */ function $4290c5a650800a1a$var$writeDismissedSlugs(set) {
    try {
        sessionStorage.setItem($4290c5a650800a1a$var$DISMISSED_STORAGE_KEY, JSON.stringify([
            ...set
        ]));
    } catch (_) {
    /* storage blocked — dismissal still applies for this page view */ }
}
const $4290c5a650800a1a$var$dismissedSlugs = $4290c5a650800a1a$var$readDismissedSlugs();
// Must run before DOM paint so dismissed items never flash.
(function injectDismissedHideStyles() {
    if (!$4290c5a650800a1a$var$dismissedSlugs.size) return;
    const rules = [
        ...$4290c5a650800a1a$var$dismissedSlugs
    ].map((slug)=>`[${$4290c5a650800a1a$var$ANNOUNCEMENT_SLUG_ATTR}="${CSS.escape(slug)}"]{display:none !important;}`).join("");
    const style = document.createElement("style");
    style.setAttribute("data-announcement-hide", "");
    style.textContent = rules;
    (document.head || document.documentElement).appendChild(style);
})();
function $4290c5a650800a1a$export$bac4adf8b6dd248e() {
    document.querySelectorAll($4290c5a650800a1a$var$ITEM_SELECTOR).forEach($4290c5a650800a1a$var$initItem);
}
/** @param {Element} item */ function $4290c5a650800a1a$var$initItem(item) {
    const el = /** @type {HTMLElement} */ item;
    if (el.dataset.scriptInitialized) return;
    const slug = el.getAttribute($4290c5a650800a1a$var$ANNOUNCEMENT_SLUG_ATTR);
    if (!slug) return;
    el.dataset.scriptInitialized = "true";
    if ($4290c5a650800a1a$var$dismissedSlugs.has(slug)) {
        el.setAttribute($4290c5a650800a1a$var$DISMISSED_ATTR, "");
        return;
    }
    const dismissButton = el.querySelector($4290c5a650800a1a$var$DISMISS_SELECTOR);
    if (!dismissButton) return;
    dismissButton.addEventListener("click", ()=>{
        $4290c5a650800a1a$var$dismissedSlugs.add(slug);
        $4290c5a650800a1a$var$writeDismissedSlugs($4290c5a650800a1a$var$dismissedSlugs);
        el.setAttribute($4290c5a650800a1a$var$DISMISSED_ATTR, "");
    });
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $4290c5a650800a1a$export$bac4adf8b6dd248e, {
    once: true
});
else $4290c5a650800a1a$export$bac4adf8b6dd248e();


/**
 * Modal Component
 *
 * Activates `<dialog data-modal-element="dialog">` elements with Web Animations
 * API open/close animations. The `data-wf--modal--variant` attribute picks the
 * animation style — "side-panel", "full-screen", or default (centered).
 *
 * Triggers:
 *   - Elements: [data-modal-trigger="<id>"]
 *   - Anchors:  a[href="#<id>"]
 *   - URL:      ?modal-id=<id> on initial load (param is stripped after open)
 *
 * Optional integrations (detected at runtime — no hard dependency):
 *   - lenis for scroll-lock
 *
 * Exposes a global registry at `window.bruce.modal`:
 *   open(id), closeAll(), list (per-id { open, close })
 *
 * Webflow markup (style with whatever classes you want):
 *   <dialog data-modal-element="dialog"
 *           data-modal-target="my-id"
 *           data-wf--modal--variant="side-panel">
 *     <div data-modal-element="backdrop" data-modal-close></div>
 *     <div data-modal-element="content">
 *       <div data-modal-element="slot">…</div>
 *     </div>
 *   </dialog>
 */ const $bbf1804d10ba9218$var$M = {
    dialog: '[data-modal-element="dialog"]',
    backdrop: '[data-modal-element="backdrop"]',
    content: '[data-modal-element="content"]',
    slot: '[data-modal-element="slot"]'
};
const $bbf1804d10ba9218$var$VARIANT = {
    SIDE_PANEL: "side-panel",
    FULL_SCREEN: "full-screen"
};
const $bbf1804d10ba9218$var$EASING_OUT = "cubic-bezier(0.16, 1, 0.3, 1)";
// Per-variant animation specs in the OPEN direction. Each entry pairs an
// element with the keyframes that take it from its closed pose to its open
// pose. Closing reverses the same animations in place via playbackRate.
function $bbf1804d10ba9218$var$buildSpecs(variant, backdrop, content, slot) {
    if (variant === $bbf1804d10ba9218$var$VARIANT.SIDE_PANEL) return [
        backdrop && {
            el: backdrop,
            kf: [
                {
                    opacity: 0
                },
                {
                    opacity: 1
                }
            ],
            opts: {
                duration: 300,
                easing: $bbf1804d10ba9218$var$EASING_OUT
            }
        },
        content && {
            el: content,
            kf: [
                {
                    transform: "translateX(100%)"
                },
                {
                    transform: "translateX(0)"
                }
            ],
            opts: {
                duration: 300,
                easing: $bbf1804d10ba9218$var$EASING_OUT
            }
        }
    ].filter(Boolean);
    if (variant === $bbf1804d10ba9218$var$VARIANT.FULL_SCREEN) return [
        // Backdrop stays hidden for full-screen — the content covers the viewport.
        backdrop && {
            el: backdrop,
            kf: [
                {
                    opacity: 0
                },
                {
                    opacity: 0
                }
            ],
            opts: {
                duration: 200
            }
        },
        content && {
            el: content,
            kf: [
                {
                    opacity: 0
                },
                {
                    opacity: 1
                }
            ],
            opts: {
                duration: 200,
                easing: $bbf1804d10ba9218$var$EASING_OUT
            }
        },
        slot && {
            el: slot,
            kf: [
                {
                    opacity: 0,
                    transform: "translateY(2rem)"
                },
                {
                    opacity: 1,
                    transform: "translateY(0)"
                }
            ],
            opts: {
                duration: 200,
                delay: 100,
                easing: $bbf1804d10ba9218$var$EASING_OUT
            }
        }
    ].filter(Boolean);
    // default — centered. Subtle fade + small rise from below.
    return [
        backdrop && {
            el: backdrop,
            kf: [
                {
                    opacity: 0
                },
                {
                    opacity: 1
                }
            ],
            opts: {
                duration: 300,
                easing: $bbf1804d10ba9218$var$EASING_OUT
            }
        },
        content && {
            el: content,
            kf: [
                {
                    opacity: 0,
                    transform: "translateY(8px) scale(0.97)"
                },
                {
                    opacity: 1,
                    transform: "translateY(0) scale(1)"
                }
            ],
            opts: {
                duration: 300,
                easing: $bbf1804d10ba9218$var$EASING_OUT
            }
        }
    ].filter(Boolean);
}
// ── Global registry ──────────────────────────────────────────
/** @type {any} */ window.bruce ||= {};
const $bbf1804d10ba9218$var$modalSystem = /** @type {any} */ window.bruce.modal ??= {
    list: {},
    open (id) {
        this.list[id]?.open?.();
    },
    closeAll () {
        Object.values(this.list).forEach((m)=>m.close?.());
    }
};
// ── Delegated trigger click ──────────────────────────────────
// One document-level listener routes every [data-modal-trigger] / a[href="#id"]
// click to the matching modal — adding a per-modal listener inside initModals
// would multiply work on every page click.
let $bbf1804d10ba9218$var$triggerListenerAttached = false;
function $bbf1804d10ba9218$var$attachTriggerListener() {
    if ($bbf1804d10ba9218$var$triggerListenerAttached) return;
    $bbf1804d10ba9218$var$triggerListenerAttached = true;
    document.addEventListener("click", (e)=>{
        const target = /** @type {Element | null} */ e.target;
        if (!target) return;
        const trigger = target.closest("[data-modal-trigger], a[href^='#']");
        if (!trigger) return;
        const id = trigger.getAttribute("data-modal-trigger") || trigger.getAttribute("href")?.slice(1);
        if (!id || !$bbf1804d10ba9218$var$modalSystem.list[id]) return;
        if (trigger.tagName === "A") e.preventDefault();
        $bbf1804d10ba9218$var$modalSystem.open(id);
    });
}
function $bbf1804d10ba9218$export$e14d3bc873a8b9b1() {
    $bbf1804d10ba9218$var$attachTriggerListener();
    document.querySelectorAll($bbf1804d10ba9218$var$M.dialog).forEach((modal)=>{
        const el = /** @type {HTMLDialogElement} */ modal;
        if (el.dataset.scriptInitialized) return;
        el.dataset.scriptInitialized = "true";
        const modalId = el.getAttribute("data-modal-target");
        const variant = el.getAttribute("data-wf--modal--variant");
        const contentEl = /** @type {HTMLElement | null} */ el.querySelector($bbf1804d10ba9218$var$M.content);
        // Anchor the default-variant scale to the bottom edge so the content
        // rises upward into place. No effect on translate-only variants.
        if (contentEl) contentEl.style.transformOrigin = "center bottom";
        const specs = $bbf1804d10ba9218$var$buildSpecs(variant, el.querySelector($bbf1804d10ba9218$var$M.backdrop), contentEl, el.querySelector($bbf1804d10ba9218$var$M.slot));
        const scrollResetEls = el.querySelectorAll("[data-modal-scroll]");
        let lastFocusedElement;
        /** @type {Animation[]} */ let animations = [];
        /** @type {"open" | "close" | null} */ let direction = null;
        // Bumped on every playClose so any stacked `.finished` handler from an
        // earlier call can detect that it's stale and bail — prevents resetModal
        // from running twice (duplicate modal-close events, duplicate focus).
        let closeToken = 0;
        const playOpen = ()=>{
            if (direction === "open") return;
            if (direction === "close") {
                animations.forEach((a)=>{
                    a.playbackRate = 1;
                });
                direction = "open";
                return;
            }
            animations = specs.map((s)=>s.el.animate(s.kf, {
                    ...s.opts,
                    fill: "forwards"
                }));
            direction = "open";
        };
        const playClose = (onComplete)=>{
            if (direction === "close") return; // an in-flight close handler will finish it
            if (direction === "open") animations.forEach((a)=>{
                a.playbackRate = -1;
            });
            else animations = specs.map((s)=>s.el.animate([
                    s.kf[1],
                    s.kf[0]
                ], {
                    ...s.opts,
                    fill: "forwards"
                }));
            direction = "close";
            if (animations.length === 0) {
                onComplete();
                return;
            }
            const myToken = ++closeToken;
            Promise.all(animations.map((a)=>a.finished.catch(()=>null))).then(()=>{
                if (myToken !== closeToken || direction !== "close") return;
                // Call onComplete (which hides the dialog) BEFORE cancelling so the
                // user never sees the brief frame where animation effects are
                // released but the dialog is still visible.
                onComplete();
                animations.forEach((a)=>a.cancel());
                animations = [];
                direction = null;
            });
        };
        function resetModal() {
            if (typeof lenis !== "undefined" && lenis.start) lenis.start();
            else document.body.style.overflow = "";
            el.close();
            if (lastFocusedElement) lastFocusedElement.focus();
            window.dispatchEvent(new CustomEvent("modal-close", {
                detail: {
                    modal: el
                }
            }));
        }
        function openModal() {
            if (typeof lenis !== "undefined" && lenis.stop) lenis.stop();
            else document.body.style.overflow = "hidden";
            lastFocusedElement = document.activeElement;
            el.showModal();
            playOpen();
            scrollResetEls.forEach((s)=>s.scrollTop = 0);
            window.dispatchEvent(new CustomEvent("modal-open", {
                detail: {
                    modal: el
                }
            }));
        }
        function closeModal() {
            playClose(resetModal);
        }
        // Open via ?modal-id=… on initial load, then strip the param.
        if (modalId && new URLSearchParams(location.search).get("modal-id") === modalId) {
            openModal();
            const url = new URL(location.href);
            url.searchParams.delete("modal-id");
            history.replaceState({}, "", url);
        }
        el.addEventListener("cancel", (e)=>{
            e.preventDefault();
            closeModal();
        });
        el.addEventListener("click", (e)=>{
            if (/** @type {Element} */ e.target.closest("[data-modal-close]")) closeModal();
        });
        if (modalId) $bbf1804d10ba9218$var$modalSystem.list[modalId] = {
            open: openModal,
            close: closeModal
        };
    });
}
// ── Auto-boot ────────────────────────────────────────────────
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $bbf1804d10ba9218$export$e14d3bc873a8b9b1, {
    once: true
});
else $bbf1804d10ba9218$export$e14d3bc873a8b9b1();


/**
 * Accordion Component
 *
 * Expandable items inside an accordion list, animated open/closed with the
 * Web Animations API. Each item pairs a toggle with a content slot.
 *
 * Per-list data attributes (read as strings; defaults shown):
 *   - data-close-previous="True"          close the prior item when opening another
 *   - data-close-on-second-click="True"   clicking an open item closes it
 *   - data-open-on-hover="False"          open on mouseenter as well as click
 *   - data-open-by-default="<n>"          open the n-th item (1-indexed) on init
 *
 * On boot the list is normalized so animations measure real children:
 *   - `.u-display-contents` wrappers are unwrapped in place
 *   - A `.w-dyn-list` is collapsed to its non-`.w-condition-invisible` children
 *
 * Webflow markup (style with whatever classes you want):
 *   <div data-accordion-element="list"
 *        data-close-previous="True"
 *        data-close-on-second-click="True"
 *        data-open-on-hover="False"
 *        data-open-by-default="1">
 *     <div data-accordion-element="item">
 *       <button data-accordion-element="toggle">…</button>
 *       <div data-accordion-element="content">…</div>
 *     </div>
 *   </div>
 *
 * Nested accordions work — each item is scoped to its own list.
 */ 
const $df9ff00450d2679b$var$A = {
    list: '[data-accordion-element="list"]',
    item: '[data-accordion-element="item"]',
    toggle: '[data-accordion-element="toggle"]',
    content: '[data-accordion-element="content"]'
};
const $df9ff00450d2679b$var$DURATION_MS = 300;
const $df9ff00450d2679b$var$EASING = "ease-in-out";
function $df9ff00450d2679b$export$6e9847a60c738c4d() {
    document.querySelectorAll($df9ff00450d2679b$var$A.list).forEach((listEl, listIndex)=>{
        const list = /** @type {HTMLElement} */ listEl;
        if (list.dataset.scriptInitialized) return;
        const closePrevious = (0, $e1f0b8fa1ae2171c$export$df345a2880184520)(list, "data-close-previous", true);
        const closeOnSecondClick = (0, $e1f0b8fa1ae2171c$export$df345a2880184520)(list, "data-close-on-second-click", true);
        const openOnHover = (0, $e1f0b8fa1ae2171c$export$df345a2880184520)(list, "data-open-on-hover");
        const openByDefault = (0, $e1f0b8fa1ae2171c$export$a802fe75dee3ccae)(list, "data-open-by-default", 0);
        let previousIndex = null;
        /** @type {Array<() => void>} */ const closeFunctions = [];
        (0, $e1f0b8fa1ae2171c$export$abb8b833bfa7c79)(list);
        (0, $e1f0b8fa1ae2171c$export$20a158e904f6d53d)(list);
        // Scope to items that belong to THIS list — skip items inside any nested list.
        const items = [
            ...list.querySelectorAll($df9ff00450d2679b$var$A.item)
        ].filter((el)=>el.closest($df9ff00450d2679b$var$A.list) === list);
        // Nothing to wire yet — leave the list uninitialized so a later init pass
        // (e.g. a modal mount re-running initAccordion) can wire it once it has items.
        if (items.length === 0) return;
        list.dataset.scriptInitialized = "true";
        items.forEach((item, itemIndex)=>{
            // Same scope discipline for toggle/content so a nested list's elements
            // don't get wired to this item.
            const button = [
                ...item.querySelectorAll($df9ff00450d2679b$var$A.toggle)
            ].find((el)=>el.closest($df9ff00450d2679b$var$A.item) === item);
            const content = [
                ...item.querySelectorAll($df9ff00450d2679b$var$A.content)
            ].find((el)=>el.closest($df9ff00450d2679b$var$A.item) === item);
            if (!button || !content) {
                console.warn("Missing elements:", item);
                return;
            }
            button.setAttribute("aria-expanded", "false");
            button.setAttribute("id", `accordion_button_${listIndex}_${itemIndex}`);
            content.setAttribute("id", `accordion_content_${listIndex}_${itemIndex}`);
            button.setAttribute("aria-controls", content.id);
            content.setAttribute("aria-labelledby", button.id);
            const contentEl = /** @type {HTMLElement} */ content;
            contentEl.style.display = "none";
            contentEl.style.overflow = "hidden";
            /** @type {Animation | null} */ let currentAnimation = null;
            // Commit the in-flight animation's current value to inline style, then
            // cancel it — lets the next animation resume from where this one was
            // visually, rather than snapping back to the underlying inline value.
            const stopCurrent = ()=>{
                if (!currentAnimation) return 0;
                try {
                    currentAnimation.commitStyles();
                } catch (_) {
                /* commitStyles fails if the element is detached — ignore */ }
                currentAnimation.cancel();
                currentAnimation = null;
                return parseFloat(contentEl.style.height) || 0;
            };
            const animateTo = (fromPx, toPx, onDone)=>{
                contentEl.style.height = `${fromPx}px`;
                const anim = contentEl.animate([
                    {
                        height: `${fromPx}px`
                    },
                    {
                        height: `${toPx}px`
                    }
                ], {
                    duration: $df9ff00450d2679b$var$DURATION_MS,
                    easing: $df9ff00450d2679b$var$EASING,
                    fill: "forwards"
                });
                currentAnimation = anim;
                anim.onfinish = ()=>{
                    if (currentAnimation !== anim) return;
                    currentAnimation = null;
                    // fill:forwards keeps the final keyframe applied at the animation
                    // layer after finish, which overrides inline style. That freezes the
                    // element at a fixed px height — invisible for leaf items but it
                    // blocks a parent from growing when a nested accordion opens inside
                    // it. Commit the final value to inline, then drop the animation
                    // effect, so onDone's `style.height = ""` actually reaches `auto`.
                    try {
                        anim.commitStyles();
                    } catch (_) {
                    /* commitStyles fails on detached elements — ignore */ }
                    anim.cancel();
                    onDone();
                };
            };
            const closeAccordion = ()=>{
                if (!item.classList.contains("is-active")) return;
                item.classList.remove("is-active");
                button.setAttribute("aria-expanded", "false");
                const from = currentAnimation ? stopCurrent() : contentEl.getBoundingClientRect().height;
                animateTo(from, 0, ()=>{
                    contentEl.style.height = "";
                    contentEl.style.display = "none";
                });
            };
            closeFunctions[itemIndex] = closeAccordion;
            const openAccordion = (instant = false)=>{
                if (closePrevious && previousIndex !== null && previousIndex !== itemIndex) closeFunctions[previousIndex]?.();
                previousIndex = itemIndex;
                button.setAttribute("aria-expanded", "true");
                item.classList.add("is-active");
                const from = stopCurrent();
                contentEl.style.display = "block";
                if (instant) {
                    contentEl.style.height = "";
                    return;
                }
                // Measure the natural target height, then restore the starting height
                // before the animation begins so there's no visible flash.
                contentEl.style.height = "auto";
                const to = contentEl.scrollHeight;
                animateTo(from, to, ()=>{
                    contentEl.style.height = "";
                });
            };
            if (openByDefault === itemIndex + 1) openAccordion(true);
            button.addEventListener("click", ()=>{
                if (item.classList.contains("is-active") && closeOnSecondClick) {
                    closeAccordion();
                    previousIndex = null;
                } else openAccordion();
            });
            if (openOnHover) button.addEventListener("mouseenter", ()=>openAccordion());
        });
    });
}
// ── Auto-boot ────────────────────────────────────────────────
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $df9ff00450d2679b$export$6e9847a60c738c4d, {
    once: true
});
else $df9ff00450d2679b$export$6e9847a60c738c4d();


/**
 * FAQ Component
 *
 * Assembles a two-level FAQ accordion from two sibling Webflow collection
 * lists, then hands interaction off to accordion.js. A Webflow Component
 * cannot contain a nested collection list, so FAQ Sections and FAQ Items are
 * bound as separate (non-nested) lists and stitched together here at runtime.
 *
 * Markup (per component):
 *   <div data-faq-element="component">
 *     <!-- FAQ Sections list (sorted by section order) -->
 *     <div data-faq-element="sections" data-accordion-element="list">
 *       <div data-accordion-element="item">
 *         <button data-accordion-element="toggle">{{ Section Name }}</button>
 *         <div data-accordion-element="content">
 *           <div data-faq-element="target" data-faq-section="{{ Section Slug }}"
 *                data-accordion-element="list"></div>
 *         </div>
 *       </div>
 *     </div>
 *     <!-- FAQ Items list (sorted by item order) -->
 *     <div data-faq-element="source">
 *       <div data-accordion-element="item"
 *            data-faq-section="{{ Item → Section → Slug }}">
 *         <button data-accordion-element="toggle">{{ Question }}</button>
 *         <div data-accordion-element="content">{{ Answer }}</div>
 *       </div>
 *     </div>
 *   </div>
 *
 * Per-component attribute (optional):
 *   - data-faq-keep-empty="True"   keep sections that receive zero items
 *                                  (default: such sections are removed)
 *
 * faq.js performs no animation — it moves item nodes into their section's
 * target, prunes empty sections, removes the source list, then calls
 * initAccordion(), which wires both accordion levels.
 */ 
/**
 * Pure planner for FAQ nesting.
 *
 * Given the section slugs of the target drop-zones (in section order) and the
 * section slugs of the source items (in item order), compute how to nest items
 * under sections: which items belong to each target, which items match no
 * section (orphans), and which targets receive no items (empty).
 *
 * Indexes refer to positions in the input arrays, so the DOM layer can map them
 * back to elements without re-matching. Slugs are unique in practice; if a slug
 * is repeated across targets, the first target wins and the rest stay empty.
 *
 * @param {string[]} targetSlugs  section slug of each target, in section order
 * @param {string[]} itemSlugs    section slug of each item, in item order
 * @returns {{
 *   groups: Array<{ slug: string, itemIndexes: number[] }>,
 *   orphanItemIndexes: number[],
 *   emptyTargetSlugs: string[],
 * }}
 */ function $9d80a5f1cffa4749$export$34711a8e770a310(targetSlugs, itemSlugs) {
    const slugToGroup = new Map();
    const groups = targetSlugs.map((slug)=>{
        const group = {
            slug: slug,
            itemIndexes: []
        };
        // First target for a given slug owns its items.
        if (!slugToGroup.has(slug)) slugToGroup.set(slug, group);
        return group;
    });
    const orphanItemIndexes = [];
    itemSlugs.forEach((slug, index)=>{
        const group = slugToGroup.get(slug);
        if (group) group.itemIndexes.push(index);
        else orphanItemIndexes.push(index);
    });
    const emptyTargetSlugs = groups.filter((group)=>group.itemIndexes.length === 0).map((group)=>group.slug);
    return {
        groups: groups,
        orphanItemIndexes: orphanItemIndexes,
        emptyTargetSlugs: emptyTargetSlugs
    };
}



const $15efe02608990f66$var$F = {
    component: '[data-faq-element="component"]',
    source: '[data-faq-element="source"]',
    target: '[data-faq-element="target"]',
    section: "data-faq-section",
    keepEmpty: "data-faq-keep-empty"
};
function $15efe02608990f66$export$4bda925ccc2b533a() {
    let restructured = false;
    document.querySelectorAll($15efe02608990f66$var$F.component).forEach((componentEl)=>{
        const component = /** @type {HTMLElement} */ componentEl;
        if (component.dataset.scriptInitialized) return;
        const sourceList = component.querySelector($15efe02608990f66$var$F.source);
        const targetEls = [
            ...component.querySelectorAll($15efe02608990f66$var$F.target)
        ];
        // Not ready yet (e.g. CMS still rendering) — leave for a later pass.
        if (!sourceList || targetEls.length === 0) return;
        component.dataset.scriptInitialized = "true";
        restructured = true;
        // Each source item is the [data-accordion-element="item"] carrying the
        // section slug. Querying within sourceList excludes the targets, which
        // also carry data-faq-section but live in the sections list.
        const itemEls = [
            ...sourceList.querySelectorAll(`[${$15efe02608990f66$var$F.section}]`)
        ];
        const targetSlugs = targetEls.map((el)=>el.getAttribute($15efe02608990f66$var$F.section) || "");
        const itemSlugs = itemEls.map((el)=>el.getAttribute($15efe02608990f66$var$F.section) || "");
        const { groups: groups, orphanItemIndexes: orphanItemIndexes } = (0, $9d80a5f1cffa4749$export$34711a8e770a310)(targetSlugs, itemSlugs);
        // Move each item into its section's target, preserving item order. Moving
        // the item node itself (not its .w-dyn-item wrapper) keeps accordion.js's
        // `closest(list) === list` scoping correct for the nested list.
        groups.forEach((group, groupIndex)=>{
            const target = targetEls[groupIndex];
            group.itemIndexes.forEach((itemIndex)=>{
                target.appendChild(itemEls[itemIndex]);
            });
        });
        // Items whose slug matches no section: drop them, warn for content fixes.
        orphanItemIndexes.forEach((itemIndex)=>{
            console.warn(`[faq] item references unknown section "${itemSlugs[itemIndex]}"`, itemEls[itemIndex]);
            itemEls[itemIndex].remove();
        });
        // Remove sections that received no items, unless told to keep them.
        if (!(0, $e1f0b8fa1ae2171c$export$df345a2880184520)(component, $15efe02608990f66$var$F.keepEmpty)) groups.forEach((group, groupIndex)=>{
            if (group.itemIndexes.length > 0) return;
            const target = targetEls[groupIndex];
            const sectionItem = target?.closest('[data-accordion-element="item"]');
            (sectionItem?.closest(".w-dyn-item") || sectionItem)?.remove();
        });
        // Drop the now-empty source list (its outer .w-dyn-list wrapper too).
        (sourceList.closest(".w-dyn-list") || sourceList).remove();
    });
    // Wire both accordion levels. initAccordion is idempotent (guards each list
    // with data-script-initialized) and skips empty lists, so this is safe even
    // if accordion.js already booted the (then-empty) section list.
    if (restructured) (0, $df9ff00450d2679b$export$6e9847a60c738c4d)();
}
// ── Auto-boot ────────────────────────────────────────────────
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $15efe02608990f66$export$4bda925ccc2b533a, {
    once: true
});
else $15efe02608990f66$export$4bda925ccc2b533a();


/**
 * Collapsible Component
 *
 * Independent expand/collapse region. Each `.collapsible_wrap` owns a single
 * `.collapsible_trigger` and a single `.collapsible_content`. Clicking the
 * trigger toggles the content with a Web Animations API height tween.
 *
 * For grouped expand/collapse with "close previous" behavior, use
 * `accordion.js` instead — this module intentionally has no group logic.
 *
 * Per-wrap data attributes (all optional, all on `.collapsible_wrap`):
 *   - data-open-by-default="True"   start in the open state (no animation)
 *   - data-open-on-hover="True"     mouseenter on trigger also opens
 *                                    (close still requires a click)
 *   - data-duration="<seconds>"     override animation duration (default 0.3)
 *   - data-collapsible-id="<key>"   broadcast the `is-active` class onto every
 *                                    `[data-component="collapsible"]
 *                                     [data-collapsible-id="<key>"]` element
 *                                    on the page (one-way mirror, for styling)
 *
 * Nesting: a `.collapsible_wrap` inside another wrap's `.collapsible_content`
 * works — each wrap resolves only its own direct trigger and content, so
 * nested triggers don't toggle the outer wrap.
 *
 * Webflow markup:
 *   <div class="collapsible_wrap"
 *        data-open-by-default="True"
 *        data-open-on-hover="True"
 *        data-duration="0.4"
 *        data-collapsible-id="faq-1">
 *     <button class="collapsible_trigger">…</button>
 *     <div class="collapsible_content">…</div>
 *   </div>
 *
 *   <!-- anywhere else on the page -->
 *   <div data-component="collapsible" data-collapsible-id="faq-1">…</div>
 */ 
// ── Module-level constants ───────────────────────────────────
const $f64951864292a846$var$DEFAULT_DURATION_S = 0.3;
const $f64951864292a846$var$EASING = "ease-in-out";
function $f64951864292a846$export$34107ba18b519094() {
    document.querySelectorAll(".collapsible_wrap").forEach((wrapEl, wrapIndex)=>{
        const wrap = /** @type {HTMLElement} */ wrapEl;
        if (wrap.dataset.scriptInitialized) return;
        wrap.dataset.scriptInitialized = "true";
        // Resolve the trigger/content that belong to THIS wrap — skip any
        // descendants that live inside a nested .collapsible_wrap.
        const own = (selector)=>[
                ...wrap.querySelectorAll(selector)
            ].find((el)=>el.closest(".collapsible_wrap") === wrap);
        const trigger = /** @type {HTMLElement | undefined} */ own(".collapsible_trigger");
        const content = /** @type {HTMLElement | undefined} */ own(".collapsible_content");
        if (!trigger || !content) {
            console.warn("Missing elements:", wrap);
            return;
        }
        const openByDefault = (0, $e1f0b8fa1ae2171c$export$df345a2880184520)(wrap, "data-open-by-default");
        const openOnHover = (0, $e1f0b8fa1ae2171c$export$df345a2880184520)(wrap, "data-open-on-hover");
        const rawDuration = (0, $e1f0b8fa1ae2171c$export$a802fe75dee3ccae)(wrap, "data-duration", $f64951864292a846$var$DEFAULT_DURATION_S);
        const durationMs = (rawDuration > 0 ? rawDuration : $f64951864292a846$var$DEFAULT_DURATION_S) * 1000;
        trigger.id = `collapsible_trigger_${wrapIndex}`;
        content.id = `collapsible_content_${wrapIndex}`;
        trigger.setAttribute("aria-controls", content.id);
        content.setAttribute("aria-labelledby", trigger.id);
        trigger.setAttribute("aria-expanded", "false");
        content.style.display = "none";
        content.style.overflow = "hidden";
        // Re-query on each transition so mirrors injected later (CMS, modals,
        // etc.) still pick up state changes. Selector is built once at init.
        const mirrorId = wrap.getAttribute("data-collapsible-id");
        const mirrorSelector = mirrorId ? `[data-component="collapsible"][data-collapsible-id="${CSS.escape(mirrorId)}"]` : null;
        const getMirrors = ()=>mirrorSelector ? document.querySelectorAll(mirrorSelector) : [];
        /** @type {Animation | null} */ let currentAnimation = null;
        // Commit the in-flight animation's current value to inline style, then
        // cancel it — lets the next animation resume from where this one was
        // visually, rather than snapping back to the underlying inline value.
        const stopCurrent = ()=>{
            if (!currentAnimation) return 0;
            try {
                currentAnimation.commitStyles();
            } catch (_) {
            /* commitStyles fails if the element is detached — ignore */ }
            currentAnimation.cancel();
            currentAnimation = null;
            return parseFloat(content.style.height) || 0;
        };
        const animateTo = (fromPx, toPx, onDone)=>{
            content.style.height = `${fromPx}px`;
            const anim = content.animate([
                {
                    height: `${fromPx}px`
                },
                {
                    height: `${toPx}px`
                }
            ], {
                duration: durationMs,
                easing: $f64951864292a846$var$EASING,
                fill: "forwards"
            });
            currentAnimation = anim;
            anim.onfinish = ()=>{
                if (currentAnimation !== anim) return;
                currentAnimation = null;
                onDone();
            };
        };
        const open = (instant = false)=>{
            wrap.classList.add("is-active");
            trigger.setAttribute("aria-expanded", "true");
            getMirrors().forEach((m)=>m.classList.add("is-active"));
            const from = stopCurrent();
            content.style.display = "block";
            if (instant) {
                content.style.height = "";
                return;
            }
            content.style.height = "auto";
            const to = content.scrollHeight;
            animateTo(from, to, ()=>{
                content.style.height = "";
            });
        };
        const close = ()=>{
            if (!wrap.classList.contains("is-active")) return;
            wrap.classList.remove("is-active");
            trigger.setAttribute("aria-expanded", "false");
            getMirrors().forEach((m)=>m.classList.remove("is-active"));
            const from = currentAnimation ? stopCurrent() : content.getBoundingClientRect().height;
            animateTo(from, 0, ()=>{
                content.style.height = "";
                content.style.display = "none";
            });
        };
        const toggle = ()=>{
            if (wrap.classList.contains("is-active")) close();
            else open();
        };
        if (openByDefault) open(true);
        trigger.addEventListener("click", toggle);
        if (openOnHover) trigger.addEventListener("mouseenter", ()=>open());
    });
}
// ── Auto-boot ────────────────────────────────────────────────
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $f64951864292a846$export$34107ba18b519094, {
    once: true
});
else $f64951864292a846$export$34107ba18b519094();


/**
 * Dropdown Component
 *
 * Single togglable dropdown region with an animated open/close, click-outside
 * dismissal, Escape key support, and ArrowUp/ArrowDown navigation through
 * focusable items inside the content panel.
 *
 * Per-wrap data attributes (all optional, all on the wrap):
 *   - data-open-on-hover-in="true"     mouseenter on the wrap opens it
 *   - data-close-on-hover-out="true"   mouseleave on the wrap closes it
 *
 * Webflow markup (style with whatever classes you want):
 *   <div data-dropdown-element="wrap"
 *        data-open-on-hover-in="true"
 *        data-close-on-hover-out="true">
 *     <button data-dropdown-element="toggle">…</button>
 *     <div data-dropdown-element="content">
 *       <a href="…">Item 1</a>
 *       <a href="…">Item 2</a>
 *     </div>
 *   </div>
 *
 * Nested dropdowns work — each wrap resolves only its own direct toggle and
 * content, so nested toggles don't toggle the outer wrap.
 */ 
/**
 * Pure placement helper for dropdown.js. Framework-free (no DOM, no globals)
 * so the flip / shift / clamp rules live in one unit-testable place.
 *
 * Everything is plain numbers in CLIENT coordinates — the same space
 * getBoundingClientRect() reports in. The caller measures and applies; this
 * only decides.
 *
 * Rules, in order:
 *   1. Prefer below the anchor. If the panel's natural height fits there, done.
 *   2. Otherwise try above. If it fits there, flip.
 *   3. If it fits neither, take whichever side has more room and clamp the
 *      height to it — the caller scrolls the overflow inside the panel.
 *   4. Left-align to the anchor, then slide horizontally to stay inside the
 *      viewport's inset box.
 *
 * @param {object} input
 * @param {{top: number, bottom: number, left: number, width: number}} input.anchor
 *   Client rect of the toggle.
 * @param {{width: number, height: number}} input.panel
 *   The panel's NATURAL size — measured unconstrained, before any clamping.
 * @param {{top: number, left: number, width: number, height: number}} input.viewport
 *   The visible band, in client coordinates. With a soft keyboard open this is
 *   the visual viewport: shorter than, and possibly offset from, the layout one.
 * @param {number} [input.gap=8] Space between the anchor and the panel.
 * @param {number} [input.inset=8] Minimum space between the panel and the
 *   viewport edge.
 * @returns {{placement: "bottom" | "top", top: number, left: number, maxHeight: number}}
 */ function $9197b43f210216fc$export$d4d5bf0e1681e4da({ anchor: anchor, panel: panel, viewport: viewport, gap: gap = 8, inset: inset = 8 }) {
    const viewportBottom = viewport.top + viewport.height;
    const viewportRight = viewport.left + viewport.width;
    // Room available to the panel on each side, with the gap and the edge inset
    // already deducted. Goes negative when the anchor sits outside the viewport.
    const spaceBelow = viewportBottom - inset - (anchor.bottom + gap);
    const spaceAbove = anchor.top - gap - (viewport.top + inset);
    // Ties go to "bottom" — the default reading direction for a dropdown.
    let placement;
    if (panel.height <= spaceBelow) placement = "bottom";
    else if (panel.height <= spaceAbove) placement = "top";
    else placement = spaceAbove > spaceBelow ? "top" : "bottom";
    const space = placement === "bottom" ? spaceBelow : spaceAbove;
    // Floor at 0: an anchor scrolled off-screen must not yield a negative
    // max-height, which CSS would reject and leave the panel unclamped.
    const maxHeight = Math.max(0, Math.min(panel.height, space));
    const top = placement === "bottom" ? anchor.bottom + gap : anchor.top - gap - maxHeight;
    // Left-align to the anchor, then shift into the inset box. When the panel is
    // wider than that box the two bounds invert, so pin to the left edge rather
    // than letting the clamp snap it right.
    const minLeft = viewport.left + inset;
    const maxLeft = viewportRight - inset - panel.width;
    const left = maxLeft < minLeft ? minLeft : Math.min(Math.max(anchor.left, minLeft), maxLeft);
    return {
        placement: placement,
        top: top,
        left: left,
        maxHeight: maxHeight
    };
}


const $2c2f6f8f0bea0e6b$var$A = {
    wrap: '[data-dropdown-element="wrap"]',
    toggle: '[data-dropdown-element="toggle"]',
    content: '[data-dropdown-element="content"]'
};
const $2c2f6f8f0bea0e6b$var$DURATION_MS = 200;
const $2c2f6f8f0bea0e6b$var$EASING = "ease-out";
const $2c2f6f8f0bea0e6b$var$FOCUSABLE_ITEM_SELECTOR = "a, button";
// Visual entry state — alongside the height tween, content fades in, slides
// up from `TRANSLATE_CLOSED` below its resting position, and scales from
// `SCALE_CLOSED`. transform-origin is set to "top" at init so the scale
// anchors under the toggle rather than at the box's center.
const $2c2f6f8f0bea0e6b$var$SCALE_CLOSED = 0.97;
const $2c2f6f8f0bea0e6b$var$TRANSLATE_CLOSED_PX = 8;
const $2c2f6f8f0bea0e6b$var$CLOSED_OPACITY = "0";
const $2c2f6f8f0bea0e6b$var$CLOSED_TRANSFORM = `translateY(${$2c2f6f8f0bea0e6b$var$TRANSLATE_CLOSED_PX}px) scale(${$2c2f6f8f0bea0e6b$var$SCALE_CLOSED})`;
const $2c2f6f8f0bea0e6b$var$OPEN_OPACITY = "1";
const $2c2f6f8f0bea0e6b$var$OPEN_TRANSFORM = "translateY(0px) scale(1)";
// ── Top-layer portal ─────────────────────────────────────────
// Panels open inside clipping ancestors — most painfully the mobile bottom
// sheet, whose shadow-DOM header is a scroll box (overflow-x: scroll forces
// overflow-y to auto) and whose chip row is another one. The top layer ignores
// every ancestor's overflow, clip, transform and z-index, so showPopover()
// sidesteps all of them at once. It also means ancestor transforms don't apply
// to the panel, which is why a plain getBoundingClientRect() on the toggle is
// the correct anchor even mid-sheet-animation.
const $2c2f6f8f0bea0e6b$var$CAN_PORTAL = "showPopover" in HTMLElement.prototype;
const $2c2f6f8f0bea0e6b$var$GAP_PX = 8; // toggle → panel
const $2c2f6f8f0bea0e6b$var$INSET_PX = 8; // panel → viewport edge
// showPopover() brings UA styles with it (inset: 0, margin: auto, a border,
// padding, fit-content sizing) via the UA stylesheet's [popover] rule, which
// applies the moment popover="manual" is set — not gated on :popover-open,
// so it's live during measurement too. It lives here rather than in a
// Webflow embed because it's a functional requirement of this script, not a
// design token — the two must not drift apart.
//
// Two rules, two jobs:
//   - The neutralising rule undoes the UA sheet. Author origin already beats
//     the UA origin, so no specificity is needed — wrapping the selector in
//     :where() keeps it at (0,0,0) so the site's own Webflow classes still
//     win. This is what lets the docstring's "style with whatever classes
//     you want" promise hold: the panel's authored background, padding,
//     border and overflow survive being portalled.
//   - The structural rule only applies while the popover is actually open,
//     and only sets what genuinely must differ from the UA default:
//     position: fixed (Webflow authors these panels as position: absolute)
//     and display: block (parity with the pre-portal code, which always
//     forced display: block on open — otherwise an authored display: none
//     panel would open invisibly, since :popover-open matching doesn't
//     imply visible).
let $2c2f6f8f0bea0e6b$var$popoverStylesInjected = false;
function $2c2f6f8f0bea0e6b$var$ensurePopoverStyles() {
    if ($2c2f6f8f0bea0e6b$var$popoverStylesInjected || !$2c2f6f8f0bea0e6b$var$CAN_PORTAL) return;
    $2c2f6f8f0bea0e6b$var$popoverStylesInjected = true;
    const style = document.createElement("style");
    style.textContent = `
    :where([data-dropdown-element="content"][popover]) {
      position: static;
      inset: auto;
      width: auto;
      height: auto;
      margin: 0;
      border: 0;
      padding: 0;
      overflow: visible;
      background: transparent;
      color: inherit;
    }

    [data-dropdown-element="content"]:popover-open {
      position: fixed;
      inset: auto;
      margin: 0;
      width: auto;
      height: auto;
      display: block;
    }
  `;
    document.head.appendChild(style);
}
// The visible band in client coordinates. visualViewport is the honest source
// on mobile: the filter bar contains a search input, so the soft keyboard can
// be open while a panel is up, and innerHeight does not shrink for it.
function $2c2f6f8f0bea0e6b$var$viewportBox() {
    const vv = window.visualViewport;
    if (vv) return {
        top: vv.offsetTop,
        left: vv.offsetLeft,
        width: vv.width,
        height: vv.height
    };
    return {
        top: 0,
        left: 0,
        width: window.innerWidth,
        height: window.innerHeight
    };
}
// Dynamic stacking — each open bumps the wrap above any already-animating
// peers so the newly-opening dropdown always sits on top of the one still
// closing underneath it. Counter resets to 0 when every dropdown is closed.
const $2c2f6f8f0bea0e6b$var$Z_BASE = 1000;
let $2c2f6f8f0bea0e6b$var$zCounter = 0;
/**
 * @typedef {{
 *   wrap: HTMLElement,
 *   toggle: HTMLElement,
 *   content: HTMLElement,
 *   close: () => void,
 *   reposition: () => number | undefined,
 *   focusableItems: HTMLElement[],
 * }} ActiveDropdown
 */ // Only one dropdown can be open at a time, so a single reference is enough —
// no need to scan a registry on every page click and keystroke.
/** @type {ActiveDropdown | null} */ let $2c2f6f8f0bea0e6b$var$activeDropdown = null;
// ── Shared document listeners (attached once) ────────────────
let $2c2f6f8f0bea0e6b$var$documentListenersAttached = false;
function $2c2f6f8f0bea0e6b$var$attachDocumentListeners() {
    if ($2c2f6f8f0bea0e6b$var$documentListenersAttached) return;
    $2c2f6f8f0bea0e6b$var$documentListenersAttached = true;
    document.addEventListener("click", (e)=>{
        if (!$2c2f6f8f0bea0e6b$var$activeDropdown) return;
        const target = /** @type {Element | null} */ e.target;
        if (target && !$2c2f6f8f0bea0e6b$var$activeDropdown.wrap.contains(target)) $2c2f6f8f0bea0e6b$var$activeDropdown.close();
    });
    document.addEventListener("keydown", (e)=>{
        if (!$2c2f6f8f0bea0e6b$var$activeDropdown) return;
        if (e.key === "Escape") {
            const { toggle: toggle, close: close } = $2c2f6f8f0bea0e6b$var$activeDropdown;
            close();
            toggle.focus();
            return;
        }
        if (e.key !== "ArrowDown" && e.key !== "ArrowUp") return;
        const focused = /** @type {Element | null} */ document.activeElement;
        if (!focused || !$2c2f6f8f0bea0e6b$var$activeDropdown.wrap.contains(focused)) return;
        const items = $2c2f6f8f0bea0e6b$var$activeDropdown.focusableItems;
        if (!items.length) return;
        e.preventDefault();
        const step = e.key === "ArrowDown" ? 1 : -1;
        const currentIndex = items.indexOf(/** @type {HTMLElement} */ focused);
        const nextIndex = currentIndex === -1 ? step === 1 ? 0 : items.length - 1 : (currentIndex + step + items.length) % items.length;
        items[nextIndex].focus();
    });
}
// ── Anchor tracking ──────────────────────────────────────────
// One rAF-throttled reposition shared by every source that can move an open
// panel. Attached on open, detached on close.
let $2c2f6f8f0bea0e6b$var$trackingFrame = 0;
function $2c2f6f8f0bea0e6b$var$onAnchorMove(event) {
    // Scrolling INSIDE an open panel must not re-run positioning — on a clamped
    // list that would fight the user's own scroll.
    const target = event?.target;
    if (target instanceof Node && $2c2f6f8f0bea0e6b$var$activeDropdown && $2c2f6f8f0bea0e6b$var$activeDropdown.content.contains(target)) return;
    if ($2c2f6f8f0bea0e6b$var$trackingFrame) return;
    $2c2f6f8f0bea0e6b$var$trackingFrame = requestAnimationFrame(()=>{
        $2c2f6f8f0bea0e6b$var$trackingFrame = 0;
        $2c2f6f8f0bea0e6b$var$activeDropdown?.reposition();
    });
}
/** @type {ResizeObserver | null} */ let $2c2f6f8f0bea0e6b$var$panelObserver = null;
function $2c2f6f8f0bea0e6b$var$startTracking() {
    if (!$2c2f6f8f0bea0e6b$var$CAN_PORTAL) return;
    // Capture phase: scroll events don't bubble, but they do traverse capture, so
    // this single listener sees every ancestor scroller — including the bottom
    // sheet's host, whose snap animation IS a scroll. That's why dropdown.js
    // never has to know that <bottom-sheet> exists.
    window.addEventListener("scroll", $2c2f6f8f0bea0e6b$var$onAnchorMove, {
        capture: true,
        passive: true
    });
    window.addEventListener("resize", $2c2f6f8f0bea0e6b$var$onAnchorMove);
    window.visualViewport?.addEventListener("resize", $2c2f6f8f0bea0e6b$var$onAnchorMove);
    window.visualViewport?.addEventListener("scroll", $2c2f6f8f0bea0e6b$var$onAnchorMove);
}
function $2c2f6f8f0bea0e6b$var$stopTracking() {
    window.removeEventListener("scroll", $2c2f6f8f0bea0e6b$var$onAnchorMove, {
        capture: true
    });
    window.removeEventListener("resize", $2c2f6f8f0bea0e6b$var$onAnchorMove);
    window.visualViewport?.removeEventListener("resize", $2c2f6f8f0bea0e6b$var$onAnchorMove);
    window.visualViewport?.removeEventListener("scroll", $2c2f6f8f0bea0e6b$var$onAnchorMove);
    $2c2f6f8f0bea0e6b$var$panelObserver?.disconnect();
    $2c2f6f8f0bea0e6b$var$panelObserver = null;
    if ($2c2f6f8f0bea0e6b$var$trackingFrame) {
        cancelAnimationFrame($2c2f6f8f0bea0e6b$var$trackingFrame);
        $2c2f6f8f0bea0e6b$var$trackingFrame = 0;
    }
}
// Watches a settled panel for content-driven size changes — Finsweet shows and
// hides facet options live (fs-list-emptyfacet="hide"), so the natural height
// can move while the panel is open and the clamp has to follow.
//
// Observes the panel's ELEMENT CHILDREN, not the panel itself. The panel's
// own border box is capped by the inline `max-height` reposition() writes
// whenever it clamps, so once it's clamped, growth past the clamp changes
// nothing about that box —
// the observer would never fire for exactly the case it exists to catch.
// Children aren't capped by their parent's max-height, so their boxes keep
// reporting real size changes whether the panel is clamped or not. Falls back
// to observing `entry.content` itself only when there are no element children
// (a text-only panel), so there's still some coverage.
//
// Whichever child fired, reposition() (invoked via onAnchorMove) re-measures
// the panel's natural height itself (content.scrollHeight), so it doesn't
// matter which descendant changed — the fix is at the read, not the watch.
//
// Only attached after the open tween finishes; during the tween the height is
// animating and every frame would fire.
function $2c2f6f8f0bea0e6b$var$observePanel(entry) {
    if (!$2c2f6f8f0bea0e6b$var$CAN_PORTAL || $2c2f6f8f0bea0e6b$var$panelObserver) return;
    $2c2f6f8f0bea0e6b$var$panelObserver = new ResizeObserver(()=>$2c2f6f8f0bea0e6b$var$onAnchorMove());
    const children = entry.content.children;
    if (children.length) for (const child of children)$2c2f6f8f0bea0e6b$var$panelObserver.observe(child);
    else $2c2f6f8f0bea0e6b$var$panelObserver.observe(entry.content);
}
const $2c2f6f8f0bea0e6b$var$allClosed = ()=>$2c2f6f8f0bea0e6b$var$activeDropdown === null;
function $2c2f6f8f0bea0e6b$export$9d96c354fe36b236() {
    $2c2f6f8f0bea0e6b$var$attachDocumentListeners();
    $2c2f6f8f0bea0e6b$var$ensurePopoverStyles();
    document.querySelectorAll($2c2f6f8f0bea0e6b$var$A.wrap).forEach((wrapEl, wrapIndex)=>{
        const wrap = /** @type {HTMLElement} */ wrapEl;
        if (wrap.dataset.scriptInitialized) return;
        wrap.dataset.scriptInitialized = "true";
        // Resolve the toggle/content that belong to THIS wrap — skip any
        // descendants that live inside a nested wrap.
        const own = (selector)=>[
                ...wrap.querySelectorAll(selector)
            ].find((el)=>el.closest($2c2f6f8f0bea0e6b$var$A.wrap) === wrap);
        const toggle = /** @type {HTMLElement | undefined} */ own($2c2f6f8f0bea0e6b$var$A.toggle);
        const content = /** @type {HTMLElement | undefined} */ own($2c2f6f8f0bea0e6b$var$A.content);
        if (!toggle || !content) {
            console.warn("Missing elements:", wrap);
            return;
        }
        const openOnHoverIn = (0, $e1f0b8fa1ae2171c$export$df345a2880184520)(wrap, "data-open-on-hover-in");
        const closeOnHoverOut = (0, $e1f0b8fa1ae2171c$export$df345a2880184520)(wrap, "data-close-on-hover-out");
        toggle.id = `dropdown_toggle_${wrapIndex}`;
        content.id = `dropdown_content_${wrapIndex}`;
        toggle.setAttribute("aria-controls", content.id);
        toggle.setAttribute("aria-expanded", "false");
        content.setAttribute("aria-labelledby", toggle.id);
        if ($2c2f6f8f0bea0e6b$var$CAN_PORTAL) // "manual", not "auto": the outside-click and Escape handlers below stay
        // authoritative, and light-dismiss can't race them. The panel stays a DOM
        // descendant of its wrap, so wrap.contains(target) keeps working — the
        // top layer changes where it paints, not where it lives.
        content.setAttribute("popover", "manual");
        else content.style.display = "none";
        content.style.transformOrigin = "top";
        /** @type {Animation | null} */ let currentAnimation = null;
        const isOpen = ()=>toggle.getAttribute("aria-expanded") === "true";
        // The panel's unconstrained size. Width is measured once per open, while
        // the panel is still in normal flow, and then pinned inline — it never
        // changes after that (see portalOpen()). Height is measured once at open
        // too, but reposition() below refreshes it on every later call: content
        // can change height while the panel stays open (Finsweet toggling
        // fs-list-emptyfacet="hide" is the motivating case), and the clamp has to
        // track that, not just the size at open time.
        let naturalSize = {
            width: 0,
            height: 0
        };
        // Border box minus padding box: the panel's own top+bottom borders, plus a
        // horizontal scrollbar's height if the AUTHORED overflow already reserves
        // one. Captured once per open by portalOpen(), while the panel is still
        // unconstrained, and added to `scrollHeight` by reposition() to turn a
        // padding-box read into the border-box number place() and `max-height`
        // both work in (Webflow sets `box-sizing: border-box` globally).
        //
        // It is deliberately NOT re-read on every reposition(), even though
        // `content.offsetHeight - content.clientHeight` would be the live value:
        // that difference includes the horizontal scrollbar, whose presence is a
        // CLAMP SIDE EFFECT. Measured in Chrome on a classic-scrollbar panel,
        // 220px of natural content in a 220px-wide box:
        //   unclamped + `overflow: scroll` (the gutterReserved resting state) →
        //     both bars reserved, delta 15, scrollHeight 205 → natural 220
        //   clamped + `overflow: auto` (no horizontal overflow) →
        //     delta 0, scrollHeight 205 → natural 205
        // Any available space between those two numbers would clamp, unclamp,
        // clamp… once per frame — the very loop gutterReserved exists to sever,
        // reopened on the other axis. A value frozen at measure time can't.
        let borderDelta = 0;
        // Whether the last placement had to clamp. Decides the resting overflow.
        let clamped = false;
        // Whether THIS open has EVER clamped. Reset to false at the top of each
        // open(); once flipped true, it never reverts until the panel closes.
        //
        // Why this exists: re-measuring `naturalSize.height` from `scrollHeight`
        // on every reposition() (above) is correct and necessary, but it opens a
        // feedback path on platforms with space-consuming ("classic") scrollbars
        // for any panel containing a WIDTH-driven child (an `aspect-ratio` box,
        // an `<img width="100%">`, a video embed): clamp -> `overflow: auto`
        // shows a scrollbar -> child's available width shrinks by the scrollbar's
        // width -> child gets shorter -> new scrollHeight now fits under
        // max-height -> unclamp -> scrollbar goes away -> child widens -> child
        // gets taller again -> clamps again -> forever, once per animation frame,
        // with no browser-visible "ResizeObserver loop" warning (the callback
        // defers to rAF, so Chrome never attributes it to the observer).
        //
        // The fix is to stop the scrollbar itself from ever coming and going
        // once it's appeared once: after the first clamp this open, the resting
        // overflow forces `scroll` instead of `auto` (see restingOverflow()
        // below) even while unclamped, so the gutter — and therefore
        // content.clientWidth, and therefore the width-driven child's height —
        // stays constant for the rest of the open. That converges by
        // construction (the feedback path is severed) rather than by tuning a
        // numeric hysteresis margin. The trade is a reserved-but-unused
        // scrollbar track if the panel later shrinks back below the clamp —
        // a visible but minor cost, and worth it for a fix that can't
        // re-oscillate under some other geometry.
        let gutterReserved = false;
        // Single formula for the resting (non-tween) `overflow` value. Called
        // from both reposition() (every post-settle recompute) and open()'s
        // tween-completion callback (the very first write, before any
        // post-settle reposition() has run) so the two call sites can't drift
        // apart into different rules.
        const restingOverflow = ()=>clamped ? "auto" : gutterReserved ? "scroll" : "";
        // Re-parenting or removing an element while its popover is showing drops
        // it out of the top layer. explorer.js does exactly that: placeFilterBar()
        // moves the whole filter form — an ancestor of every filter dropdown —
        // into and out of the bottom sheet whenever the layout crosses the mobile
        // breakpoint, i.e. on an orientation change, which can land while a panel
        // is open. That re-parenting is legitimate; tolerating it is this module's
        // job.
        //
        // The UA hides the popover SILENTLY: the spec runs the removing steps'
        // hide-popover with fireEvents = false, so no `toggle` (or `beforetoggle`)
        // event is dispatched — verified in Chrome 151, where a re-parented panel
        // goes `display: none` with an empty event log. Listening for `toggle`
        // therefore would not catch this at all; the honest signal is the state
        // itself, so this asks `:popover-open` directly.
        //
        // Without it, aria-expanded stays "true", `.is-active` stays on the wrap,
        // `activeDropdown` stays set and the tracking listeners stay attached,
        // writing geometry to a `display: none` panel — and the next tap on the
        // toggle closes instead of opening. Routing through close() resyncs all of
        // that AND detaches the listeners and the ResizeObserver, which is also
        // what stops a wrap removed from the DOM while open from leaking them.
        //
        // Called from the two places that can observe a settled panel: every
        // reposition() (the ResizeObserver fires a 0×0 entry for the panel's now
        // box-less children the moment it is dropped, and orientation changes fire
        // window/visualViewport resize too), and the open tween's completion,
        // which covers a drop during the ~200ms before the observer is attached.
        const healIfDropped = ()=>{
            if (!$2c2f6f8f0bea0e6b$var$CAN_PORTAL || !isOpen() || content.matches(":popover-open")) return false;
            close();
            return true;
        };
        // Writes geometry ONLY — never `height`. A reposition landing mid-tween
        // therefore can't fight the animation: the tween finishes to its original
        // target and max-height clamps the result if the space shrank underneath.
        const reposition = ()=>{
            if (!$2c2f6f8f0bea0e6b$var$CAN_PORTAL || !isOpen()) return;
            if (healIfDropped()) return;
            // Re-measure the natural height from scrollHeight before placing.
            // scrollHeight reports the full content height even while the panel is
            // currently clamped and scrolling (unlike offsetHeight, which would
            // read the capped box back) — so this is the correct way to notice
            // content that grew or shrank since the last call, without re-running
            // the expensive display:block/height:auto remeasure portalOpen() does.
            // It is a PADDING-box number though, so `borderDelta` converts it to the
            // border box that place() reasons in and that `max-height` caps.
            // Guarded on `!currentAnimation`: mid-tween, `content`'s height is the
            // animation's own transient value, not the settled natural size, so
            // reading it here would feed a wrong number into place(). Width is
            // deliberately left untouched — it's pinned inline on purpose (see
            // naturalSize's declaration above) and never changes after open.
            if (!currentAnimation) naturalSize.height = content.scrollHeight + borderDelta;
            const { placement: placement, top: top, left: left, maxHeight: maxHeight } = (0, $9197b43f210216fc$export$d4d5bf0e1681e4da)({
                anchor: toggle.getBoundingClientRect(),
                panel: naturalSize,
                viewport: $2c2f6f8f0bea0e6b$var$viewportBox(),
                gap: $2c2f6f8f0bea0e6b$var$GAP_PX,
                inset: $2c2f6f8f0bea0e6b$var$INSET_PX
            });
            content.style.top = `${top}px`;
            content.style.left = `${left}px`;
            // Anchor the scale/slide at the toggle, whichever side we landed on.
            content.style.transformOrigin = placement === "bottom" ? "top" : "bottom";
            wrap.setAttribute("data-dropdown-placement", placement);
            content.setAttribute("data-dropdown-placement", placement);
            clamped = maxHeight < naturalSize.height;
            // Write `max-height` ONLY when it actually clamps, and clear it
            // otherwise. Two reasons, both about the unclamped path — the common
            // one, on every open, on every portal browser:
            //   - Pre-portal there was no max-height at all. Writing one caps the
            //     panel at a number we computed, so any measurement error shows up
            //     as a permanently short panel. Clearing it lets layout decide.
            //   - An authored `max-height` on the panel's own Webflow class would
            //     otherwise be overridden on every open, which breaks the
            //     docstring's "style with whatever classes you want" promise the
            //     same way the old :popover-open reset did.
            // The clamped write still wins over an authored max-height, on purpose:
            // there genuinely isn't room, and scrolling inside the panel beats
            // spilling out of the viewport.
            content.style.maxHeight = clamped ? `${maxHeight}px` : "";
            if (clamped) gutterReserved = true;
            // Keep the RESTING overflow in sync with `clamped` (and, once latched,
            // `gutterReserved`) even after the panel has settled open. reposition()
            // is the only place either can change post-settle (the tracking loop
            // calls it on scroll/resize/sheet-drag, and the ResizeObserver calls it
            // on content-driven height changes), so it's the single correct place
            // to react to that change too — anywhere else would mean re-deriving
            // "did clamped change" from scratch.
            // Guarded on `!currentAnimation` so this never fights animateTo's own
            // `overflow: hidden`, which owns the property for the ~200ms tween; the
            // tween's onDone callback sets the resting value once currentAnimation
            // is already null, so there's no gap where both would try to write it.
            if (!currentAnimation) content.style.overflow = restingOverflow();
            return maxHeight;
        };
        // Measures in normal flow, hands the panel to the top layer, positions it.
        // Returns the height the open tween should animate to.
        //
        // The measure-first order matters: Webflow may author the panel's width as
        // a percentage of .explorer_filter_dropdown, and once the panel is fixed
        // that percentage would resolve against the viewport instead. So we read
        // the width while the cascade still resolves it correctly, then pin it.
        const portalOpen = ()=>{
            content.style.visibility = "hidden";
            content.style.display = "block";
            content.style.height = "auto";
            content.style.maxHeight = "none";
            // offsetHeight, not scrollHeight: `max-height: none` means nothing is
            // overflowing, so this IS the natural size — and it is the border box,
            // which is the unit place() compares against viewport space and the unit
            // an eventual `max-height` caps.
            naturalSize = {
                width: content.offsetWidth,
                height: content.offsetHeight
            };
            borderDelta = content.offsetHeight - content.clientHeight;
            // Clearing inline display hands visibility back to the UA's
            // [popover]:not(:popover-open) rule, so showPopover() takes effect.
            content.style.display = "";
            content.style.visibility = "";
            if (!content.matches(":popover-open")) content.showPopover();
            content.style.width = `${naturalSize.width}px`;
            // `?? naturalSize.height` is belt-and-braces: open() sets aria-expanded
            // before calling this, so reposition()'s isOpen() guard always passes.
            const maxHeight = reposition() ?? naturalSize.height;
            // Tween to the CLAMPED height. Animating to the natural height under a
            // smaller max-height would render as an instant jump, not an animation.
            return Math.min(naturalSize.height, maxHeight);
        };
        // Undoes portalOpen. Leaves the tween's own inline state to
        // clearInlineState().
        const portalClose = ()=>{
            if (!$2c2f6f8f0bea0e6b$var$CAN_PORTAL) return;
            if (content.matches(":popover-open")) content.hidePopover();
            content.style.width = "";
            content.style.top = "";
            content.style.left = "";
            content.style.maxHeight = "";
            content.style.transformOrigin = "top";
            wrap.removeAttribute("data-dropdown-placement");
            content.removeAttribute("data-dropdown-placement");
        };
        // Snapshot whatever the in-flight animation is currently rendering, commit
        // those values to inline style, then cancel — lets the next animation
        // resume from the visible state instead of snapping to a default.
        const snapshotAndStop = ()=>{
            if (!currentAnimation) return null;
            try {
                currentAnimation.commitStyles();
            } catch (_) {
            /* commitStyles fails if the element is detached — ignore */ }
            currentAnimation.cancel();
            currentAnimation = null;
            return {
                height: parseFloat(content.style.height) || 0,
                opacity: content.style.opacity || $2c2f6f8f0bea0e6b$var$OPEN_OPACITY,
                transform: content.style.transform || $2c2f6f8f0bea0e6b$var$OPEN_TRANSFORM
            };
        };
        const animateTo = (from, to, onDone)=>{
            // Clip during the animation only — children that should overflow
            // (submenus, focus rings) need to escape once the dropdown is open.
            content.style.overflow = "hidden";
            // Inline-style the from state so a mid-flight cancel reverts cleanly.
            content.style.height = `${from.height}px`;
            content.style.opacity = from.opacity;
            content.style.transform = from.transform;
            const anim = content.animate([
                {
                    height: `${from.height}px`,
                    opacity: from.opacity,
                    transform: from.transform
                },
                {
                    height: `${to.height}px`,
                    opacity: to.opacity,
                    transform: to.transform
                }
            ], {
                duration: $2c2f6f8f0bea0e6b$var$DURATION_MS,
                easing: $2c2f6f8f0bea0e6b$var$EASING,
                fill: "forwards"
            });
            currentAnimation = anim;
            anim.onfinish = ()=>{
                if (currentAnimation !== anim) return;
                currentAnimation = null;
                onDone();
                // Release the forwards fill so the element renders from inline+cascade
                // again — otherwise height stays locked to the value measured at
                // animation start, clipping any content that grew afterward.
                anim.cancel();
            };
        };
        const clearInlineState = ()=>{
            content.style.height = "";
            content.style.opacity = "";
            content.style.transform = "";
        };
        const open = ()=>{
            if (isOpen()) return;
            // Fresh open, fresh gutter-freeze latch — a panel that clamped on a
            // previous open must not start this one with the gutter already
            // reserved.
            gutterReserved = false;
            // Only one dropdown open at a time — sidesteps z-index conflicts when
            // two open menus would otherwise stack by document order.
            if ($2c2f6f8f0bea0e6b$var$activeDropdown && $2c2f6f8f0bea0e6b$var$activeDropdown.wrap !== wrap) $2c2f6f8f0bea0e6b$var$activeDropdown.close();
            // Lift above any peer that's still animating closed so it can't
            // overlap visually during the parallel close/open.
            $2c2f6f8f0bea0e6b$var$zCounter += 1;
            wrap.style.zIndex = String($2c2f6f8f0bea0e6b$var$Z_BASE + $2c2f6f8f0bea0e6b$var$zCounter);
            wrap.classList.add("is-active");
            toggle.setAttribute("aria-expanded", "true");
            const from = snapshotAndStop() || {
                height: 0,
                opacity: $2c2f6f8f0bea0e6b$var$CLOSED_OPACITY,
                transform: $2c2f6f8f0bea0e6b$var$CLOSED_TRANSFORM
            };
            let toHeight;
            if ($2c2f6f8f0bea0e6b$var$CAN_PORTAL) toHeight = portalOpen();
            else {
                content.style.display = "block";
                content.style.height = "auto";
                toHeight = content.scrollHeight;
            }
            $2c2f6f8f0bea0e6b$var$activeDropdown = {
                wrap: wrap,
                toggle: toggle,
                content: content,
                close: close,
                reposition: reposition,
                focusableItems: /** @type {HTMLElement[]} */ [
                    ...content.querySelectorAll($2c2f6f8f0bea0e6b$var$FOCUSABLE_ITEM_SELECTOR)
                ]
            };
            $2c2f6f8f0bea0e6b$var$startTracking();
            animateTo(from, {
                height: toHeight,
                opacity: $2c2f6f8f0bea0e6b$var$OPEN_OPACITY,
                transform: $2c2f6f8f0bea0e6b$var$OPEN_TRANSFORM
            }, ()=>{
                clearInlineState();
                // A clamped panel keeps scrolling internally. An unclamped one lets
                // descendants (focus rings, submenus) overflow, as before — unless
                // this open has clamped before, in which case restingOverflow()
                // keeps the gutter reserved (see gutterReserved's declaration).
                content.style.overflow = restingOverflow();
                if ($2c2f6f8f0bea0e6b$var$activeDropdown?.content === content && !healIfDropped()) $2c2f6f8f0bea0e6b$var$observePanel($2c2f6f8f0bea0e6b$var$activeDropdown);
            });
        };
        const close = ()=>{
            if (!isOpen()) return;
            wrap.classList.remove("is-active");
            toggle.setAttribute("aria-expanded", "false");
            // Detach synchronously, not in the tween's callback — a fast reopen would
            // otherwise let the old close's callback tear down the new panel's
            // tracking. Not repositioning during the ~200ms close tween is fine.
            if ($2c2f6f8f0bea0e6b$var$activeDropdown && $2c2f6f8f0bea0e6b$var$activeDropdown.wrap === wrap) {
                $2c2f6f8f0bea0e6b$var$stopTracking();
                $2c2f6f8f0bea0e6b$var$activeDropdown = null;
            }
            const from = snapshotAndStop() || {
                height: content.getBoundingClientRect().height,
                opacity: $2c2f6f8f0bea0e6b$var$OPEN_OPACITY,
                transform: $2c2f6f8f0bea0e6b$var$OPEN_TRANSFORM
            };
            animateTo(from, {
                height: 0,
                opacity: $2c2f6f8f0bea0e6b$var$CLOSED_OPACITY,
                transform: $2c2f6f8f0bea0e6b$var$CLOSED_TRANSFORM
            }, ()=>{
                clearInlineState();
                if ($2c2f6f8f0bea0e6b$var$CAN_PORTAL) portalClose();
                else content.style.display = "none";
                content.style.overflow = "";
                wrap.style.zIndex = "";
                if ($2c2f6f8f0bea0e6b$var$allClosed()) $2c2f6f8f0bea0e6b$var$zCounter = 0;
            });
        };
        toggle.addEventListener("click", ()=>{
            isOpen() ? close() : open();
        });
        if (openOnHoverIn) wrap.addEventListener("mouseenter", open);
        if (closeOnHoverOut) wrap.addEventListener("mouseleave", close);
    });
}
// ── Auto-boot ────────────────────────────────────────────────
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $2c2f6f8f0bea0e6b$export$9d96c354fe36b236, {
    once: true
});
else $2c2f6f8f0bea0e6b$export$9d96c354fe36b236();


/**
 * Variables (Placeholder Replacement)
 *
 * Replaces {{key}} placeholders in text and common attributes across the page.
 * Supports scoped (per-ancestor) and global variables.
 *
 * Two namespaces:
 *   • `$`-prefixed keys (built-in dynamics like {{$year}}) resolve only
 *     against the module-level globals map — never the ancestor chain.
 *   • Everything else: nearest ancestor `data-var-{key}` wins, falling
 *     back to a `[data-variable-key]` element anywhere on the page.
 *
 * Unknown keys are left as-is so typos are visible in the published site.
 *
 * Usage in Webflow:
 *
 *   Global values (place anywhere — typically inside a hidden CMS collection):
 *     <div data-variable-key="company-name" data-variable-value="Bruce Studios"></div>
 *     <div data-variable-key="phone" data-variable-value="+46 31 ..."></div>
 *
 *   Scoped values — must use the data-var-* prefix so generic Webflow data
 *   attributes (data-loop, data-src, ...) can't collide with placeholders:
 *     <div data-var-author-name="Johan Andersson">
 *       <p>{{author-name}}</p>  →  Johan Andersson
 *     </div>
 *
 *   Built-in dynamics — reserved `$` prefix isolates them from user keys:
 *     <p>© {{$year}}</p>
 *
 *   Anywhere in text content:
 *     <p>Welcome to {{company-name}}. © {{$year}}</p>
 *
 *   In attributes (href, src, alt, title, aria-label, placeholder, value):
 *     <a href="mailto:{{email}}">Contact</a>
 *
 * Handles late-arriving content (async / CMS injection) via a
 * debounced re-scan + delayed safety passes.
 *
 * Loaded globally — no external dependencies.
 */ // ── Module-level constants ───────────────────────────────────
// Keys allow `$` so built-in dynamics like {{$year}} live in a reserved
// namespace that can't be shadowed by CMS-defined variables.
// PATTERN is `/g` (used by String.replace); HAS_PATTERN is the same expression
// without `/g` for stateless `.test()` checks — calling `.test()` on a `/g`
// regex advances lastIndex and can return inconsistent results across calls.
const $efca945ce4efb95c$var$PATTERN = /\{\{\s*([\$\w-]+)\s*\}\}/g;
const $efca945ce4efb95c$var$HAS_PATTERN = /\{\{\s*[\$\w-]+\s*\}\}/;
const $efca945ce4efb95c$var$BUILTIN_PREFIX = "$";
const $efca945ce4efb95c$var$ATTRS = [
    "href",
    "src",
    "alt",
    "title",
    "aria-label",
    "placeholder",
    "value"
];
const $efca945ce4efb95c$var$ATTR_SELECTOR = $efca945ce4efb95c$var$ATTRS.map((a)=>`[${a}*="{{"]`).join(",");
const $efca945ce4efb95c$var$SAFETY_PASS_DELAYS = [
    500,
    1500,
    3500
]; // ms
// Globals are seeded with `$`-prefixed built-ins so user-defined CMS keys
// can never shadow them. Populated further from [data-variable-key] on each
// pass to catch late-loaded items.
/** @type {Record<string, string>} */ const $efca945ce4efb95c$var$globals = {
    $year: String(new Date().getFullYear())
};
// Originals of text nodes and attributes that ever contained {{...}}. process()
// always substitutes from the stored template, never from the current value —
// so calling setGlobal() after the first pass actually re-renders. Without
// this, the first pass would overwrite the placeholders and any subsequent
// re-scan would find nothing to replace.
/** @type {WeakMap<Text, string>} */ const $efca945ce4efb95c$var$textTemplates = new WeakMap();
/** @type {Map<Element, Record<string, string>>} */ const $efca945ce4efb95c$var$attrTemplates = new Map();
/**
 * Load global key/value pairs from any [data-variable-key] element on
 * the page. Idempotent — re-runs on each pass to catch late-loaded items.
 */ function $efca945ce4efb95c$var$loadGlobals() {
    document.querySelectorAll("[data-variable-key]").forEach((el)=>{
        const key = el.getAttribute("data-variable-key");
        const value = el.getAttribute("data-variable-value");
        // First definition wins. Built-ins ($-prefixed) are seeded first so they
        // can't be silently replaced by a CMS item with the same key.
        if (key && !(key in $efca945ce4efb95c$var$globals)) $efca945ce4efb95c$var$globals[key] = value ?? "";
    });
}
/**
 * Resolve a {{key}} reference against scoped + global sources.
 *
 * Reserved-prefix keys (starting with `$`) are built-ins and bypass the
 * ancestor walk — they only resolve against the globals map.
 *
 * @param {string} key
 * @param {Node} node
 * @returns {string | null} The replacement value, or null if unresolved.
 */ function $efca945ce4efb95c$var$resolve(key, node) {
    if (key.startsWith($efca945ce4efb95c$var$BUILTIN_PREFIX)) return key in $efca945ce4efb95c$var$globals ? $efca945ce4efb95c$var$globals[key] : null;
    const scopedAttr = `data-var-${key}`;
    /** @type {Element | null} */ let el = node.nodeType === 1 ? /** @type {Element} */ node : node.parentElement;
    while(el){
        if (el.hasAttribute(scopedAttr)) return el.getAttribute(scopedAttr) ?? "";
        el = el.parentElement;
    }
    return key in $efca945ce4efb95c$var$globals ? $efca945ce4efb95c$var$globals[key] : null;
}
/**
 * Build a replacer function bound to a specific node for scope resolution.
 *
 * @param {Node} node
 * @returns {(match: string, key: string) => string}
 */ function $efca945ce4efb95c$var$replacer(node) {
    return (match, key)=>{
        const value = $efca945ce4efb95c$var$resolve(key, node);
        return value !== null ? value : match; // leave unresolved keys visible
    };
}
// ── Core processing ──────────────────────────────────────────
/**
 * Scan the entire document body and replace any {{key}} placeholders found.
 * Idempotent: nothing without {{...}} is touched, so multiple passes are safe.
 *
 * Always scans from document.body rather than from MutationObserver-supplied
 * subtrees — CMS rendering often inserts a parent container, then populates its
 * children in subsequent mutations. A full-body scan sidesteps that race.
 */ function $efca945ce4efb95c$var$process() {
    // Accept a text node if it currently contains {{...}} (first-pass discovery)
    // OR if it's already tracked (so we revisit it on every re-scan to honour
    // updated globals — without this, a re-scan after substitution would skip
    // the node and setGlobal() couldn't reactively update the page).
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
        acceptNode: (n)=>{
            const tn = /** @type {Text} */ n;
            return $efca945ce4efb95c$var$HAS_PATTERN.test(n.nodeValue || "") || $efca945ce4efb95c$var$textTemplates.has(tn) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
        }
    });
    /** @type {Text[]} */ const textNodes = [];
    let n;
    while(n = walker.nextNode())textNodes.push(/** @type {Text} */ n);
    for (const tn of textNodes){
        let tmpl = $efca945ce4efb95c$var$textTemplates.get(tn);
        if (tmpl === undefined) {
            tmpl = tn.nodeValue || "";
            $efca945ce4efb95c$var$textTemplates.set(tn, tmpl);
        }
        const next = tmpl.replace($efca945ce4efb95c$var$PATTERN, $efca945ce4efb95c$var$replacer(tn));
        if (next !== tn.nodeValue) tn.nodeValue = next;
    }
    // Attribute scan: union of elements that currently contain `{{` (first-pass
    // discovery) with elements we've previously tracked (so re-scans pick them
    // up after their attribute has been substituted and no longer matches the
    // `[attr*="{{"]` selector).
    /** @type {Set<Element>} */ const elementsToProcess = new Set(document.querySelectorAll($efca945ce4efb95c$var$ATTR_SELECTOR));
    for (const el of $efca945ce4efb95c$var$attrTemplates.keys())elementsToProcess.add(el);
    for (const el of elementsToProcess){
        let originals = $efca945ce4efb95c$var$attrTemplates.get(el);
        for (const attr of $efca945ce4efb95c$var$ATTRS){
            const cur = el.getAttribute(attr);
            if (cur === null) continue;
            if (!originals || !(attr in originals)) {
                if (!cur.includes("{{")) continue;
                if (!originals) {
                    originals = {};
                    $efca945ce4efb95c$var$attrTemplates.set(el, originals);
                }
                originals[attr] = cur;
            }
            const next = originals[attr].replace($efca945ce4efb95c$var$PATTERN, $efca945ce4efb95c$var$replacer(el));
            if (next !== cur) el.setAttribute(attr, next);
        }
    }
}
// ── Debounced re-process ─────────────────────────────────────
// Any relevant DOM change schedules a single rAF-deferred re-scan, so a
// burst of CMS mutations triggers one pass instead of N. `dirty` lets
// the safety-pass timers skip their work on pages that have settled.
let $efca945ce4efb95c$var$pendingRafId = 0;
let $efca945ce4efb95c$var$dirty = false;
const $efca945ce4efb95c$var$runProcess = ()=>{
    $efca945ce4efb95c$var$loadGlobals(); // in case the globals list itself was CMS-rendered
    $efca945ce4efb95c$var$process();
    $efca945ce4efb95c$var$dirty = false;
};
const $efca945ce4efb95c$var$scheduleProcess = ()=>{
    $efca945ce4efb95c$var$dirty = true;
    if ($efca945ce4efb95c$var$pendingRafId) return;
    $efca945ce4efb95c$var$pendingRafId = requestAnimationFrame(()=>{
        $efca945ce4efb95c$var$pendingRafId = 0;
        $efca945ce4efb95c$var$runProcess();
    });
};
/**
 * Cheap pre-filter for the MutationObserver: only re-process if the added
 * subtree could plausibly affect placeholder resolution. Skips the constant
 * DOM churn from sliders, tabs, video players, etc.
 *
 * @param {Node} node
 */ function $efca945ce4efb95c$var$subtreeIsRelevant(node) {
    if (node.nodeType === 3) return (node.nodeValue || "").includes("{{");
    if (node.nodeType !== 1) return false;
    const el = /** @type {Element} */ node;
    // Text-content placeholders are the common case.
    if ((el.textContent || "").includes("{{")) return true;
    // Attribute placeholders + new [data-variable-key] definitions are rarer
    // but possible — one CSS engine call each.
    if (el.matches($efca945ce4efb95c$var$ATTR_SELECTOR) || el.querySelector($efca945ce4efb95c$var$ATTR_SELECTOR)) return true;
    if (el.matches("[data-variable-key]") || el.querySelector("[data-variable-key]")) return true;
    return false;
}
function $efca945ce4efb95c$export$9dd695d235d663a7() {
    $efca945ce4efb95c$var$runProcess();
}
function $efca945ce4efb95c$export$af1d5fec79261cf2() {
    $efca945ce4efb95c$var$scheduleProcess();
}
function $efca945ce4efb95c$export$5918c53cd9b66b1f(key, value) {
    $efca945ce4efb95c$var$globals[key] = value;
    $efca945ce4efb95c$var$scheduleProcess();
}
// ── MutationObserver: catch late-arriving content ────────────
const $efca945ce4efb95c$var$mutationObserver = new MutationObserver((mutations)=>{
    for (const m of mutations){
        for (const node of m.addedNodes)if ($efca945ce4efb95c$var$subtreeIsRelevant(node)) {
            $efca945ce4efb95c$var$scheduleProcess();
            return;
        }
    }
});
// ── Auto-boot ────────────────────────────────────────────────
const $efca945ce4efb95c$var$boot = ()=>{
    $efca945ce4efb95c$export$9dd695d235d663a7();
    $efca945ce4efb95c$var$mutationObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
    $efca945ce4efb95c$var$SAFETY_PASS_DELAYS.forEach((ms)=>setTimeout(()=>{
            if ($efca945ce4efb95c$var$dirty) $efca945ce4efb95c$var$runProcess();
        }, ms));
};
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $efca945ce4efb95c$var$boot, {
    once: true
});
else $efca945ce4efb95c$var$boot();


/**
 * City Context
 *
 * Resolves and holds the single active city (or neutral / null), pushes the
 * active city's placeholders into variables.js, and exposes window.bruce.city.
 * The pure resolution + placeholder logic lives in city-resolve.js; this file
 * is the DOM/localStorage/boot shell around it.
 */ /**
 * City Registry
 *
 * Reads the hidden CMS Collection List (`[data-city-list]`) into typed city
 * objects. `cityFromAttrs` is a pure parser (one attribute map → one city)
 * so it is unit-testable without a DOM; `readCityList` is the thin DOM shell.
 *
 * Each city: { slug, name, vars, coords }. `vars` are the `data-city-var-*`
 * values keyed by the suffix; `coords` is [lng, lat] (Mapbox order) parsed
 * from `data-city-var-lat` / `-lng`, or null when either is missing/invalid.
 */ const $09780d2e440fc575$var$VAR_PREFIX = "data-city-var-";
function $09780d2e440fc575$export$39d68bb550e2a0d5(attrs) {
    const slug = (attrs["data-city-slug"] ?? "").trim();
    if (!slug) return null;
    const name = (attrs["data-city-name"] ?? "").trim();
    /** @type {Record<string,string>} */ const vars = {};
    for (const key of Object.keys(attrs)){
        if (!key.startsWith($09780d2e440fc575$var$VAR_PREFIX)) continue;
        vars[key.slice($09780d2e440fc575$var$VAR_PREFIX.length)] = attrs[key];
    }
    const lat = parseFloat(vars.lat);
    const lng = parseFloat(vars.lng);
    const coords = Number.isNaN(lat) || Number.isNaN(lng) ? null : [
        lng,
        lat
    ];
    return {
        slug: slug,
        name: name,
        vars: vars,
        coords: coords
    };
}
function $09780d2e440fc575$export$ec021605e6a00ef1() {
    const out = [];
    document.querySelectorAll("[data-city-list] [data-city-slug]").forEach((el)=>{
        /** @type {Record<string,string>} */ const attrs = {};
        for (const a of el.attributes)attrs[a.name] = a.value;
        const city = $09780d2e440fc575$export$39d68bb550e2a0d5(attrs);
        if (city) out.push(city);
    });
    return out;
}



/**
 * City Resolve — pure helpers for city-context.js
 *
 * Framework-free (no DOM, no imports) so the resolution chain and placeholder
 * mapping are unit-testable in Node. The DOM/localStorage shell and public API
 * live in city-context.js, which imports these. (Same split pattern as
 * city-visibility-decide.js ↔ city-visibility.js.)
 *
 * Active-city authority, highest first: URL lock → ?city= param → saved
 * preference → neutral. There is no implicit default — neutral is a real,
 * resolved state.
 */ /**
 * Decide the active city and whether to seed the saved preference.
 *
 * A valid URL lock persists: it always seeds the saved preference, so
 * navigating to a city page (the same act as clicking a switcher) sticks. The
 * ?city= param stays transient (never seeds) — a shared/ad link previews a city
 * without re-homing someone who already chose one.
 *
 * @param {{lock: string|null, param: string|null, saved: string|null}} inputs
 * @param {Array<{slug: string}>} cities
 * @returns {{active: string|null, seedPreference: string|null}}
 */ function $22caa12693408ecc$export$3ccf1bf91bf0ae12({ lock: lock, param: param, saved: saved }, cities) {
    const has = (s)=>!!s && cities.some((c)=>c.slug === s);
    if (has(lock)) return {
        active: lock,
        seedPreference: lock
    };
    if (has(param)) return {
        active: param,
        seedPreference: null
    };
    if (has(saved)) return {
        active: saved,
        seedPreference: null
    };
    return {
        active: null,
        seedPreference: null
    };
}
function $22caa12693408ecc$export$e2bc75b27c220590(activeCity, knownVarKeys) {
    /** @type {Record<string,string>} */ const out = {
        city: activeCity ? activeCity.slug : "",
        "city-name": activeCity ? activeCity.name : ""
    };
    for (const key of knownVarKeys)out[key] = activeCity ? activeCity.vars[key] ?? "" : "";
    return out;
}


const $ad58cec2bfe54d54$var$STORAGE_KEY = "bruce-city";
const $ad58cec2bfe54d54$var$SAFETY_PASS_DELAYS = [
    500,
    1500,
    3500
];
// ── State ────────────────────────────────────────────────────
/** @type {Array<ReturnType<import("./city-registry.js").cityFromAttrs>>} */ let $ad58cec2bfe54d54$var$cities = [];
/** @type {Set<string>} */ let $ad58cec2bfe54d54$var$knownVarKeys = new Set();
/** @type {string | null} */ let $ad58cec2bfe54d54$var$current = null;
/** @type {boolean} — true once the chain has run at least once */ let $ad58cec2bfe54d54$var$resolved = false;
/** @type {Set<(slug: string|null) => void>} */ const $ad58cec2bfe54d54$var$listeners = new Set();
const $ad58cec2bfe54d54$var$cityBySlug = (slug)=>$ad58cec2bfe54d54$var$cities.find((c)=>c.slug === slug) ?? null;
// ── Inputs (DOM / URL / storage) ─────────────────────────────
function $ad58cec2bfe54d54$var$readLock() {
    const v = document.body?.dataset.cityLock?.trim();
    return v || null;
}
function $ad58cec2bfe54d54$var$readParam() {
    const sp = new URLSearchParams(location.search);
    const v = (sp.get("city") ?? "").trim();
    return v || null;
}
function $ad58cec2bfe54d54$var$readSaved() {
    try {
        return localStorage.getItem($ad58cec2bfe54d54$var$STORAGE_KEY);
    } catch  {
        return null; // private mode / strict cookie policy
    }
}
function $ad58cec2bfe54d54$var$writeSaved(slug) {
    try {
        if (slug === null) localStorage.removeItem($ad58cec2bfe54d54$var$STORAGE_KEY);
        else localStorage.setItem($ad58cec2bfe54d54$var$STORAGE_KEY, slug);
    } catch  {
    // best-effort
    }
}
// ── Apply ────────────────────────────────────────────────────
// Push placeholders into variables.js and notify subscribers. `force` makes
// the initial resolution notify even when the slug did not change (neutral
// page: null → null) so the visibility module can reveal data-city-none.
function $ad58cec2bfe54d54$var$apply(active, { force: force = false } = {}) {
    const changed = active !== $ad58cec2bfe54d54$var$current;
    $ad58cec2bfe54d54$var$current = active;
    const placeholders = (0, $22caa12693408ecc$export$e2bc75b27c220590)($ad58cec2bfe54d54$var$cityBySlug(active), $ad58cec2bfe54d54$var$knownVarKeys);
    for (const key of Object.keys(placeholders))(0, $efca945ce4efb95c$export$5918c53cd9b66b1f)(key, placeholders[key]);
    if (changed || force) $ad58cec2bfe54d54$var$listeners.forEach((fn)=>{
        try {
            fn(active);
        } catch (err) {
            console.error("[bruce.city] onChange listener threw", err);
        }
    });
}
// ── Resolve ──────────────────────────────────────────────────
/** Re-read the CMS registry (it may render late) and the var-key union. */ function $ad58cec2bfe54d54$var$readRegistry() {
    $ad58cec2bfe54d54$var$cities = (0, $09780d2e440fc575$export$ec021605e6a00ef1)();
    $ad58cec2bfe54d54$var$knownVarKeys = new Set();
    for (const c of $ad58cec2bfe54d54$var$cities)for (const k of Object.keys(c.vars))$ad58cec2bfe54d54$var$knownVarKeys.add(k);
}
// Idempotent. Re-reads the registry, runs the chain, seeds the preference if
// applicable, applies.
function $ad58cec2bfe54d54$var$resolve({ force: force = false } = {}) {
    $ad58cec2bfe54d54$var$readRegistry();
    if ($ad58cec2bfe54d54$var$cities.length === 0) return; // nothing to resolve yet; safety pass retries
    const lock = $ad58cec2bfe54d54$var$readLock();
    const saved = $ad58cec2bfe54d54$var$readSaved();
    const { active: active, seedPreference: seedPreference } = (0, $22caa12693408ecc$export$3ccf1bf91bf0ae12)({
        lock: lock,
        param: $ad58cec2bfe54d54$var$readParam(),
        saved: saved
    }, $ad58cec2bfe54d54$var$cities);
    if (seedPreference) $ad58cec2bfe54d54$var$writeSaved(seedPreference);
    const firstResolve = !$ad58cec2bfe54d54$var$resolved;
    $ad58cec2bfe54d54$var$resolved = true;
    $ad58cec2bfe54d54$var$apply(active, {
        force: force || firstResolve
    });
}
// ── Public API ───────────────────────────────────────────────
const $ad58cec2bfe54d54$var$api = {
    get () {
        return $ad58cec2bfe54d54$var$current;
    },
    isNeutral () {
        return $ad58cec2bfe54d54$var$current === null;
    },
    /** @param {string} slug  "" resets to neutral */ set (slug) {
        const next = slug === "" ? null : slug;
        if (next !== null && !$ad58cec2bfe54d54$var$cityBySlug(next)) // The CMS registry can render after boot, leaving `cities` empty. Re-read
        // before rejecting, so a pick made in that window (a gateway picker card
        // clicked before the first safety pass) is not silently dropped.
        $ad58cec2bfe54d54$var$readRegistry();
        if (next !== null && !$ad58cec2bfe54d54$var$cityBySlug(next)) {
            console.warn(`[bruce.city] unknown city "${slug}" \u{2014} ignoring`);
            return;
        }
        $ad58cec2bfe54d54$var$writeSaved(next);
        $ad58cec2bfe54d54$var$apply(next);
    },
    all () {
        return $ad58cec2bfe54d54$var$cities.map((c)=>({
                ...c,
                vars: {
                    ...c.vars
                }
            }));
    },
    /**
   * Subscribe to active-city changes. If the chain has already resolved, the
   * callback fires immediately with the current value so late subscribers
   * (import order) never miss the initial resolution.
   * @param {(slug: string|null) => void} fn
   */ onChange (fn) {
        $ad58cec2bfe54d54$var$listeners.add(fn);
        if ($ad58cec2bfe54d54$var$resolved) try {
            fn($ad58cec2bfe54d54$var$current);
        } catch (err) {
            console.error("[bruce.city] onChange listener threw", err);
        }
        return ()=>$ad58cec2bfe54d54$var$listeners.delete(fn);
    }
};
/** @type {any} */ window.bruce ||= {};
/** @type {any} */ window.bruce.city = $ad58cec2bfe54d54$var$api;
// ── Boot ─────────────────────────────────────────────────────
const $ad58cec2bfe54d54$var$boot = ()=>{
    $ad58cec2bfe54d54$var$resolve();
    $ad58cec2bfe54d54$var$SAFETY_PASS_DELAYS.forEach((ms)=>setTimeout(()=>{
            // Re-resolve until the registry has loaded; once resolved, a later pass
            // is a cheap no-op unless cities/inputs changed.
            $ad58cec2bfe54d54$var$resolve();
        }, ms));
};
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $ad58cec2bfe54d54$var$boot, {
    once: true
});
else $ad58cec2bfe54d54$var$boot();


/**
 * City Visibility
 *
 * Toggles elements marked with one of four attributes based on the active
 * city resolved by src/city-context.js:
 *   data-city-show="<slug-or-name>[,...]"   visible only for those cities
 *   data-city-hide="<slug-or-name>[,...]"   hidden for those cities
 *   data-city-none                          visible only when neutral
 *   data-city-any                           visible only when a city is active
 *
 * ── Required CSS (Webflow site-wide custom code, set up once) ─────
 *   .is-city-hidden { display: none !important; }
 *   html:not(.wf-design-mode) body:not(.is-city-ready)
 *     :is([data-city-show],[data-city-hide],[data-city-none],[data-city-any]) {
 *     display: none;
 *   }
 *
 * The !important defeats Webflow class-driven display:flex/grid/block (same
 * external-CSS precedence lesson as the bottom-sheet component). Pre-hide uses
 * display:none to avoid empty flex/grid slots during the boot window.
 *
 * ── Ready flag ────────────────────────────────────────────────────
 * is-city-ready is set after the first sweep that runs from a *resolved*
 * context. city-context fires onChange once on initial resolution — even for a
 * neutral (null) result — and replays it to late subscribers, so a neutral
 * page still reveals its data-city-none content. If the context never resolves
 * (registry missing) the flag stays unset and only generic content shows
 * (fail-closed neutral baseline).
 *
 * Late inserts (dynamic CMS) are caught by a narrow MutationObserver and
 * safety-pass timers at [500, 1500, 3500] ms.
 */ /**
 * Pure decision helper for city-visibility.js. Framework-free (no DOM, no
 * globals) so the "is this element visible in the active city" rules live in
 * one unit-testable place.
 *
 * Four independent attributes, AND-combined (an element typically carries
 * exactly one):
 *   show="a,b"  visible when active ∈ {a,b}
 *   hide="a,b"  hidden when active ∈ {a,b}  (so: visible otherwise, incl. neutral)
 *   none        visible only when active is null (neutral)
 *   any         visible only when active is non-null
 *
 * `activeSlug === null` means NEUTRAL — a real resolved state, not pre-boot.
 * (Pre-boot hiding is the CSS pre-hide rule's job, gated on is-city-ready.)
 *
 * show/hide values: comma-separated, trimmed, case-insensitive against both
 * city.slug and city.name. Empty/whitespace value is a no-op (no constraint).
 * Tokens matching no city are collected in `unknownValues` so the caller can
 * warn once per value; an unknown token never satisfies a `show`.
 *
 * @param {{show: string|null, hide: string|null, none: boolean, any: boolean}} attrs
 * @param {string | null} activeSlug
 * @param {Array<{slug: string, name: string}>} cities
 * @returns {{ visible: boolean, unknownValues: string[] }}
 */ function $92d42c78aa88cb50$export$120712bcebdf3322(attrs, activeSlug, cities) {
    const unknownValues = [];
    const active = activeSlug ? activeSlug.toLowerCase() : null;
    // Returns { count, matched } for a comma list, pushing unknown tokens.
    function evalList(raw) {
        const tokens = (raw ?? "").split(",").map((t)=>t.trim().toLowerCase()).filter(Boolean);
        let matched = false;
        for (const t of tokens){
            const city = cities.find((c)=>c.slug.toLowerCase() === t || c.name.toLowerCase() === t);
            if (!city) {
                unknownValues.push(t);
                continue;
            }
            if (active && city.slug.toLowerCase() === active) matched = true;
        }
        return {
            count: tokens.length,
            matched: matched
        };
    }
    let visible = true;
    if (attrs.show != null) {
        const { count: count, matched: matched } = evalList(attrs.show);
        if (count > 0 && !matched) visible = false;
    }
    if (attrs.hide != null) {
        const { count: count, matched: matched } = evalList(attrs.hide);
        if (count > 0 && matched) visible = false;
    }
    if (attrs.none && active !== null) visible = false;
    if (attrs.any && active === null) visible = false;
    return {
        visible: visible,
        unknownValues: unknownValues
    };
}


const $5e08841b7818cf19$var$SELECTOR = "[data-city-show],[data-city-hide],[data-city-none],[data-city-any]";
const $5e08841b7818cf19$var$HIDE_CLASS = "is-city-hidden";
const $5e08841b7818cf19$var$READY_CLASS = "is-city-ready";
const $5e08841b7818cf19$var$SAFETY_PASS_DELAYS = [
    500,
    1500,
    3500
];
/** Dedupe warnings: one per (attr value, unknown token). */ const $5e08841b7818cf19$var$warnedValues = new Set();
function $5e08841b7818cf19$var$readAttrs(el) {
    return {
        show: el.getAttribute("data-city-show"),
        hide: el.getAttribute("data-city-hide"),
        none: el.hasAttribute("data-city-none"),
        any: el.hasAttribute("data-city-any")
    };
}
function $5e08841b7818cf19$var$applyVisibility(el, activeSlug, cities) {
    const attrs = $5e08841b7818cf19$var$readAttrs(el);
    const { visible: visible, unknownValues: unknownValues } = (0, $92d42c78aa88cb50$export$120712bcebdf3322)(attrs, activeSlug, cities);
    el.classList.toggle($5e08841b7818cf19$var$HIDE_CLASS, !visible);
    for (const v of unknownValues){
        const key = `${attrs.show ?? ""}|${attrs.hide ?? ""}|${v}`;
        if ($5e08841b7818cf19$var$warnedValues.has(key)) continue;
        $5e08841b7818cf19$var$warnedValues.add(key);
        console.warn(`[bruce.city-visibility] value "${v}" matched no known city.`, "Known cities:", cities.map((c)=>({
                slug: c.slug,
                name: c.name
            })));
    }
}
let $5e08841b7818cf19$var$lastResolved = false;
function $5e08841b7818cf19$var$sweep() {
    const cityApi = /** @type {any} */ window.bruce?.city;
    if (!cityApi) return;
    const activeSlug = cityApi.get();
    const cities = cityApi.all();
    document.querySelectorAll($5e08841b7818cf19$var$SELECTOR).forEach((el)=>$5e08841b7818cf19$var$applyVisibility(el, activeSlug, cities));
    // Only flag ready once the context has actually resolved. We learn that via
    // the onChange callback (set lastResolved there); a MutationObserver-driven
    // sweep before resolution must not reveal content.
    if ($5e08841b7818cf19$var$lastResolved) document.body.classList.add($5e08841b7818cf19$var$READY_CLASS);
}
let $5e08841b7818cf19$var$pendingRafId = 0;
const $5e08841b7818cf19$var$scheduleSweep = ()=>{
    if ($5e08841b7818cf19$var$pendingRafId) return;
    $5e08841b7818cf19$var$pendingRafId = requestAnimationFrame(()=>{
        $5e08841b7818cf19$var$pendingRafId = 0;
        $5e08841b7818cf19$var$sweep();
    });
};
const $5e08841b7818cf19$var$observer = new MutationObserver((mutations)=>{
    for (const m of mutations)for (const node of m.addedNodes){
        if (node.nodeType !== 1) continue;
        const el = /** @type {Element} */ node;
        if (el.matches?.($5e08841b7818cf19$var$SELECTOR) || el.querySelector?.($5e08841b7818cf19$var$SELECTOR)) {
            $5e08841b7818cf19$var$scheduleSweep();
            return;
        }
    }
});
const $5e08841b7818cf19$var$boot = ()=>{
    const cityApi = /** @type {any} */ window.bruce?.city;
    // onChange replays the current state immediately if already resolved, so this
    // both handles "resolved before us" and "resolves after us".
    cityApi?.onChange?.(()=>{
        $5e08841b7818cf19$var$lastResolved = true;
        $5e08841b7818cf19$var$sweep();
    });
    $5e08841b7818cf19$var$observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    $5e08841b7818cf19$var$SAFETY_PASS_DELAYS.forEach((ms)=>setTimeout(()=>{
            if (!document.body.classList.contains($5e08841b7818cf19$var$READY_CLASS)) $5e08841b7818cf19$var$sweep();
        }, ms));
};
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $5e08841b7818cf19$var$boot, {
    once: true
});
else $5e08841b7818cf19$var$boot();


/**
 * City Switcher
 *
 * In-place ambient switching on pages without a city URL variant. Any element
 * with `data-set-city="<slug>"` becomes a switcher; `data-set-city=""` resets
 * to neutral. Active switchers are flagged `data-city-active="true"` for
 * styling, kept in sync with the live active city.
 *
 * Switching BETWEEN city pages (e.g. /studios/city/sto → …/cph) does not use
 * this module — those are plain CMS anchor links to each city's page, and the
 * destination page's data-city-lock resolves everything.
 *
 * Delegated listeners cover static + CMS-injected switchers. Keyboard
 * activation is added for non-native triggers (role="button"); native
 * <button>/<a> already fire click on Enter/Space.
 */ function $e4f02777f7cf40b9$var$syncActive(active) {
    document.querySelectorAll("[data-set-city]").forEach((el)=>{
        /** @type {HTMLElement} */ el.dataset.cityActive = el.getAttribute("data-set-city") === (active ?? "") ? "true" : "false";
    });
}
/**
 * Is this click headed somewhere? A switcher can also be a real link — a
 * gateway city-picker card sets the city AND navigates to the destination
 * (e.g. the autumn-campaign gateway → that city's country campaign page,
 * which carries no data-city-lock of its own). Suppressing the default there
 * would strand the visitor on the picker. Hash-only hrefs don't count: those
 * are in-place switchers wearing a link's clothes.
 */ function $e4f02777f7cf40b9$var$navigates(target) {
    const href = /** @type {Element|null} */ target?.closest?.("a[href]")?.getAttribute("href")?.trim();
    return !!href && !href.startsWith("#");
}
function $e4f02777f7cf40b9$var$handle(e) {
    const trigger = /** @type {Element|null} */ e.target?.closest?.("[data-set-city]");
    if (!trigger) return;
    // writeSaved() inside set() is synchronous localStorage, so the pick is
    // durable before the browser unloads the page.
    if (!$e4f02777f7cf40b9$var$navigates(e.target)) e.preventDefault();
    /** @type {any} */ window.bruce?.city?.set(trigger.getAttribute("data-set-city") ?? "");
}
document.addEventListener("click", $e4f02777f7cf40b9$var$handle);
document.addEventListener("keydown", (e)=>{
    if (e.key !== "Enter" && e.key !== " ") return;
    const trigger = /** @type {Element|null} */ e.target?.closest?.("[data-set-city]");
    if (!trigger || trigger.tagName === "BUTTON" || trigger.tagName === "A") return;
    $e4f02777f7cf40b9$var$handle(e);
});
const $e4f02777f7cf40b9$var$boot = ()=>{
    /** @type {any} */ window.bruce?.city?.onChange?.($e4f02777f7cf40b9$var$syncActive);
};
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $e4f02777f7cf40b9$var$boot, {
    once: true
});
else $e4f02777f7cf40b9$var$boot();


/**
 * City Links
 *
 * Auto-resolves plain in-site gateway links (e.g. /memberships, /studios and
 * their localized variants) to the active city's CMS page. Webflow renders the
 * real, fully-localized URLs into hidden source elements; this module copies
 * the right one onto every matching <a>. Pure match/compose logic lives in
 * city-links-plan.js.
 *
 * Source data (rendered in the global component, every page + locale):
 *   [data-city-gateway="<section>"]                  — anchor; localized gateway path
 *   [data-city-link-list="<section>"]                — list wrapper (Collection List or static)
 *     [data-city-link-item][data-city-link-key][href] — key → localized URL
 *   The key is the city slug, unless the wrapper sets data-city-link-by="<var>"
 *   — then it is the active city's data-city-var-<var> value (e.g. terms pages
 *   keyed by country).
 *
 * Opt-out: <a data-city-link-skip> is never rewritten (keeps it pointing at the
 * neutral gateway, e.g. a "Browse all cities" link).
 *
 * Same DOM-shell role as city-context.js; pure logic lives in city-links-plan.js.
 */ /**
 * City Links Plan — pure helpers for city-links.js
 *
 * Framework-free (no DOM, no imports) so the gateway-match and href
 * composition logic is unit-testable in Node. The DOM/WeakMap/boot shell lives
 * in city-links.js. (Same split as city-resolve.js ↔ city-context.js.)
 */ /** Strip a single trailing slash, but keep root "/". */ function $bd5c8a565e071f25$var$normalize(pathname) {
    return pathname.length > 1 && pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
}
function $bd5c8a565e071f25$export$b94e91b4000a52a(pathname, gateways) {
    const p = $bd5c8a565e071f25$var$normalize(pathname);
    for (const section of Object.keys(gateways)){
        if ($bd5c8a565e071f25$var$normalize(gateways[section]) === p) return section;
    }
    return null;
}
/**
 * Case-insensitive lookup in a key → url map. Editors bind keys and city vars
 * from different collections whose codes differ in casing (synced country_code
 * is uppercase, terms keys are lowercase slugs) — a miss here would silently
 * fall back to the gateway, so casing must never matter.
 *
 * @param {Record<string,string>|undefined} m
 * @param {string} key
 * @returns {string|null}
 */ function $bd5c8a565e071f25$var$lookup(m, key) {
    if (!m) return null;
    if (m[key] != null) return m[key];
    const want = key.toLowerCase();
    for (const k of Object.keys(m)){
        if (k.toLowerCase() === want) return m[k];
    }
    return null;
}
function $bd5c8a565e071f25$export$e98df7762080a54d({ section: section, search: search, hash: hash }, { gateways: gateways, linkMap: linkMap, keyBy: keyBy, active: active, activeVars: activeVars }) {
    const by = keyBy?.[section];
    const key = by ? activeVars?.[by] ?? null : active;
    const url = key ? $bd5c8a565e071f25$var$lookup(linkMap[section], key) : null;
    return (url ?? gateways[section] ?? "") + search + hash;
}


const $2a48e4b9d05f5baf$var$SAFETY_PASS_DELAYS = [
    500,
    1500,
    3500
];
/** @type {WeakMap<HTMLAnchorElement, {section: string, search: string, hash: string}>} */ const $2a48e4b9d05f5baf$var$managed = new WeakMap();
// ── Read source data ─────────────────────────────────────────
function $2a48e4b9d05f5baf$var$readGateways() {
    /** @type {Record<string,string>} */ const out = {};
    document.querySelectorAll("[data-city-gateway]").forEach((el)=>{
        const section = el.getAttribute("data-city-gateway")?.trim();
        const href = el.getAttribute("href");
        if (section && href) out[section] = new URL(href, location.origin).pathname;
    });
    return out;
}
function $2a48e4b9d05f5baf$var$readLinkMap() {
    /** @type {Record<string,Record<string,string>>} */ const map = {};
    /** @type {Record<string,string>} */ const keyBy = {};
    document.querySelectorAll("[data-city-link-list]").forEach((list)=>{
        const section = list.getAttribute("data-city-link-list")?.trim();
        if (!section) return;
        const by = list.getAttribute("data-city-link-by")?.trim();
        if (by) keyBy[section] = by;
        const m = map[section] ||= {};
        list.querySelectorAll("[data-city-link-item]").forEach((a)=>{
            const key = a.getAttribute("data-city-link-key")?.trim();
            const href = a.getAttribute("href");
            if (key && href) m[key] = new URL(href, location.origin).pathname;
        });
    });
    return {
        map: map,
        keyBy: keyBy
    };
}
// ── Apply ────────────────────────────────────────────────────
function $2a48e4b9d05f5baf$var$apply(active) {
    const gateways = $2a48e4b9d05f5baf$var$readGateways();
    if (Object.keys(gateways).length === 0) return; // sources not rendered yet
    const { map: linkMap, keyBy: keyBy } = $2a48e4b9d05f5baf$var$readLinkMap();
    const activeCity = active ? /** @type {any} */ window.bruce?.city?.all?.()?.find((c)=>c.slug === active) : null;
    const activeVars = activeCity?.vars ?? null;
    document.querySelectorAll("a[href]").forEach((el)=>{
        const a = /** @type {HTMLAnchorElement} */ el;
        if (a.hasAttribute("data-city-link-skip")) return;
        // Ignore our own source elements (gateway anchors + list items).
        if (a.closest("[data-city-link-list], [data-city-gateway]")) return;
        let entry = $2a48e4b9d05f5baf$var$managed.get(a);
        if (!entry) {
            let url;
            try {
                url = new URL(a.getAttribute("href"), location.origin);
            } catch  {
                return; // non-parseable href (mailto:, tel:, javascript:) — skip
            }
            const section = (0, $bd5c8a565e071f25$export$b94e91b4000a52a)(url.pathname, gateways);
            if (!section) return; // not a gateway link
            entry = {
                section: section,
                search: url.search,
                hash: url.hash
            };
            $2a48e4b9d05f5baf$var$managed.set(a, entry);
        }
        a.setAttribute("href", (0, $bd5c8a565e071f25$export$e98df7762080a54d)(entry, {
            gateways: gateways,
            linkMap: linkMap,
            keyBy: keyBy,
            active: active,
            activeVars: activeVars
        }));
    });
}
// ── Boot ─────────────────────────────────────────────────────
const $2a48e4b9d05f5baf$var$boot = ()=>{
    // onChange fires immediately if the chain has already resolved, and on every
    // later switch. Safety passes re-run apply so late-rendered CMS lists settle.
    /** @type {any} */ window.bruce?.city?.onChange?.($2a48e4b9d05f5baf$var$apply);
    $2a48e4b9d05f5baf$var$SAFETY_PASS_DELAYS.forEach((ms)=>setTimeout(()=>$2a48e4b9d05f5baf$var$apply(/** @type {any} */ window.bruce?.city?.get?.() ?? null), ms));
};
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $2a48e4b9d05f5baf$var$boot, {
    once: true
});
else $2a48e4b9d05f5baf$var$boot();


/**
 * Clean Link Params
 *
 * Strips empty query params from links whose href is assembled in a Webflow
 * code embed (e.g. the Clickable component's signup link). Embeds cannot
 * conditionally include a param, so unset component properties render as
 * `&campaign-code=` — this module removes them client-side on load. Pure
 * logic lives in clean-link-params-plan.js.
 *
 * Markup contract (either attribute on the <a> opts it in):
 *   <a data-bruce-id="…" href="…?tier=gold&campaign-code=">   — existing embed anchors
 *   <a data-clean-params href="…?tier=gold&campaign-code=">   — explicit marker for new embeds
 *
 * Only empty params are removed; the href is otherwise left alone. Links
 * cleaned once are claimed and skipped on later safety passes.
 */ /**
 * Clean Link Params — pure logic
 *
 * A Webflow code embed cannot conditionally include a query param, so unset
 * component properties render as empty params (`&campaign-code=`). This module
 * holds the pure cleanup logic; DOM wiring lives in clean-link-params.js.
 */ /**
 * Remove query params whose value is empty ("" or a bare key without "=").
 *
 * @param {string} href absolute or relative URL
 * @param {string} [base] base for resolving relative hrefs
 * @returns {string|null} cleaned absolute URL, or null when there is nothing
 *   to clean (or the href is unparseable) so the caller can leave the DOM as-is
 */ function $8bd7e689abb53ac0$export$cb9671eef03d01a6(href, base) {
    if (!href || !href.includes("?")) return null;
    let url;
    try {
        url = new URL(href, base);
    } catch  {
        return null;
    }
    const kept = [];
    let dropped = false;
    for (const [key, value] of url.searchParams)if (value === "") dropped = true;
    else kept.push([
        key,
        value
    ]);
    if (!dropped) return null;
    url.search = new URLSearchParams(kept).toString();
    return url.toString();
}


const $befcca4ce6f28325$var$SAFETY_PASS_DELAYS = [
    500,
    1500,
    3500
];
const $befcca4ce6f28325$var$applied = new WeakSet();
function $befcca4ce6f28325$var$cleanLink(link) {
    if ($befcca4ce6f28325$var$applied.has(link)) return;
    $befcca4ce6f28325$var$applied.add(link);
    const href = link.getAttribute("href");
    const cleaned = (0, $8bd7e689abb53ac0$export$cb9671eef03d01a6)(href, location.origin);
    if (cleaned != null) link.setAttribute("href", cleaned);
}
function $befcca4ce6f28325$var$run() {
    document.querySelectorAll("a[data-bruce-id], a[data-clean-params]").forEach($befcca4ce6f28325$var$cleanLink);
}
// ── Boot ─────────────────────────────────────────────────────
const $befcca4ce6f28325$var$boot = ()=>{
    $befcca4ce6f28325$var$run();
    // Safety passes re-scan for late-rendered CMS items; applied elements are no-ops.
    $befcca4ce6f28325$var$SAFETY_PASS_DELAYS.forEach((ms)=>setTimeout($befcca4ce6f28325$var$run, ms));
};
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $befcca4ce6f28325$var$boot, {
    once: true
});
else $befcca4ce6f28325$var$boot();


parcelRequire("dSfL8");
parcelRequire("fxPUT");
/**
 * Intercom Triggers
 *
 * Lets any Webflow button/link open the Intercom Messenger. Intercom's snippet
 * (installed via Site settings → Custom code or the Intercom Webflow app)
 * exposes `window.Intercom`; this module just routes clicks to it.
 *
 * Markup:
 *   <a href="mailto:hello@bruce.app" data-intercom="new-message"
 *      data-intercom-message="Hi! I have a question about…">Chat with us</a>
 *
 * Values for data-intercom:
 *   - "new-message"  open the composer for a NEW conversation
 *                    (data-intercom-message prefills the text — handy for
 *                    giving support context per button)
 *   - "messages"     open the conversations list
 *   - anything else  open the Messenger home
 *
 * Keep a real href (mailto / contact page) as the fallback: if Intercom is
 * blocked (ad-blocker, consent not given) or hasn't loaded, the click falls
 * through to it untouched. The listener is delegated so it survives CMS
 * re-renders and an Intercom script that loads after ours — availability is
 * checked at click time, not at init. Pre-boot, `window.Intercom` is
 * Intercom's queue stub, so calls made early are replayed after boot.
 */ const $1c6ca00b6d92eac4$var$TRIGGER = "[data-intercom]";
document.addEventListener("click", (e)=>{
    const target = /** @type {Element | null} */ e.target;
    const el = target?.closest?.($1c6ca00b6d92eac4$var$TRIGGER);
    if (!el) return;
    const intercom = window.Intercom;
    if (typeof intercom !== "function") return;
    e.preventDefault();
    const action = el.getAttribute("data-intercom");
    if (action === "new-message") {
        const message = el.getAttribute("data-intercom-message") || undefined;
        intercom("showNewMessage", message);
    } else if (action === "messages") intercom("showSpace", "messages");
    else intercom("show");
});


// Explore map — a standalone map section ("Explore studios near you" and
// friends), distinct from explorer.js which powers the per-city list/map page.
//
// The difference that shapes this file: there is no Finsweet list here. The set
// of studios is whatever the hidden CMS collection rendered, fixed at page load,
// so the map renders once and never re-filters. Everything the explorer needs
// for a live list — the state machine, the count display, the filter chrome, the
// bottom-sheet, locate, "search this area" — is absent by design.
//
// The heavy lifting is the shared engine in map-render.js, STATICALLY imported
// and bundled into index.js so the section works on any page the moment it is
// authored — no per-page <script> to remember, and forgetting one can't leave a
// dead map behind. That costs every page ~7.8 kB (index.js 41.6 -> 49.4 kB).
//
// Static is deliberate. Bundling it lazily would mean a dynamic import, parcel
// names async chunks with a content hash, and jsDelivr serves our bundles with
// max-age=604800 — so any later change to map-render.js would 404 the old chunk
// for visitors holding a week-old cached index.js, silently killing the section.
// A static import has no chunk to miss.
//
// The expensive part stays lazy anyway: mapbox-gl (~460 kB) and supercluster are
// only fetched once a section actually approaches the viewport, so a page
// without the section — or with it below the fold — never loads them.
//
// Markup contract:
//   [data-map-element="wrap"]             the section (one renderer per wrap)
//     [data-map-element="target"]         the map container, must have a size
//     [data-map-element="cluster-template"]  OPTIONAL — present enables
//                                         clustering, absent means every studio
//                                         drops its own pin and supercluster is
//                                         never fetched
//     [data-map-element="item"]           each studio (falls back to Webflow's
//                                         .w-dyn-item when not authored)
//   Optional `data-map-lat` / `data-map-lng` on the wrap set the pre-fit
//   center; without them the camera just fits to the studios.
//
// Each item carries its own pin and popup markup via the SAME per-item contract
// the explorer uses ([data-explorer-field="studio-lat|studio-lng|studio-id"],
// [data-explorer-element="studio-marker|studio-popup"]), so one Webflow
// component works in both places with no Designer changes.

var $77YEB = parcelRequire("77YEB");
const $34460f1d1498c24c$var$S = {
    wrap: '[data-map-element="wrap"]',
    target: '[data-map-element="target"]',
    clusterTemplate: '[data-map-element="cluster-template"]',
    item: '[data-map-element="item"]',
    // Webflow's own collection-item class, used when the items carry no explicit
    // hook — the common case when an existing studio card is dropped in as-is.
    fallbackItem: ".w-dyn-item"
};
// How early to start loading. Matches studio.js: enough runway that the map is
// usually ready by the time the section is actually on screen, without loading
// it for someone who never scrolls that far.
const $34460f1d1498c24c$var$PRELOAD_MARGIN = "200px";
// Reads the authored center off the wrap. Both halves must parse; a partial or
// malformed pair is treated as "no center" so the camera just fits the studios.
function $34460f1d1498c24c$var$readCenter(wrap) {
    const lat = parseFloat(wrap.getAttribute("data-map-lat"));
    const lng = parseFloat(wrap.getAttribute("data-map-lng"));
    if (Number.isNaN(lat) || Number.isNaN(lng)) return null;
    return [
        lng,
        lat
    ];
}
function $34460f1d1498c24c$var$readItems(wrap) {
    const authored = [
        ...wrap.querySelectorAll($34460f1d1498c24c$var$S.item)
    ];
    if (authored.length) return authored;
    return [
        ...wrap.querySelectorAll($34460f1d1498c24c$var$S.fallbackItem)
    ];
}
function $34460f1d1498c24c$var$setupExploreMap(wrap) {
    const targetEl = wrap.querySelector($34460f1d1498c24c$var$S.target);
    if (!targetEl) {
        console.warn(`[explore-map] Missing ${$34460f1d1498c24c$var$S.target} \u{2014} nothing to render into.`, wrap);
        return;
    }
    let started = false;
    function start() {
        if (started) return;
        started = true;
        try {
            const items = $34460f1d1498c24c$var$readItems(wrap);
            if (items.length === 0) console.warn(`[explore-map] No ${$34460f1d1498c24c$var$S.item} / ${$34460f1d1498c24c$var$S.fallbackItem} found \u{2014} the map will render empty.`, wrap);
            const renderer = (0, $77YEB.createMapRenderer)({
                targetEl: targetEl,
                // The collection is static, and extractFeatures memoises per element,
                // so re-reading it costs nothing.
                getFeatures: ()=>(0, $77YEB.extractFeatures)(items),
                clusterTemplateEl: wrap.querySelector($34460f1d1498c24c$var$S.clusterTemplate),
                getCenter: ()=>$34460f1d1498c24c$var$readCenter(wrap),
                onReady: ()=>{
                    // Lets CSS hide a placeholder / spinner once the canvas has painted.
                    wrap.dataset.mapReady = "true";
                }
            });
            renderer.ensureMap();
        } catch (err) {
            console.error("[explore-map] failed to start", err);
        }
    }
    // Nothing loads until the section is within a screenful of the viewport.
    const observer = new IntersectionObserver((entries)=>{
        if (!entries.some((e)=>e.isIntersecting)) return;
        observer.disconnect();
        start();
    }, {
        rootMargin: $34460f1d1498c24c$var$PRELOAD_MARGIN
    });
    observer.observe(wrap);
}
function $34460f1d1498c24c$var$init() {
    document.querySelectorAll($34460f1d1498c24c$var$S.wrap).forEach($34460f1d1498c24c$var$setupExploreMap);
}
// Webflow renders CMS collections server-side, so the items are in the DOM by
// DOMContentLoaded — no need to wait for load or for Finsweet.
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $34460f1d1498c24c$var$init, {
    once: true
});
else $34460f1d1498c24c$var$init();


/**
 * Slider Component
 *
 * Swiper-based slider with static CMS flattening. Slides come from
 * server-rendered Webflow Collection Lists and are initialized once at load.
 *
 * Usage in Webflow:
 *   <div data-slider="component">
 *     <div class="slider_element"
 *          data-follow-finger="True|False"   (default True)
 *          data-free-mode="True|False"        (default False)
 *          data-mousewheel="True|False"       (default False)
 *          data-slide-to-clicked="True|False" (default False)
 *          data-centered="True|False"         (default False)
 *          data-loop="True|False"             (default False)
 *          data-speed="600"                   (default 600ms)
 *          data-initial-slide="0"             (default 0)
 *     >
 *       <div class="slider_list">
 *         <!-- slides -->
 *       </div>
 *     </div>
 *     <div class="slider_bullet_list"></div>          (optional pagination)
 *     <div data-slider="next"><button></button></div>  (optional)
 *     <div data-slider="previous"><button></button></div>
 *   </div>
 *
 * Loaded globally — Swiper is loaded via CDN in Site Settings.
 */ 
// ── Module-level constants ───────────────────────────────────
const $4d58ed7a9770d49d$var$SLIDER_SELECTOR = "[data-slider='component']:not([data-slider='component'] [data-slider='component'])";
// ── CMS → Swiper slides (non-destructive) ────────────────────
/**
 * Feed Swiper its slides without destroying the Webflow CMS list.
 *
 * Swiper needs the slides to be direct children of `.slider_list`, but the
 * slides come from a Webflow Collection List nested as
 * `.w-dyn-list > .w-dyn-items > .w-dyn-item > <card>`. An earlier approach
 * hoisted the cards out and DELETED that collection-list shell — which
 * silently corrupted any Finsweet `fs-list` elsewhere on the page: Finsweet
 * enumerates the collection from the live CMS DOM, and removing these nodes
 * made it mis-count and pull the slider's items into the paginated results
 * list (see the studios city pages).
 *
 * Instead we CLONE each card into the wrapper for Swiper to render, and keep
 * the original collection list intact in the DOM — hidden and moved out of
 * the Swiper wrapper — so Finsweet still reads it exactly as authored.
 *
 * @param {HTMLElement} swiperWrapper the `.slider_list`
 * @param {HTMLElement} component the slider component root
 */ function $4d58ed7a9770d49d$var$cloneCMSItemsAsSlides(swiperWrapper, component) {
    const dynList = swiperWrapper.querySelector(".w-dyn-list");
    if (!dynList) return; // static slides — already direct children
    dynList.querySelectorAll(".w-dyn-item").forEach((item)=>{
        const card = [
            ...item.children
        ].find((child)=>!child.classList.contains("w-condition-invisible"));
        if (card) swiperWrapper.appendChild(card.cloneNode(true));
    });
    // Preserve the original list for Finsweet: keep it in the DOM, intact, but
    // out of the Swiper wrapper and hidden so it doesn't render as a stray slide.
    dynList.setAttribute("aria-hidden", "true");
    dynList.style.display = "none";
    component.appendChild(dynList);
}
// ── Init a single slider component ───────────────────────────
/**
 * @param {HTMLElement} component
 */ function $4d58ed7a9770d49d$var$initComponent(component) {
    if (component.dataset.scriptInitialized) return;
    const swiperElement = component.querySelector(".slider_element");
    const swiperWrapper = component.querySelector(".slider_list");
    if (!swiperElement || !swiperWrapper) return;
    // Restructure DOM for Swiper compatibility. Clone CMS items into the wrapper
    // and preserve the original collection list (see cloneCMSItemsAsSlides).
    (0, $e1f0b8fa1ae2171c$export$abb8b833bfa7c79)(swiperWrapper);
    $4d58ed7a9770d49d$var$cloneCMSItemsAsSlides(swiperWrapper, component);
    [
        ...swiperWrapper.children
    ].forEach((el)=>el.classList.add("swiper-slide"));
    const slideCount = swiperWrapper.children.length;
    // Nothing to show — skip empty lists.
    if (slideCount === 0) return;
    // Mark initialized only once we're committed (past the empty-list guard)
    component.dataset.scriptInitialized = "true";
    // ── Read configuration attributes ─────────────────────
    const followFinger = swiperElement.getAttribute("data-follow-finger") !== "False";
    const freeMode = (0, $e1f0b8fa1ae2171c$export$df345a2880184520)(swiperElement, "data-free-mode");
    const mousewheel = (0, $e1f0b8fa1ae2171c$export$df345a2880184520)(swiperElement, "data-mousewheel");
    const slideToClickedSlide = (0, $e1f0b8fa1ae2171c$export$df345a2880184520)(swiperElement, "data-slide-to-clicked");
    const centeredSlides = (0, $e1f0b8fa1ae2171c$export$df345a2880184520)(swiperElement, "data-centered");
    const loop = (0, $e1f0b8fa1ae2171c$export$df345a2880184520)(swiperElement, "data-loop");
    const speed = (0, $e1f0b8fa1ae2171c$export$a802fe75dee3ccae)(swiperElement, "data-speed", 600);
    const initialSlide = Math.min((0, $e1f0b8fa1ae2171c$export$a802fe75dee3ccae)(swiperElement, "data-initial-slide", 0), slideCount - 1);
    // ── Resolve nav + pagination elements ─────────────────
    const paginationEl = component.querySelector(".slider_bullet_list");
    const nextEls = [
        ...component.querySelectorAll("[data-slider='next'] button")
    ];
    const prevEls = [
        ...component.querySelectorAll("[data-slider='previous'] button")
    ];
    // ── Build Swiper instance ─────────────────────────────
    // eslint-disable-next-line no-new
    const swiper = new Swiper(swiperElement, {
        slidesPerView: "auto",
        followFinger: followFinger,
        loop: loop,
        loopAdditionalSlides: loop ? 10 : 0,
        freeMode: freeMode,
        slideToClickedSlide: slideToClickedSlide,
        centeredSlides: centeredSlides,
        centeredSlidesBounds: centeredSlides,
        autoHeight: false,
        initialSlide: initialSlide,
        speed: speed,
        mousewheel: {
            enabled: mousewheel,
            forceToAxis: true
        },
        keyboard: {
            enabled: true,
            onlyInViewport: true
        },
        navigation: nextEls.length && prevEls.length ? {
            nextEl: nextEls,
            prevEl: prevEls
        } : false,
        pagination: paginationEl ? {
            el: paginationEl,
            bulletActiveClass: "is-active",
            bulletClass: "slider_bullet_item",
            bulletElement: "button",
            clickable: true
        } : false,
        slideActiveClass: "is-active",
        slideDuplicateActiveClass: "is-active"
    });
    // Expose for external access (e.g. coordinating with video state)
    /** @type {any} */ component._swiper = swiper;
}
function $4d58ed7a9770d49d$export$528b4520649dcd3a() {
    document.querySelectorAll($4d58ed7a9770d49d$var$SLIDER_SELECTOR).forEach((el)=>{
        $4d58ed7a9770d49d$var$initComponent(/** @type {HTMLElement} */ el);
    });
}
function $4d58ed7a9770d49d$export$25bca1bc22cc4f64(element) {
    if (element && element.matches($4d58ed7a9770d49d$var$SLIDER_SELECTOR)) $4d58ed7a9770d49d$var$initComponent(element);
}
// ── Auto-boot ────────────────────────────────────────────────
// Slider content is static (server-rendered Webflow Collection Lists), so a
// single init at DOMContentLoaded is sufficient.
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $4d58ed7a9770d49d$export$528b4520649dcd3a, {
    once: true
});
else $4d58ed7a9770d49d$export$528b4520649dcd3a();


/**
 * Tab Component
 *
 * Accessible tab pattern with optional autoplay, accordion mode, and
 * static CMS list flattening. No external dependencies.
 *
 * Autoplay drives a `--progress` custom property (0→1) on `.tab_wrap` via
 * requestAnimationFrame, so any CSS keyed off that variable updates each
 * frame. Panel switches and accordion-variant content toggle instantly —
 * style transitions live in CSS, not here.
 *
 * Usage in Webflow:
 *   <div class="tab_wrap"
 *        data-loop-controls="True|False"        (default False)
 *        data-pause-on-hover="True|False"        (default False)
 *        data-autoplay-duration="5"              (seconds; 0 = off)
 *        data-tab-component-id="features"        (optional, for deep linking)
 *   >
 *     <div class="tab_button_list">
 *       <div data-wf--tab-link--variant="default|accordion"
 *            data-tab-item-id="overview">
 *         <button>...</button>
 *         <div data-tab-link-content>...</div>  (accordion variant only)
 *       </div>
 *     </div>
 *     <div class="tab_content_list">
 *       <div>panel content</div>
 *     </div>
 *     <div data-tab="previous"><button></button></div>  (optional)
 *     <div data-tab="next"><button></button></div>       (optional)
 *     <div data-tab-button="toggle"><button></button></div>  (optional autoplay toggle)
 *   </div>
 *
 * Deep linking: ?tab-id=features-overview activates that tab on load.
 */ 
// ── Module-level constants ───────────────────────────────────
const $1f2575536b05084f$var$REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";
// ── Helpers ──────────────────────────────────────────────────
/** @param {string} value */ function $1f2575536b05084f$var$slugify(value) {
    return value.toLowerCase().replaceAll(" ", "-");
}
// ── Init a single tab component ──────────────────────────────
/**
 * @param {HTMLElement} tabWrap
 * @param {number} componentIndex
 */ function $1f2575536b05084f$var$initComponent(tabWrap, componentIndex) {
    if (tabWrap.dataset.scriptInitialized) return;
    // ── Props ──────────────────────────────────────────────
    const loopControls = (0, $e1f0b8fa1ae2171c$export$df345a2880184520)(tabWrap, "data-loop-controls");
    const pauseOnHover = (0, $e1f0b8fa1ae2171c$export$df345a2880184520)(tabWrap, "data-pause-on-hover");
    let autoplay = (0, $e1f0b8fa1ae2171c$export$a802fe75dee3ccae)(tabWrap, "data-autoplay-duration", 0);
    // ── Required DOM ───────────────────────────────────────
    const buttonList = /** @type {HTMLElement | null} */ tabWrap.querySelector(".tab_button_list");
    const panelList = /** @type {HTMLElement | null} */ tabWrap.querySelector(".tab_content_list");
    if (!buttonList || !panelList) {
        console.warn("Tab component missing .tab_button_list or .tab_content_list:", tabWrap);
        return;
    }
    // ── Optional controls ──────────────────────────────────
    const previousButton = /** @type {HTMLButtonElement | null} */ tabWrap.querySelector("[data-tab='previous'] button");
    const nextButton = /** @type {HTMLButtonElement | null} */ tabWrap.querySelector("[data-tab='next'] button");
    const toggleWrap = /** @type {HTMLElement | null} */ tabWrap.querySelector("[data-tab-button='toggle']");
    const toggleButton = /** @type {HTMLButtonElement | null} */ tabWrap.querySelector("[data-tab-button='toggle'] button");
    // ── Restructure DOM ────────────────────────────────────
    (0, $e1f0b8fa1ae2171c$export$abb8b833bfa7c79)(buttonList);
    (0, $e1f0b8fa1ae2171c$export$abb8b833bfa7c79)(panelList);
    (0, $e1f0b8fa1ae2171c$export$20a158e904f6d53d)(buttonList);
    (0, $e1f0b8fa1ae2171c$export$20a158e904f6d53d)(panelList);
    // ── Resolve buttons + wraps ────────────────────────────
    /** @type {HTMLElement[]} */ const buttonItems = Array.from(buttonList.children).map((child)=>/** @type {HTMLElement} */ child.querySelector("button") || child);
    /** @type {HTMLElement[]} */ const buttonWraps = buttonItems.map((btn)=>{
        let wrap = btn;
        while(wrap.parentElement && wrap.parentElement !== buttonList)wrap = wrap.parentElement;
        return wrap;
    });
    // Strip ARIA from wraps (only the inner buttons own the roles)
    buttonWraps.forEach((wrap, i)=>{
        if (wrap !== buttonItems[i]) {
            wrap.removeAttribute("role");
            wrap.removeAttribute("aria-selected");
            wrap.removeAttribute("aria-controls");
            wrap.removeAttribute("tabindex");
        }
    });
    /** @type {HTMLElement[]} */ const panelItems = Array.from(panelList.children).map((c)=>/** @type {HTMLElement} */ c);
    if (!buttonItems.length || !panelItems.length) {
        console.warn("Tab component has no buttons or panels:", tabWrap);
        return;
    }
    // Per-button accordion content slot (null for non-accordion variants).
    /** @type {Array<HTMLElement | null>} */ const accordionContents = buttonWraps.map((wrap)=>{
        if (wrap.getAttribute("data-wf--tab-link--variant") !== "accordion") return null;
        const content = /** @type {HTMLElement | null} */ wrap.querySelector("[data-tab-link-content]");
        if (!content) return null;
        content.style.display = "none";
        return content;
    });
    // ── Initial ARIA setup ─────────────────────────────────
    buttonList.setAttribute("role", "tablist");
    panelList.removeAttribute("role");
    panelItems.forEach((panel)=>{
        panel.style.display = "none";
        panel.setAttribute("role", "tabpanel");
    });
    buttonItems.forEach((btn)=>btn.setAttribute("role", "tab"));
    // ── State ──────────────────────────────────────────────
    let activeIndex = -1;
    /** @type {{play: () => void, pause: () => void, restart: () => void} | null} */ let autoplayTl = null;
    // True when the user has explicitly paused autoplay via the toggle button.
    // (Name reflects intent — `updateAuto` keeps the cycle paused while this is true.)
    let userPaused = true;
    // Mark initialized after DOM restructuring but before behavior wiring
    // (so re-entry calls from MutationObservers bail out)
    tabWrap.dataset.scriptInitialized = "true";
    /**
   * Activate a tab by index.
   *
   * @param {number} index
   * @param {boolean} [focus]
   */ const makeActive = (index, focus = false)=>{
        if (index === activeIndex) return;
        const previousIndex = activeIndex;
        /** @param {number} i @param {boolean} isActive */ const setButtonActive = (i, isActive)=>{
            const btn = buttonItems[i];
            btn.classList.toggle("is-active", isActive);
            if (buttonWraps[i] !== btn) buttonWraps[i].classList.toggle("is-active", isActive);
            btn.setAttribute("aria-selected", isActive ? "true" : "false");
            btn.setAttribute("tabindex", isActive ? "0" : "-1");
            if (accordionContents[i]) btn.setAttribute("aria-expanded", isActive ? "true" : "false");
        };
        // First activation: seed every button into a known state.
        // Subsequent switches: only touch the two indices that changed.
        if (previousIndex === -1) {
            buttonItems.forEach((_, i)=>setButtonActive(i, i === index));
            panelItems.forEach((panel, i)=>panel.classList.toggle("is-active", i === index));
        } else {
            setButtonActive(previousIndex, false);
            setButtonActive(index, true);
            panelItems[previousIndex]?.classList.toggle("is-active", false);
            panelItems[index]?.classList.toggle("is-active", true);
        }
        // Update prev/next disabled state
        if (nextButton) nextButton.disabled = index === buttonItems.length - 1 && !loopControls;
        if (previousButton) previousButton.disabled = index === 0 && !loopControls;
        if (focus) buttonItems[index].focus();
        // Toggle accordion-variant content visibility
        if (previousIndex !== -1 && accordionContents[previousIndex]) /** @type {HTMLElement} */ accordionContents[previousIndex].style.display = "none";
        if (accordionContents[index]) /** @type {HTMLElement} */ accordionContents[index].style.display = "block";
        // Swap panels — instant; any visible transition belongs in CSS
        if (previousIndex !== -1 && panelItems[previousIndex]) panelItems[previousIndex].style.display = "none";
        if (panelItems[index]) panelItems[index].style.display = "block";
        // Reset autoplay progress on user-driven changes — clicking a tab restarts
        // the timer for the new tab. `userPaused` blocks the restart so a cycle
        // the user has explicitly paused stays paused.
        if (autoplayTl && !userPaused) autoplayTl.restart();
        // Scroll active button into view (only if button list is horizontally scrollable)
        if (buttonList.scrollWidth > buttonList.clientWidth) buttonList.scrollTo({
            left: buttonWraps[index].offsetLeft,
            behavior: "smooth"
        });
        activeIndex = index;
    };
    // ── Navigation ────────────────────────────────────────
    /** @param {number} delta @param {boolean} [focus] */ const updateIndex = (delta, focus = false)=>makeActive((activeIndex + delta + buttonItems.length) % buttonItems.length, focus);
    nextButton?.addEventListener("click", ()=>updateIndex(1));
    previousButton?.addEventListener("click", ()=>updateIndex(-1));
    // ── Per-button setup: IDs, click, keyboard, deep-link ──
    const tabIdAttr = tabWrap.getAttribute("data-tab-component-id");
    const tabId = tabIdAttr ? $1f2575536b05084f$var$slugify(tabIdAttr) : String(componentIndex + 1);
    const deepLinkId = new URLSearchParams(location.search).get("tab-id");
    buttonItems.forEach((btn, index)=>{
        const itemIdAttr = btn.getAttribute("data-tab-item-id");
        const itemId = itemIdAttr ? $1f2575536b05084f$var$slugify(itemIdAttr) : String(index + 1);
        const buttonId = `tab-button-${tabId}-${itemId}`;
        const panelId = `tab-panel-${tabId}-${itemId}`;
        btn.setAttribute("id", buttonId);
        btn.setAttribute("aria-controls", panelId);
        panelItems[index]?.setAttribute("id", panelId);
        panelItems[index]?.setAttribute("aria-labelledby", buttonId);
        // Deep linking via ?tab-id=tabId-itemId
        if (deepLinkId === `${tabId}-${itemId}`) // Defer activation until after initial makeActive(0) below
        queueMicrotask(()=>{
            makeActive(index);
            autoplay = 0; // stop autoplay on deep-link
            tabWrap.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
            const url = new URL(location.href);
            url.searchParams.delete("tab-id");
            history.replaceState({}, "", url);
        });
        btn.addEventListener("click", ()=>makeActive(index));
        btn.addEventListener("keydown", (e)=>{
            if (e.key === "ArrowRight" || e.key === "ArrowDown") {
                e.preventDefault();
                updateIndex(1, true);
            } else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
                e.preventDefault();
                updateIndex(-1, true);
            } else if (e.key === "Home") {
                e.preventDefault();
                makeActive(0, true);
            } else if (e.key === "End") {
                e.preventDefault();
                makeActive(buttonItems.length - 1, true);
            }
        });
    });
    // Activate first tab (or wait for deep-link microtask)
    makeActive(0);
    // ── Autoplay (rAF-driven; no external deps) ────────────
    if (autoplay !== 0) {
        const durationMs = autoplay * 1000;
        let rafId = 0;
        let cycleStart = 0; // performance.now() when current playing segment started
        let elapsedBeforePause = 0; // ms accumulated from prior playing segments in this cycle
        let isPlaying = false;
        /** @param {number} p */ const setProgress = (p)=>{
            tabWrap.style.setProperty("--progress", String(p));
        };
        /** @param {number} now */ const tick = (now)=>{
            if (!isPlaying) return;
            const elapsed = elapsedBeforePause + (now - cycleStart);
            if (elapsed >= durationMs) {
                setProgress(1);
                isPlaying = false;
                rafId = 0;
                elapsedBeforePause = 0;
                // Advance the tab; `makeActive` will call restart() if state allows.
                updateIndex(1, false);
                return;
            }
            setProgress(elapsed / durationMs);
            rafId = requestAnimationFrame(tick);
        };
        const startCycle = ()=>{
            if (rafId) cancelAnimationFrame(rafId);
            elapsedBeforePause = 0;
            cycleStart = performance.now();
            isPlaying = true;
            setProgress(0);
            rafId = requestAnimationFrame(tick);
        };
        const pauseCycle = ()=>{
            if (!isPlaying) return;
            isPlaying = false;
            if (rafId) {
                cancelAnimationFrame(rafId);
                rafId = 0;
            }
            elapsedBeforePause += performance.now() - cycleStart;
        };
        const resumeCycle = ()=>{
            if (isPlaying) return;
            // If the previous cycle had already completed before pause, start fresh
            if (elapsedBeforePause >= durationMs) {
                startCycle();
                return;
            }
            cycleStart = performance.now();
            isPlaying = true;
            rafId = requestAnimationFrame(tick);
        };
        autoplayTl = {
            play: resumeCycle,
            pause: pauseCycle,
            restart: startCycle
        };
        startCycle();
        let isHovered = false;
        let hasFocusInside = false;
        let prefersReducedMotion = false;
        let inView = true;
        const updateAuto = ()=>{
            if (prefersReducedMotion || !inView || userPaused || isHovered || hasFocusInside) autoplayTl?.pause();
            else autoplayTl?.play();
        };
        const setButton = ()=>{
            userPaused = !userPaused;
            toggleButton?.setAttribute("aria-pressed", !userPaused ? "true" : "false");
            toggleWrap?.classList.toggle("is-pressed", !userPaused);
            if (!userPaused) {
                isHovered = false;
                hasFocusInside = false;
                prefersReducedMotion = false;
            }
            updateAuto();
        };
        setButton();
        toggleButton?.addEventListener("click", ()=>setButton());
        /** @param {MediaQueryList | MediaQueryListEvent} e */ const handleMotionChange = (e)=>{
            prefersReducedMotion = e.matches;
            updateAuto();
            userPaused = !e.matches;
            setButton();
        };
        const motionMQ = window.matchMedia($1f2575536b05084f$var$REDUCED_MOTION_QUERY);
        handleMotionChange(motionMQ);
        motionMQ.addEventListener("change", handleMotionChange);
        if (pauseOnHover) {
            tabWrap.addEventListener("mouseenter", ()=>{
                isHovered = true;
                updateAuto();
            });
            tabWrap.addEventListener("mouseleave", ()=>{
                hasFocusInside = false;
                isHovered = false;
                updateAuto();
            });
        }
        tabWrap.addEventListener("focusin", ()=>{
            hasFocusInside = true;
            updateAuto();
        });
        tabWrap.addEventListener("focusout", (e)=>{
            const related = /** @type {Element | null} */ e.relatedTarget;
            if (!related || !tabWrap.contains(related)) {
                hasFocusInside = false;
                updateAuto();
            }
        });
        new IntersectionObserver((entries)=>{
            inView = entries[0].isIntersecting;
            updateAuto();
        }, {
            threshold: 0
        }).observe(tabWrap);
    }
    // Expose for external access
    /** @type {any} */ tabWrap._tab = {
        makeActive: makeActive,
        updateIndex: updateIndex,
        get activeIndex () {
            return activeIndex;
        }
    };
}
function $1f2575536b05084f$export$c92e8f569ad2976f() {
    document.querySelectorAll(".tab_wrap").forEach((el, i)=>{
        $1f2575536b05084f$var$initComponent(/** @type {HTMLElement} */ el, i);
    });
}
function $1f2575536b05084f$export$7af7b2410c9bae8b(element) {
    if (element && element.classList.contains("tab_wrap")) // Use 0 as index — only matters as fallback when data-tab-component-id is absent
    $1f2575536b05084f$var$initComponent(element, 0);
}
// ── Auto-boot ────────────────────────────────────────────────
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $1f2575536b05084f$export$c92e8f569ad2976f, {
    once: true
});
else $1f2575536b05084f$export$c92e8f569ad2976f();


/**
 * Membership Pricing
 *
 * Fetches campaign-specific discount pricing on the client and writes it into
 * pricing cards. Each card carries a config element (the inner div of
 * .card_plan_data) with its city, campaign, tier, and formatting attributes;
 * the price text lives in [data-price-slot] elements elsewhere inside the same
 * .card_plan_wrap. Cards sharing the same city+campaign reuse a single deduped
 * request. When the codes are absent or the request fails, the Webflow-rendered
 * defaults are left untouched.
 *
 * Pure formatting + response-shaping logic lives in membership-pricing-format.js
 * (same DOM-shell ↔ pure-logic split as city-context.js ↔ city-resolve.js).
 *
 * Markup contract:
 *   .card_plan_wrap                                  — card root (CARD_ROOT_SELECTOR)
 *     …[data-price-slot="committed.price"]           — price text, filled by "{variant}.{field}"
 *     .card_plan_data > [data-pricing-tier]          — config element:
 *       data-pricing-city="CPH"        — required; lowercased into the request
 *       data-pricing-campaign="VENTURE26" — required; no fetch when empty
 *       data-pricing-tier="BLACK"      — required; selects tier_code from response
 *       data-pricing-locale="en"       — optional, default "sv-SE"
 *       data-pricing-fraction-digits="0" — optional, default 0
 *       data-pricing-endpoint="https://…" — optional endpoint override
 *
 * When a card's variant has a discount, `is-discounted` is toggled on the card
 * root so the (static) .card_plan_price_original strike-through price is revealed.
 */ /**
 * Membership Pricing Format — pure helpers for membership-pricing.js
 *
 * Framework-free (no DOM, no imports) so the formatting + response-shaping logic
 * is unit-testable in Node. The DOM/fetch/boot shell lives in
 * membership-pricing.js. (Same split as city-resolve.js ↔ city-context.js.)
 */ /**
 * Format an integer price in minor units (öre) for display: divide by 100 and
 * group per locale. Number only — no currency symbol (Webflow markup supplies
 * the unit text).
 *
 * @param {number} minorUnits
 * @param {{locale?: string, fractionDigits?: number}} [opts]
 * @returns {string}
 */ function $709bc3c1556a8121$export$c86caf1be068fb8d(minorUnits, { locale: locale = "sv-SE", fractionDigits: fractionDigits = 0 } = {}) {
    const digits = Number.isFinite(fractionDigits) ? fractionDigits : 0;
    return (minorUnits / 100).toLocaleString(locale, {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits
    });
}
function $709bc3c1556a8121$export$fd66987bb8df262(payload, tierCode) {
    return payload?.tiers?.find((t)=>t.tier_code === tierCode) ?? null;
}
function $709bc3c1556a8121$export$ac0fbb2a2d8bb0ec(tier, opts = {}) {
    /** @type {Record<string,string>} */ const slots = {};
    const prices = tier?.prices;
    if (!prices) return slots;
    for (const variant of Object.keys(prices)){
        const p = prices[variant];
        if (!p) continue;
        if (typeof p.price === "number") slots[`${variant}.price`] = $709bc3c1556a8121$export$c86caf1be068fb8d(p.price, opts);
        if (typeof p.list_price === "number") slots[`${variant}.list_price`] = $709bc3c1556a8121$export$c86caf1be068fb8d(p.list_price, opts);
        if (p.discount != null && typeof p.discount.amount === "number") slots[`${variant}.discount`] = $709bc3c1556a8121$export$c86caf1be068fb8d(p.discount.amount, opts);
    }
    return slots;
}


const $374ed7583c53b901$var$DEFAULT_ENDPOINT = "https://api.bruce.app/partner/membership/info";
const $374ed7583c53b901$var$SAFETY_PASS_DELAYS = [
    500,
    1500,
    3500
];
const $374ed7583c53b901$var$CARD_ROOT_SELECTOR = ".card_plan_wrap";
const $374ed7583c53b901$var$DISCOUNTED_CLASS = "is-discounted";
/** @type {WeakSet<Element>} config elements already applied (or in-flight) */ const $374ed7583c53b901$var$applied = new WeakSet();
/** @type {Map<string, Promise<any>>} deduped fetches keyed "endpoint|city|campaign" */ const $374ed7583c53b901$var$fetchCache = new Map();
function $374ed7583c53b901$var$endpointFor(config) {
    return config.getAttribute("data-pricing-endpoint")?.trim() || /** @type {any} */ window.bruce?.pricingEndpoint || $374ed7583c53b901$var$DEFAULT_ENDPOINT;
}
// The price slots live outside the config element, elsewhere inside the card.
// Prefer the known wrapper; fall back to the nearest ancestor that holds slots.
function $374ed7583c53b901$var$cardRootFor(config) {
    const known = config.closest($374ed7583c53b901$var$CARD_ROOT_SELECTOR);
    if (known) return known;
    let el = config.parentElement;
    while(el){
        if (el.querySelector("[data-price-slot]")) return el;
        el = el.parentElement;
    }
    return null;
}
function $374ed7583c53b901$var$fetchPricing(endpoint, city, campaign) {
    const key = `${endpoint}|${city}|${campaign}`;
    let promise = $374ed7583c53b901$var$fetchCache.get(key);
    if (!promise) {
        const url = new URL(endpoint);
        url.searchParams.set("city_code", city);
        url.searchParams.set("campaign_code", campaign);
        promise = fetch(url.toString()).then((res)=>{
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            return res.json();
        }).catch((err)=>{
            $374ed7583c53b901$var$fetchCache.delete(key); // evict so a later safety pass can retry
            throw err;
        });
        $374ed7583c53b901$var$fetchCache.set(key, promise);
    }
    return promise;
}
function $374ed7583c53b901$var$applyCard(config, payload) {
    const tierCode = config.getAttribute("data-pricing-tier")?.trim();
    const tier = (0, $709bc3c1556a8121$export$fd66987bb8df262)(payload, tierCode);
    if (!tier) {
        console.warn(`[bruce.pricing] tier "${tierCode}" not in response`);
        return;
    }
    const root = $374ed7583c53b901$var$cardRootFor(config);
    if (!root) {
        console.warn(`[bruce.pricing] no card root for tier "${tierCode}"`);
        return;
    }
    const locale = config.getAttribute("data-pricing-locale")?.trim() || "sv-SE";
    const fdAttr = config.getAttribute("data-pricing-fraction-digits");
    const fractionDigits = fdAttr != null && fdAttr.trim() !== "" ? Number(fdAttr) : 0;
    const slots = (0, $709bc3c1556a8121$export$ac0fbb2a2d8bb0ec)(tier, {
        locale: locale,
        fractionDigits: fractionDigits
    });
    // Fill each price slot; flag the card as discounted if any variant it renders
    // carries a discount (reveals the strike-through original price via CSS).
    let discounted = false;
    root.querySelectorAll("[data-price-slot]").forEach((el)=>{
        const slotKey = el.getAttribute("data-price-slot")?.trim();
        if (!slotKey) return;
        if (slotKey in slots) el.textContent = slots[slotKey];
        const variant = slotKey.split(".")[0];
        if (tier.prices?.[variant]?.discount != null) discounted = true;
    });
    root.classList.toggle($374ed7583c53b901$var$DISCOUNTED_CLASS, discounted);
}
function $374ed7583c53b901$var$processCard(config) {
    if ($374ed7583c53b901$var$applied.has(config)) return;
    // Lowercase city once at read time so the dedup key and the request param are
    // always derived from the same normalized value (CPH and cph share one fetch).
    const city = config.getAttribute("data-pricing-city")?.trim().toLowerCase();
    const campaign = config.getAttribute("data-pricing-campaign")?.trim();
    if (!city || !campaign) return; // gate: only fetch when both are populated
    $374ed7583c53b901$var$applied.add(config); // claim before async so safety passes don't double-fetch
    $374ed7583c53b901$var$fetchPricing($374ed7583c53b901$var$endpointFor(config), city, campaign).then((payload)=>$374ed7583c53b901$var$applyCard(config, payload)).catch((err)=>{
        $374ed7583c53b901$var$applied.delete(config); // released for retry by a later safety pass (no-op after the last)
        console.warn("[bruce.pricing] fetch failed", err);
    });
}
function $374ed7583c53b901$var$run() {
    document.querySelectorAll("[data-pricing-tier][data-pricing-city]").forEach((el)=>$374ed7583c53b901$var$processCard(el));
}
// ── Boot ─────────────────────────────────────────────────────
const $374ed7583c53b901$var$boot = ()=>{
    $374ed7583c53b901$var$run();
    // Safety passes re-scan for late-rendered CMS cards; applied cards are no-ops.
    $374ed7583c53b901$var$SAFETY_PASS_DELAYS.forEach((ms)=>setTimeout($374ed7583c53b901$var$run, ms));
};
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $374ed7583c53b901$var$boot, {
    once: true
});
else $374ed7583c53b901$var$boot();


/**
 * Price Format
 *
 * Formats a plain number authored in Webflow into a locale-grouped string, in
 * place. Drop `data-price-format` on any element holding a raw number and it is
 * rewritten on the client (129000 → "129 000"). Number only — no currency
 * symbol; the Webflow markup supplies the unit text (same convention as
 * formatPrice in membership-pricing-format.js).
 *
 * Distinct from membership-pricing.js, which fetches campaign pricing from the
 * Bruce API and works in minor units (öre). This module only formats numbers
 * already present in the DOM.
 *
 * Markup contract:
 *   <span data-price-format>129000</span>                            → 129 000
 *   <span data-price-format>129.95</span>                            → 129,95
 *   <span data-price-format data-price-locale="en-US">129000</span>  → 129,000
 *   <span data-price-format data-price-decimals="2">129000</span>    → 129 000,00
 *
 *   - data-price-format    — marks the element (required)
 *   - data-price-locale    — optional, default "sv-SE"
 *   - data-price-decimals  — optional; when omitted, preserve the decimals present
 *                            in the raw value (129.95 → 2, 129000 → 0)
 *
 * The authored raw value is a plain number using "." as the decimal separator and
 * no grouping; surrounding whitespace is tolerated.
 */ const $200864dd62e293a8$var$SAFETY_PASS_DELAYS = [
    500,
    1500,
    3500
];
/** @type {WeakSet<Element>} elements already formatted (or non-numeric, skipped) */ const $200864dd62e293a8$var$applied = new WeakSet();
function $200864dd62e293a8$export$d3fe679f650a9062(raw, { locale: locale = "sv-SE", decimals: decimals = null } = {}) {
    const trimmed = (raw ?? "").trim();
    if (trimmed === "") return null;
    const value = Number(trimmed);
    if (!Number.isFinite(value)) return null;
    // Explicit decimals win; otherwise preserve whatever the raw value carries.
    const rawDecimals = trimmed.split(".")[1]?.length ?? 0;
    const digits = Number.isFinite(decimals) && decimals >= 0 ? decimals : rawDecimals;
    return value.toLocaleString(locale, {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits
    });
}
function $200864dd62e293a8$var$applyElement(el) {
    if ($200864dd62e293a8$var$applied.has(el)) return;
    $200864dd62e293a8$var$applied.add(el); // claim once: skip on every later pass, formatted or not
    const locale = el.getAttribute("data-price-locale")?.trim() || "sv-SE";
    const decAttr = el.getAttribute("data-price-decimals");
    const decimals = decAttr != null && decAttr.trim() !== "" ? Number(decAttr) : null;
    const formatted = $200864dd62e293a8$export$d3fe679f650a9062(el.textContent, {
        locale: locale,
        decimals: decimals
    });
    if (formatted != null) el.textContent = formatted;
}
function $200864dd62e293a8$var$run() {
    document.querySelectorAll("[data-price-format]").forEach((el)=>$200864dd62e293a8$var$applyElement(el));
}
// ── Boot ─────────────────────────────────────────────────────
const $200864dd62e293a8$var$boot = ()=>{
    $200864dd62e293a8$var$run();
    // Safety passes re-scan for late-rendered CMS items; applied elements are no-ops.
    $200864dd62e293a8$var$SAFETY_PASS_DELAYS.forEach((ms)=>setTimeout($200864dd62e293a8$var$run, ms));
};
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $200864dd62e293a8$var$boot, {
    once: true
});
else $200864dd62e293a8$var$boot();


/**
 * Visual Video Component
 *
 * Plyr-based video player with:
 * - Lazy-loading (IntersectionObserver + Swiper-aware deferral)
 * - Aspect-ratio-aware cover sizing across all Lumos variants
 * - State broadcasting to opt-in parent scopes via [data-video="component"]
 * - Source-aspect override for vertical content (Shorts, Reels)
 *
 * Usage in Webflow:
 *   <div class="video_wrap"
 *        data-src="https://youtu.be/..."
 *        data-source-aspect="16/9"   (optional, defaults to 16:9)
 *        data-autoplay                (optional)
 *        data-muted                   (optional, implied by autoplay)
 *        data-loop                    (optional)
 *        data-controls="none|minimal|full"  (default: full)
 *        data-captions="https://.../captions.vtt"  (optional)
 *   >
 *     <div class="video_player"></div>
 *     <div class="video_poster">
 *       <img class="video_poster_image" src="..." />
 *     </div>
 *   </div>
 *
 * Optional parent scope (e.g. on a testimonial card):
 *   <div data-video="component"> ... </div>
 *
 * The scope receives data-video-state="idle|playing|paused|ended"
 * and can style its children accordingly.
 */ // ── Module-level constants ───────────────────────────────────
const $42b1e4ed05c9e2af$var$DEFAULT_ASPECT = 16 / 9;
const $42b1e4ed05c9e2af$var$LAZY_ROOT_MARGIN = "200px";
const $42b1e4ed05c9e2af$var$SWIPER_ACTIVE_CLASSES = [
    "swiper-slide-active",
    "swiper-slide-visible",
    "swiper-slide-next",
    "swiper-slide-prev"
];
const $42b1e4ed05c9e2af$var$CONTROLS_MAP = {
    full: [
        "play",
        "progress",
        "current-time",
        "mute",
        "volume",
        "captions",
        "settings",
        "pip",
        "airplay",
        "fullscreen"
    ],
    minimal: [
        "play",
        "progress",
        "mute",
        "fullscreen"
    ],
    none: []
};
// Pre-compiled regexes
const $42b1e4ed05c9e2af$var$RE_YOUTUBE = /youtube\.com|youtu\.be/;
const $42b1e4ed05c9e2af$var$RE_VIMEO = /vimeo\.com/;
const $42b1e4ed05c9e2af$var$RE_YT_ID = /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|shorts\/))([^?&#]+)/;
const $42b1e4ed05c9e2af$var$RE_VIMEO_ID = /vimeo\.com\/(?:video\/)?(\d+)/;
// ── Types ────────────────────────────────────────────────────
/** @typedef {'youtube' | 'vimeo' | 'html5'} Provider */ /** @typedef {'idle' | 'playing' | 'paused' | 'ended'} VideoState */ // ── Helpers ──────────────────────────────────────────────────
/**
 * @param {string} url
 * @returns {Provider}
 */ function $42b1e4ed05c9e2af$var$detectProvider(url) {
    if ($42b1e4ed05c9e2af$var$RE_YOUTUBE.test(url)) return "youtube";
    if ($42b1e4ed05c9e2af$var$RE_VIMEO.test(url)) return "vimeo";
    return "html5";
}
/**
 * @param {string} url
 * @param {Provider} prov
 * @returns {string}
 */ function $42b1e4ed05c9e2af$var$extractEmbedId(url, prov) {
    if (prov === "youtube") return (url.match($42b1e4ed05c9e2af$var$RE_YT_ID) || [])[1] || "";
    if (prov === "vimeo") return (url.match($42b1e4ed05c9e2af$var$RE_VIMEO_ID) || [])[1] || "";
    return url;
}
/**
 * Parses a "W/H" aspect string into a number.
 * @param {string | null} str
 * @param {number} fallback
 * @returns {number}
 */ function $42b1e4ed05c9e2af$var$parseAspect(str, fallback) {
    if (!str || !str.includes("/")) return fallback;
    const parts = str.split("/");
    const w = parseFloat(parts[0]);
    const h = parseFloat(parts[1]);
    return w > 0 && h > 0 ? w / h : fallback;
}
/**
 * @param {string} src
 * @returns {string}
 */ function $42b1e4ed05c9e2af$var$getMimeType(src) {
    const ext = src.split(".").pop().split("?")[0].toLowerCase();
    if (ext === "webm") return "video/webm";
    if (ext === "ogg") return "video/ogg";
    return "video/mp4";
}
/**
 * @param {HTMLElement} slide
 * @returns {boolean}
 */ function $42b1e4ed05c9e2af$var$isSwiperSlideActive(slide) {
    for (const cls of $42b1e4ed05c9e2af$var$SWIPER_ACTIVE_CLASSES){
        if (slide.classList.contains(cls)) return true;
    }
    return false;
}
// ── Init a single component ──────────────────────────────────
/**
 * @param {HTMLElement} component
 */ function $42b1e4ed05c9e2af$var$initComponent(component) {
    if (component.dataset.scriptInitialized) return;
    component.dataset.scriptInitialized = "true";
    const playerWrapper = component.querySelector(".video_player");
    if (!playerWrapper) {
        console.warn("Visual Video: .video_player element missing");
        return;
    }
    const posterEl = component.querySelector(".video_poster");
    const scope = component.closest("[data-video='component']");
    const swiperSlide = component.closest(".swiper-slide");
    // ── Props ──────────────────────────────────────────────
    const src = component.getAttribute("data-src") || "";
    if (!src) return;
    const captions = component.getAttribute("data-captions") || "";
    const autoplay = component.hasAttribute("data-autoplay");
    const muted = component.hasAttribute("data-muted") || autoplay;
    const loop = component.hasAttribute("data-loop");
    const controlsValue = component.getAttribute("data-controls") || "full";
    const controlsList = $42b1e4ed05c9e2af$var$CONTROLS_MAP[controlsValue] || $42b1e4ed05c9e2af$var$CONTROLS_MAP.full;
    const provider = $42b1e4ed05c9e2af$var$detectProvider(src);
    const embedId = $42b1e4ed05c9e2af$var$extractEmbedId(src, provider);
    let videoAspect = $42b1e4ed05c9e2af$var$parseAspect(component.getAttribute("data-source-aspect"), $42b1e4ed05c9e2af$var$DEFAULT_ASPECT);
    // ── State broadcaster ──────────────────────────────────
    /** @type {VideoState | null} */ let currentState = null;
    /** @param {VideoState} state */ const setVideoState = (state)=>{
        if (state === currentState) return; // skip redundant DOM writes
        currentState = state;
        component.setAttribute("data-video-state", state);
        if (scope) scope.setAttribute("data-video-state", state);
    };
    setVideoState(autoplay ? "playing" : "idle");
    // ── Deferred init: choose strategy based on context ────
    // Strategy A: Inside a Swiper slide → init only when slide
    //   becomes active/visible.
    // Strategy B: Standalone → IntersectionObserver with 200px
    //   margin. Init before the user reaches the video.
    let initialized = false;
    const initOnce = ()=>{
        if (initialized) return;
        initialized = true;
        initPlayer();
    };
    if (swiperSlide) {
        if ($42b1e4ed05c9e2af$var$isSwiperSlideActive(swiperSlide)) initOnce();
        else {
            const slideObserver = new MutationObserver(()=>{
                if ($42b1e4ed05c9e2af$var$isSwiperSlideActive(swiperSlide)) {
                    initOnce();
                    slideObserver.disconnect();
                }
            });
            slideObserver.observe(swiperSlide, {
                attributes: true,
                attributeFilter: [
                    "class"
                ]
            });
        }
    } else {
        const ioObserver = new IntersectionObserver((entries)=>{
            for (const entry of entries)if (entry.isIntersecting) {
                initOnce();
                ioObserver.disconnect();
                break;
            }
        }, {
            rootMargin: $42b1e4ed05c9e2af$var$LAZY_ROOT_MARGIN
        });
        ioObserver.observe(component);
    }
    // ── Initialize Plyr ────────────────────────────────────
    function initPlayer() {
        /** @type {HTMLElement} */ let targetEl;
        if (provider === "youtube" || provider === "vimeo") {
            targetEl = document.createElement("div");
            targetEl.dataset.plyrProvider = provider;
            targetEl.dataset.plyrEmbedId = embedId;
        } else {
            targetEl = document.createElement("video");
            targetEl.setAttribute("playsinline", "");
            if (controlsList.length) targetEl.setAttribute("controls", "");
            const sourceEl = document.createElement("source");
            sourceEl.src = src;
            sourceEl.type = $42b1e4ed05c9e2af$var$getMimeType(src);
            targetEl.appendChild(sourceEl);
            if (captions) {
                const track = document.createElement("track");
                track.kind = "captions";
                track.src = captions;
                track.srclang = "en";
                track.label = "English";
                track.default = true;
                targetEl.appendChild(track);
            }
        }
        playerWrapper.insertBefore(targetEl, playerWrapper.firstChild);
        const player = new Plyr(targetEl, {
            controls: controlsList,
            autoplay: autoplay,
            muted: muted,
            loop: {
                active: loop
            },
            playsinline: true,
            // ratio omitted — wrap dictates aspect, JS handles cover
            youtube: {
                noCookie: true,
                rel: 0,
                showinfo: 0,
                iv_load_policy: 3,
                modestbranding: 1,
                controls: 0,
                disablekb: 1,
                playsinline: 1,
                fs: 0,
                cc_load_policy: 0,
                hl: "en",
                enablejsapi: 1
            },
            vimeo: {
                byline: false,
                portrait: false,
                title: false,
                transparent: false,
                dnt: true
            }
        });
        // ── Cover sizing ─────────────────────────────────────
        /** @type {HTMLElement | null} */ let mediaEl = null;
        let lastW = 0;
        let lastH = 0;
        let rafId = 0;
        const findMediaEl = ()=>{
            mediaEl = playerWrapper.querySelector("iframe, video");
            return mediaEl;
        };
        const computeAndApply = ()=>{
            rafId = 0;
            if (!mediaEl && !findMediaEl()) return;
            const rect = component.getBoundingClientRect();
            const wW = rect.width;
            const wH = rect.height;
            if (!wW || !wH) return;
            // Skip if dimensions unchanged
            if (wW === lastW && wH === lastH) return;
            lastW = wW;
            lastH = wH;
            const wrapAspect = wW / wH;
            let tW;
            let tH;
            if (wrapAspect > videoAspect) {
                tW = wW;
                tH = wW / videoAspect;
            } else {
                tH = wH;
                tW = wH * videoAspect;
            }
            // Single style write (one reflow)
            mediaEl.style.cssText += `position:absolute;top:50%;left:50%;` + `width:${tW}px;height:${tH}px;` + `max-width:none;transform:translate(-50%,-50%);`;
        };
        // rAF-batched scheduler
        const scheduleApply = ()=>{
            if (rafId) return;
            rafId = requestAnimationFrame(computeAndApply);
        };
        const forceApply = ()=>{
            lastW = 0;
            lastH = 0;
            scheduleApply();
        };
        forceApply(); // also try synchronously, before Plyr signals ready
        player.on("ready", async ()=>{
            findMediaEl();
            forceApply();
            if (!autoplay) setVideoState("idle");
            // Vimeo: ask the embed for real source dimensions so cover-sizing
            // uses the actual aspect, not the declared one.
            if (provider === "vimeo") try {
                const embed = /** @type {any} */ player.embed;
                if (embed && embed.getVideoWidth && embed.getVideoHeight) {
                    const [w, h] = await Promise.all([
                        embed.getVideoWidth(),
                        embed.getVideoHeight()
                    ]);
                    if (w > 0 && h > 0) {
                        videoAspect = w / h;
                        forceApply();
                    }
                }
            } catch (_) {
            /* silent */ }
        });
        // HTML5: auto-detect true source aspect via loadedmetadata
        if (provider === "html5") {
            const v = /** @type {HTMLVideoElement | null} */ playerWrapper.querySelector("video");
            if (v) v.addEventListener("loadedmetadata", ()=>{
                if (v.videoWidth && v.videoHeight) {
                    videoAspect = v.videoWidth / v.videoHeight;
                    forceApply();
                }
            }, {
                once: true
            });
        }
        // ResizeObserver — re-fits on any wrap size change
        const ro = new ResizeObserver(scheduleApply);
        ro.observe(component);
        player.on("playing", ()=>setVideoState("playing"));
        player.on("pause", ()=>setVideoState("paused"));
        player.on("ended", ()=>{
            setVideoState("ended");
            if (posterEl) posterEl.classList.remove("is-active");
        });
        // ── Poster ───────────────────────────────────────────
        if (posterEl) {
            posterEl.addEventListener("click", ()=>player.play(), {
                passive: true
            });
            player.on("playing", ()=>posterEl.classList.add("is-active"));
            if (autoplay) posterEl.classList.add("is-active");
        }
        // ── Cleanup ──────────────────────────────────────────
        player.on("destroy", ()=>{
            ro.disconnect();
            if (rafId) cancelAnimationFrame(rafId);
        });
        // Expose Plyr instance for external access
        /** @type {any} */ component._plyr = player;
    }
}
function $42b1e4ed05c9e2af$export$a9cf4c44b9bfbcdf() {
    document.querySelectorAll(".video_wrap").forEach((el)=>{
        $42b1e4ed05c9e2af$var$initComponent(/** @type {HTMLElement} */ el);
    });
}
function $42b1e4ed05c9e2af$export$922558c9cda76335(element) {
    if (element && element.classList.contains("video_wrap")) $42b1e4ed05c9e2af$var$initComponent(element);
}
// ── Auto-boot ────────────────────────────────────────────────
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $42b1e4ed05c9e2af$export$a9cf4c44b9bfbcdf, {
    once: true
});
else $42b1e4ed05c9e2af$export$a9cf4c44b9bfbcdf();



})();
//# sourceMappingURL=index.js.map
